export default {
    "en": {
        "hero": {
            "search-offers": {
                "title": "JOB OFFERS",
                "filters": {
                    "keyword": {
                        "label": "Find offers of...",
                        "placeholder": "Position, company or keyword"
                    },
                    "province": {
                        "label": "in..."
                    }
                },
                "search": "SEARCH",
                "view-offers": {
                    "pretext": "or ",
                    "link": "view all offers"
                }
            }
        },
        "modals": {
            "delete": {
                "confirm": "Are you sure you want to delete?",
                "success": "Deleted successfully"
            },
            "archive": {
                "confirm": "Are you sure you want to archive?",
                "success": "Archived successfully"
            },
            "deactivate": {
                "confirm": "Are you sure you want to deactivate?",
                "success": "Deactivated successfully!",
                "form": {
                    "confirm-password": "Confirm your password to deactivate your account",
                    "confirm-password.validation": "The password must contain at least 6 characters",
                    "confirm-password.placeholder": "Enter your password"
                }
            },
            "reactivate": {
                "confirm": "Are you sure you want to reactivate?",
                "success": "Reactivated succesfully!"
            },
            "delegate-user": {
                "confirm": "Are you sure you want to delegate selected offer to this user?",
                "success": "Delegated an offer for the user successfully!"
            },
            "irrecoverable-action": "You cannot undo this later!",
            "copy-offer": {
                "title": "Warning!"
            }
        },
        "main": {
            "you-are-in": "You are in {place}",
            "routes": {
                "hr-delegations": "Delegations",
                "hr-delegate-user": "Delegate a user",
                "hr-delegate-offer": "Delegate an offer",
                "one-offer": "Offer",
                "one-company": "Company",
                "my-offers": "My offers",
                "offer-payment": "Offer payment",
                "publish-offer": "Publish offer",
                "edit-offer": "Edit offer",
                "copy-offer": "Copy offer",
                "multiprovince-offer": "Multiprovince offer",
                "my-candidates": "My candidates",
                "offer-candidates": "Candidates",
                "one-candidate": "Candidate",
                "offer-interns": "Interns candidates",
                "all-offers": "All ofers",
                "all-companies": "Companies",
                "all-users": "Users",
                "one-user": "User",
                "all-payments": "Payments",
                "all-promos": "Promo codes",
                "all-referrals": "Referrals",
                "one-referral": "Referral",
                "all-hrs": "Manage headhunters",
                "manage-hr": "Manage headhunter",
                "add-hr": "Add headhunter",
                "roles": "Roles",
                "permissions": "Permissions",
                "dashboard": "Dashboard",
                "profile": "Profile",
                "my-account": "My account",
                "apply-offer": "Apply to offer",
                "applied-offers": "Applications",
                "my-cv": "My CV",
                "killer-questions-templates": {
                    "main": "Killer Questions Templates",
                    "add-question": "Add Killer Question",
                    "add-folder": "Add Killer Questions Folder",
                    "manage-question": "Manage Killer Question",
                    "manage-folder": "Manage Killer Question Folder"
                },
                "external-candidate": "External Candidate"
            },
            "navbar": {
                "login-as-company": "Company Access",
                "login-as-candidate": "Candidate Access"
            },
            "footer": {
                "help": "Help",
                "contact-us-via-email": "Contact us by e-mail",
                "contact-us-via-email.caption": "The selection process is only through the employment portal. We do not attend requests in this way. Thank you.",
                "contact-us": "Contact us",
                "working-hours-line-1": "Monday to Thursday from {from} to {to} Hours",
                "working-hours-line-2": "Friday from {from} to {to} Hours"
            },
            "footer2": {
                "about-us": {
                    "title": "About us",
                    "general-conditions": "Legal conditions",
                    "privacy-policy": "Privacy Policy",
                    "help": "Help",
                    "cookies-policy": "Cookies policy"
                },
                "on": {
                    "title": "About {portal}",
                    "work-with-us": "Work with us"
                },
                "vip-services": {
                    "title": "Companies VIP services",
                    "recruitment": "Successful recruitment and selection"
                },
                "job-offers": {
                    "title": "Job Offers",
                    "employment-counseling": "Job orientation",
                    "executive-education": "Executive education",
                    "employment-training": "Training for employment",
                    "trusted-professional": "Trusted professional"
                },
                "group-company": "Is a company of group",
                "our-brands": "Our brands"
            }
        },
        "inputs": {
            "email": {
                "title": "Email",
                "title-full": "Email address",
                "validation": "Invalid email address",
                "placeholder": "Email address..."
            },
            "password": {
                "title": "Password",
                "validation": "Password must be at least 6 characters long",
                "placeholder": "Password..."
            },
            "password-confirm": {
                "title": "Confirm password",
                "validation": "Passwords does not match",
                "placeholder": "Repeat password..."
            },
            "first-name": {
                "title": "First name",
                "validation": "Field required"
            },
            "last-name": {
                "title": "Last name",
                "validation": "Field required"
            },
            "place": {
                "title": "Enter your place",
                "city": {
                    "title": "City"
                }
            },
            "phone": {
                "title": "Enter your phone",
                "title-full": "Phone number",
                "validation": "Field required"
            },
            "comment": {
                "title": "Comment",
                "placeholder": "Enter something..."
            },
            "company-title": {
                "title": "Enter your company*",
                "validation": "Field required"
            },
            "company-phone": {
                "title": "Mobile phone*",
                "validation": "Field required (Verification by sms or call)"
            },
            "company-cif": {
                "title": "Tax ID (C.I.F or N.I.F)*",
                "validation": "Must be valid C.I.F or N.I.F"
            },
            "company-description": {
                "title": "Company description",
                "placeholder": "Describe your company how you want it to appear for candidates. Tip: Use the description of your corporate website."
            },
            "keyword": {
                "title": "Keyword",
                "placeholder": "Keyword"
            },
            "option": {
                "placeholder": "Select option"
            }
        },
        "backend": {
            "responses": {
                "auth": {
                    "incorrect-credentials": "Incorrect credentials",
                    "account-disabled": "Account disabled!",
                    "account-unverified": "Account not verified! Please check your email and follow the instructions",
                    "logout-success": "Successfully logged out",
                    "email-verify-success": "You have successfully verified your email address.",
                    "email-already-verified": "Account already verified!",
                    "email-code-invalid": "Verification code is invalid.",
                    "user-by-email-not-found": "User with provided email not found!"
                },
                "company": {
                    "invalid-cif": "Invalid CIF or NIF",
                    "no-company": "Could not find company!",
                    "only-your-company": "Can only edit own company"
                },
                "file-upload": {
                    "invalid-category": "Invalid file category"
                },
                "offer": {
                    "any-offers": "Could not find any offers!",
                    "no-offer": "Could not find offer!",
                    "no-offers": "Could not find offers!",
                    "killer-questions": {
                        "already-exist": "Killer questions already exist for this offer!",
                        "cant-save-question": "Cannot save killer question!"
                    },
                    "promo": {
                        "not-found": "Promo not found!",
                        "limit-reached": "Promo provinces limit reached!"
                    }
                },
                "user": {
                    "user-no-exist": "User does not exist",
                    "not-found": "Could not find user!",
                    "deleted": "User deleted!",
                    "cant-delete": "Could not delete user",
                    "new-psw-no-match": "New passwords doesnt match",
                    "psw-no-match": "New passwords doesnt match",
                    "psw-change-success": "Password changed successfully"
                },
                "payments": {
                    "not-proccessed": "Payment could not be processed"
                },
                "referral": {
                    "cant-create": "Could not create a referral",
                    "incorrect-id": "Incorrect referral id",
                    "not-found": "Referral not found"
                },
                "roles-and-permissions": {
                    "role-not-found": "Could not find role!"
                },
                "user-cv": {
                    "not-found": "Could not find user cv!"
                },
                "locale": {
                    "own-saved": "Your locale settings has been updated!",
                    "target-saved": "User locale settings has been updated!"
                },
                "common-errors": {
                    "unauthorized": "Unauthorized!",
                    "no-permissions": "You do not have permissions for this",
                    "bad-request": "Bad request"
                }
            },
            "emails": {
                "generic": {
                    "hello": "Hello!",
                    "hello-name": "Hello {name} ,",
                    "click-to-see-more": "Click here to see more",
                    "click-to-see": "Click here to see",
                    "contact-us-doubt": "Contact us in case of any doubt.",
                    "team-of": "Team of {appName} .",
                    "footer-msg": "You receive this message because we have received a request to change the password in {appName} specifying your email address. In case it was not you, you can delete this message."
                },
                "footer": {
                    "made-with": "Made with",
                    "by": "By",
                    "dont-receive": "Don't you want to receive these letters anymore?",
                    "unsubscribe": "Unsubscribe",
                    "auto-msg": "This message has been sent by an automatic system.",
                    "dont-reply": "Please do not reply to this email directly."
                },
                "new-company": {
                    "subject": "A new company registered on the portal",
                    "title": "A new company registered on the portal: {companyName}",
                    "company-name": "Company name {title}",
                    "company-cif": "CIF/NIF: {cif}",
                    "company-phone": "Phone: {phone}"
                },
                "candidatura-change": {
                    "subject": "Your application status has changed",
                    "accepted": "Your application status in the offer\" {offerTitle} \" has changed. You have been accepted.",
                    "rejected": "We regret to inform you that your application in the offer \" {offerTitle} \" has been rejected."
                },
                "offers-report": {
                    "subject": "New offers since yesterday in {appName}",
                    "you-have": "You have",
                    "offers-yesterday": "new offers since yesterday",
                    "offers-below": "Below you can find some new offers since yesterday.",
                    "no-company-name": "Company name not available",
                    "contract": "Contract: {contract}",
                    "workday": "Workday: {workday}"
                },
                "applications-realtime": {
                    "subject": "Somebody has applied to your offer!",
                    "user-applied": "{userName} has applied to this offer!",
                    "view-all": "VIEW ALL APPLICATIONS"
                },
                "applications-report": {
                    "subject": "Applications to your offers since yesterday",
                    "title": "Applications to your company offers since yesterday:"
                },
                "company-status-realtime": {
                    "subject": "The status of your company has changed",
                    "accepted": "Congratulations! Your company status ( {companyTitle} ) has changed to active.",
                    "publish-now": "Now you can post offers on the portal.",
                    "rejected": "We regret to inform you that your company registration ( {companyTitle} ) has been rejected.",
                    "free-offer": "Click here to post your first offer FREE!"
                },
                "contacts": {
                    "subject": "Someone submitted a support inquiry from {appName}",
                    "title": "Someone submitted a support inquiry from {appName}",
                    "name": "Name",
                    "type": "Type",
                    "topic": "Topic",
                    "content": "Content",
                    "reply-user": "You can reply to this message to answer the user ( {email} )"
                },
                "reset-password-success": {
                    "subject": "Password of your {appName} account has been changed",
                    "change-success": "Your password has been changed successfully.",
                    "contact-support": "If it was not you, contact support immediately."
                },
                "reset-password": {
                    "subject": "Password change request",
                    "title": "Forgot your password?",
                    "reset-psw-msg": "We received a request to change your account password from {appName} . You can do it by clicking the button below:",
                    "reset-psw": "RESET YOUR PASSWORD",
                    "copy-link-msg": "You can also copy the following link and paste it into your web browser to access the activation:"
                },
                "verification": {
                    "subject": "Confirm your registration in {appName}",
                    "title": "Thank you very much for registering in {appName} .",
                    "neccessary-confirm": "You need to confirm your registration:",
                    "activate-now": "ACTIVATE {appName} NOW",
                    "copy-link-msg": "You can also copy the following link and paste it into your web browser to access the activation:"
                },
                "workwithus": {
                    "subject": "Someone sent a work with us query from {appName}",
                    "title": "Someone sent a work with us query from {appName}",
                    "reply-user": "You can reply to this message to reply to the user ( {email} )"
                },
                "recruitment": {
                    "subject": "Someone submitted a successful recruitment and selection inquiry from {appName}",
                    "title": "Someone submitted a successful recruitment and selection inquiry from {appName}",
                    "reply-user": "You can reply to this message to reply to the user ( {email} )"
                }
            }
        },
        "cards": {
            "offer-candidate": {
                "last-status-change": "Last status change"
            },
            "offer-employer": {
                "no-company-name": "Company name not available",
                "status": {
                    "archived": "Archived",
                    "draft": "Draft",
                    "open": "Active"
                },
                "actions": {
                    "view": "View offer",
                    "edit": "Edit offer",
                    "archive": "Archive",
                    "copy": "Copy",
                    "view-candidates": "View candidate list",
                    "view-interns": "See intern for interview",
                    "multiprovince": "Multiprovince",
                    "multiprovince.only-in-spain": "Only in Spain!",
                    "multiprovince.only-active-offers": "Only active offers!",
                    "destroy": "Destroy",
                    "share": "Share"
                },
                "candidate": {
                    "new": "New",
                    "seen": "Seen",
                    "accepted": "Accepted",
                    "rejected": "Rejected",
                    "invalid": "Not suitable"
                }
            },
            "offer-application": {
                "accepted-text": "The company has your application in process.",
                "rejected-text": "The company rejected your application."
            },
            "publish-offer": {
                "publish-now": "Publish now",
                "less-info": "Show less",
                "more-info": "Show more",
                "your-ad-on": "Your offer in"
            },
            "one-offer": {
                "actions": {
                    "view": "View offer",
                    "view-candidates": "View candidates",
                    "delegate-user": "Delegate this user",
                    "delegate-offer": "Delegate this offer",
                    "delegate-external-user": "Delegate external candidate",
                    "archive": "Archive",
                    "delete": "Delete"
                }
            },
            "one-company": {
                "phone": "Phone",
                "status": "Status",
                "status.confirmed": "Confirmed",
                "status.pending": "Pending",
                "status.rejected": "Rejected"
            },
            "one-user": {
                "actions": {
                    "view": "View profile",
                    "delegate-offer": "Delegate offer",
                    "delegate-user": "Delegate to this user",
                    "manage-companies": "Manage companies"
                },
                "role": {
                    "candidate": "Candidate",
                    "company": "Company",
                    "headhunter": "Headhunter",
                    "admin": "Administrator"
                }
            },
            "referral": {
                "disabled": "Disabled",
                "enabled": "Enabled",
                "link": "Link",
                "created-at": "Created",
                "updated-at": "Updated",
                "counter": "Counter"
            }
        },
        "data": {
            "countries": {
                "(Seleccionar)": "(To select)",
                "España": "Spain",
                "--- Extranjero ---": "--- Foreign ---",
                "Andorra": "Andorra",
                "United Arab Emirates": "United Arab Emirates",
                "Afghanistan": "Afghanistan",
                "Antigua and Barbuda": "Antigua and Barbuda",
                "Anguilla": "Anguilla",
                "Albania": "Albania",
                "Armenia": "Armenia",
                "Angola": "Angola",
                "Antarctica": "Antarctica",
                "Argentina": "Argentina",
                "American Samoa": "American Samoa",
                "Austria": "Austria",
                "Australia": "Australia",
                "Aruba": "Aruba",
                "Aland Islands": "Aland Islands",
                "Azerbaijan": "Azerbaijan",
                "Bosnia and Herzegovina": "Bosnia and Herzegovina",
                "Barbados": "Barbados",
                "Bangladesh": "Bangladesh",
                "Belgium": "Belgium",
                "Burkina Faso": "Burkina Faso",
                "Bulgaria": "Bulgaria",
                "Bahrain": "Bahrain",
                "Burundi": "Burundi",
                "Benin": "Benin",
                "Saint Barthelemy": "Saint Barthelemy",
                "Bermuda": "Bermuda",
                "Brunei": "Brunei",
                "Bolivia": "Bolivia",
                "Bonaire, Saint Eustatius and Saba": "Bonaire, Saint Eustatius and Saba",
                "Brazil": "Brazil",
                "Bahamas": "Bahamas",
                "Bhutan": "Bhutan",
                "Bouvet Island": "Bouvet Island",
                "Botswana": "Botswana",
                "Belarus": "Belarus",
                "Belize": "Belize",
                "Canada": "Canada",
                "Cocos Islands": "Cocos Islands",
                "Democratic Republic of the Congo": "Democratic Republic of the Congo",
                "Central African Republic": "Central African Republic",
                "Republic of the Congo": "Republic of the Congo",
                "Switzerland": "Switzerland",
                "Ivory Coast": "Ivory Coast",
                "Cook Islands": "Cook Islands",
                "Chile": "Chile",
                "Cameroon": "Cameroon",
                "China": "China",
                "Colombia": "Colombia",
                "Costa Rica": "Costa Rica",
                "Cuba": "Cuba",
                "Cape Verde": "Cape Verde",
                "Curacao": "Curacao",
                "Christmas Island": "Christmas Island",
                "Cyprus": "Cyprus",
                "Czech Republic": "Czech Republic",
                "Germany": "Germany",
                "Djibouti": "Djibouti",
                "Denmark": "Denmark",
                "Dominica": "Dominica",
                "Dominican Republic": "Dominican Republic",
                "Algeria": "Algeria",
                "Ecuador": "Ecuador",
                "Estonia": "Estonia",
                "Egypt": "Egypt",
                "Western Sahara": "Western Sahara",
                "Eritrea": "Eritrea",
                "Ethiopia": "Ethiopia",
                "Finland": "Finland",
                "Fiji": "Fiji",
                "Falkland Islands": "Falkland Islands",
                "Micronesia": "Micronesia",
                "Faroe Islands": "Faroe Islands",
                "France": "France",
                "Gabon": "Gabon",
                "United Kingdom": "United Kingdom",
                "Grenada": "Grenada",
                "Georgia": "Georgia",
                "French Guiana": "French Guiana",
                "Guernsey": "Guernsey",
                "Ghana": "Ghana",
                "Gibraltar": "Gibraltar",
                "Greenland": "Greenland",
                "Gambia": "Gambia",
                "Guinea": "Guinea",
                "Guadeloupe": "Guadeloupe",
                "Equatorial Guinea": "Equatorial Guinea",
                "Greece": "Greece",
                "South Georgia and the South Sandwich Islands": "South Georgia and the South Sandwich Islands",
                "Guatemala": "Guatemala",
                "Guam": "Guam",
                "Guinea-Bissau": "Guinea-Bissau",
                "Guyana": "Guyana",
                "Hong Kong": "Hong Kong",
                "Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
                "Honduras": "Honduras",
                "Croatia": "Croatia",
                "Haiti": "Haiti",
                "Hungary": "Hungary",
                "Indonesia": "Indonesia",
                "Ireland": "Ireland",
                "Israel": "Israel",
                "Isle of Man": "Isle of Man",
                "India": "India",
                "British Indian Ocean Territory": "British Indian Ocean Territory",
                "Iraq": "Iraq",
                "Iran": "Iran",
                "Iceland": "Iceland",
                "Italy": "Italy",
                "Jersey": "Jersey",
                "Jamaica": "Jamaica",
                "Jordan": "Jordan",
                "Japan": "Japan",
                "Kenya": "Kenya",
                "Kyrgyzstan": "Kyrgyzstan",
                "Cambodia": "Cambodia",
                "Kiribati": "Kiribati",
                "Comoros": "Comoros",
                "Saint Kitts and Nevis": "Saint Kitts and Nevis",
                "North Korea": "North Korea",
                "South Korea": "South Korea",
                "Kuwait": "Kuwait",
                "Cayman Islands": "Cayman Islands",
                "Kazakhstan": "Kazakhstan",
                "Laos": "Laos",
                "Lebanon": "Lebanon",
                "Saint Lucia": "Saint Lucia",
                "Liechtenstein": "Liechtenstein",
                "Sri Lanka": "Sri Lanka",
                "Liberia": "Liberia",
                "Lesotho": "Lesotho",
                "Lithuania": "Lithuania",
                "Luxembourg": "Luxembourg",
                "Latvia": "Latvia",
                "Libya": "Libya",
                "Morocco": "Morocco",
                "Monaco": "Monaco",
                "Moldova": "Moldova",
                "Montenegro": "Montenegro",
                "Saint Martin": "Saint Martin",
                "Madagascar": "Madagascar",
                "Marshall Islands": "Marshall Islands",
                "Macedonia": "Macedonia",
                "Mali": "Mali",
                "Myanmar": "Myanmar",
                "Mongolia": "Mongolia",
                "Macao": "Macao",
                "Northern Mariana Islands": "Northern Mariana Islands",
                "Martinique": "Martinique",
                "Mauritania": "Mauritania",
                "Montserrat": "Montserrat",
                "Malta": "Malta",
                "Mauritius": "Mauritius",
                "Maldives": "Maldives",
                "Malawi": "Malawi",
                "Mexico": "Mexico",
                "Malaysia": "Malaysia",
                "Mozambique": "Mozambique",
                "Namibia": "Namibia",
                "New Caledonia": "New Caledonia",
                "Niger": "Niger",
                "Norfolk Island": "Norfolk Island",
                "Nigeria": "Nigeria",
                "Nicaragua": "Nicaragua",
                "Netherlands": "Netherlands",
                "Norway": "Norway",
                "Nepal": "Nepal",
                "Nauru": "Nauru",
                "Niue": "Niue",
                "New Zealand": "New Zealand",
                "Oman": "Oman",
                "Panama": "Panama",
                "Peru": "Peru",
                "French Polynesia": "French Polynesia",
                "Papua New Guinea": "Papua New Guinea",
                "Philippines": "Philippines",
                "Pakistan": "Pakistan",
                "Poland": "Poland",
                "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
                "Pitcairn": "Pitcairn",
                "Puerto Rico": "Puerto Rico",
                "Palestinian Territory": "Palestinian Territory",
                "Portugal": "Portugal",
                "Palau": "Palau",
                "Paraguay": "Paraguay",
                "Qatar": "Qatar",
                "Reunion": "Reunion",
                "Romania": "Romania",
                "Serbia": "Serbia",
                "Russia": "Russia",
                "Rwanda": "Rwanda",
                "Saudi Arabia": "Saudi Arabia",
                "Solomon Islands": "Solomon Islands",
                "Seychelles": "Seychelles",
                "Sudan": "Sudan",
                "Sweden": "Sweden",
                "Singapore": "Singapore",
                "Saint Helena": "Saint Helena",
                "Slovenia": "Slovenia",
                "Svalbard and Jan Mayen": "Svalbard and Jan Mayen",
                "Slovakia": "Slovakia",
                "Sierra Leone": "Sierra Leone",
                "San Marino": "San Marino",
                "Senegal": "Senegal",
                "Somalia": "Somalia",
                "Suriname": "Suriname",
                "South Sudan": "South Sudan",
                "Sao Tome and Principe": "Sao Tome and Principe",
                "El Salvador": "El Salvador",
                "Sint Maarten": "Sint Maarten",
                "Syria": "Syria",
                "Swaziland": "Swaziland",
                "Turks and Caicos Islands": "Turks and Caicos Islands",
                "Chad": "Chad",
                "French Southern Territories": "French Southern Territories",
                "Togo": "Togo",
                "Thailand": "Thailand",
                "Tajikistan": "Tajikistan",
                "Tokelau": "Tokelau",
                "East Timor": "East Timor",
                "Turkmenistan": "Turkmenistan",
                "Tunisia": "Tunisia",
                "Tonga": "Tonga",
                "Turkey": "Turkey",
                "Trinidad and Tobago": "Trinidad and Tobago",
                "Tuvalu": "Tuvalu",
                "Taiwan": "Taiwan",
                "Tanzania": "Tanzania",
                "Ukraine": "Ukraine",
                "Uganda": "Uganda",
                "United States Minor Outlying Islands": "United States Minor Outlying Islands",
                "United States": "United States",
                "Uruguay": "Uruguay",
                "Uzbekistan": "Uzbekistan",
                "Vatican": "Vatican",
                "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
                "Venezuela": "Venezuela",
                "British Virgin Islands": "British Virgin Islands",
                "U.S. Virgin Islands": "U.S. Virgin Islands",
                "Vietnam": "Vietnam",
                "Vanuatu": "Vanuatu",
                "Wallis and Futuna": "Wallis and Futuna",
                "Samoa": "Samoa",
                "Kosovo": "Kosovo",
                "Yemen": "Yemen",
                "Mayotte": "Mayotte",
                "South Africa": "South Africa",
                "Zambia": "Zambia",
                "Zimbabwe": "Zimbabwe"
            },
            "provinces": {
                "(Seleccionar)": "(To select)",
                "A Coruña": "A Coruña",
                "Álava/Araba": "Álava/Araba",
                "Albacete": "Albacete",
                "Alicante/Alacant": "Alicante/Alacant",
                "Almería": "Almería",
                "Asturias": "Asturias",
                "Ávila": "Ávila",
                "Badajoz": "Badajoz",
                "Barcelona": "Barcelona",
                "Burgos": "Burgos",
                "Cáceres": "Cáceres",
                "Cádiz": "Cádiz",
                "Cantabria": "Cantabria",
                "Castellón/Castelló": "Castellón/Castelló",
                "Ceuta": "Ceuta",
                "Ciudad Real": "Ciudad Real",
                "Córdoba": "Córdoba",
                "Cuenca": "Cuenca",
                "Girona": "Girona",
                "Granada": "Granada",
                "Guadalajara": "Guadalajara",
                "Guipúzcoa/Gipuzkoa": "Guipúzcoa/Gipuzkoa",
                "Huelva": "Huelva",
                "Huesca": "Huesca",
                "Islas Baleares/Illes Balears": "Islas Baleares/Illes Balears",
                "Jaén": "Jaén",
                "La Rioja": "La Rioja",
                "Las Palmas": "Las Palmas",
                "León": "León",
                "Lleida": "Lleida",
                "Lugo": "Lugo",
                "Madrid": "Madrid",
                "Málaga": "Málaga",
                "Melilla": "Melilla",
                "Murcia": "Murcia",
                "Navarra": "Navarra",
                "Ourense": "Ourense",
                "Palencia": "Palencia",
                "Pontevedra": "Pontevedra",
                "Salamanca": "Salamanca",
                "Santa Cruz de Tenerife": "Santa Cruz de Tenerife",
                "Segovia": "Segovia",
                "Sevilla": "Sevilla",
                "Soria": "Soria",
                "Tarragona": "Tarragona",
                "Teruel": "Teruel",
                "Toledo": "Toledo",
                "Valencia/València": "Valencia/València",
                "Valladolid": "Valladolid",
                "Vizcaya/Bizkaia": "Vizcaya/Bizkaia",
                "Zamora": "Zamora",
                "Zaragoza": "Zaragoza"
            },
            "levels": {
                "Becario/a - Prácticas": "Internship - Internship",
                "Becario/a - Formación Profesionals": "Intern - Professional Training",
                "Becario/a - Grado universitario o Máster": "Scholar - University degree or Master",
                "Empleado/a": "Employee",
                "Especialista": "Specialist",
                "Mando intermedio": "Intermediate control",
                "Dirección / gerencia": "Direction / management",
                "Consejo directivo": "Board of directors"
            },
            "categories": {
                "(Seleccionar)": "(To select)",
                "Administración Publica": "Public administration",
                "Administración de empresas": "Business Administration",
                "Atención a clientes": "Customer service",
                "Calidad, producción e I+D": "Quality, production and R&D",
                "Comercial y ventas": "Trade and sales",
                "Compras, logística y almacén": "Purchasing, logistics and warehouse",
                "Diseño y artes gráficas": "Design and graphic arts",
                "Educación y formación": "Education and formation",
                "Finanzas y banca": "Finance and banking",
                "Informática y telecomunicaciones": "IT and Telecoms",
                "Inginerios y técnicos": "Engineering and technical",
                "Immobiliario y construcción": "Real estate and construction",
                "Legal": "Legal",
                "Marketing y comunicación": "Marketing and Communication",
                "Profesionales, artes y oficios": "Professionals, arts and crafts",
                "Recursos humanos": "Human Resources",
                "Sanidad y salud": "Health and health",
                "Sector Farmacéutico": "Pharmaceutical sector",
                "Turismo y restauración": "Tourism and restoration",
                "Ventas al detalle": "Retail sales",
                "Otros": "Others"
            },
            "subcategories": {
                "(Seleccionar)": "(To select)",
                "Administraciones europeas": "European administrations",
                "Administración autonómica": "Autonomous administration",
                "Administración del Estado": "State Administration",
                "Administración local": "Local Management",
                "Cuerpos de seguridad": "Security forces",
                "Empresas públicas": "Public enterprises",
                "Empresa Privada": "Private company",
                "Administración": "Administration",
                "Auditoría": "Audit",
                "Consultoría": "Consultancy",
                "Dirección y gerencia": "Direction and management",
                "Facturación, cobros y pagos": "Billing, collections and payments",
                "Finanzas y contabilidad": "Finance and accounting",
                "Negociación y contratación": "Negotiation and contracting",
                "Operaciones societarias": "Corporate operations",
                "Organización de la empresa": "Business organization",
                "Recepción": "Reception",
                "Secretariado": "Secretariat",
                "Atención al cliente": "Customer Support",
                "Promoción y ferias": "Promotion and fairs",
                "Certificación de calidad": "Quality certification",
                "Gestión de la calidad": "Quality management",
                "Gestión de proyectos": "Projects management",
                "Investigación y desarrollo": "Investigation and development",
                "Mantenimiento": "Maintenance",
                "Medio ambiente": "Environment",
                "Metrología": "Metrology",
                "Operaciones": "Operations",
                "Agente comercial": "Broker",
                "Comercial": "Commercial",
                "Comercio exterior": "Foreign trade",
                "Gran cuenta": "Big account",
                "Televenta y marketing telefónico": "Telesales and telephone marketing",
                "Almacén": "Warehouse",
                "Compras y aprovisionamiento": "Purchasing and provisioning",
                "Distribución y logística": "Distribution and logistics",
                "Creación audiovisual": "Audiovisual creation",
                "Diseño gráfico": "Graphic design",
                "Diseño industrial": "Industrial design",
                "Diseño web": "Web design",
                "Editorial e imprenta": "Publishing and printing",
                "Moda y confección": "Fashion and clothing",
                "Educación especial": "Special education",
                "Educación social": "Social education",
                "Enseñanza": "Teaching",
                "Gestión de centros educativos": "Management of educational centers",
                "Pedagogía": "Pedagogy",
                "Puericultura": "Childcare",
                "Banca empresarial": "Business banking",
                "Banca privada": "Private banking",
                "Bolsa, valores e inversión": "Stock market, securities and investment",
                "Productos y servicios bancarios": "Banking products and services",
                "Seguros": "Insurance",
                "Administración de bases de datos": "Database administration",
                "Análisis": "Analysis",
                "Arquitectura": "Architecture",
                "Calidad": "Quality",
                "ERP, CRM, Business Intelligence": "ERP, CRM, Business Intelligence",
                "Hardware, redes y seguridad": "Hardware, networks and security",
                "Helpdesk": "Helpdesk",
                "Programación": "Programming",
                "Sistemas": "Systems",
                "Telecomunicaciones": "Telecommunications",
                "Aeronáutico": "Aeronautical",
                "Agrónomo y montes": "Agronomist and mountains",
                "Electrónica": "Electronics",
                "Electrónica y automática industrial": "Electronics and industrial automation",
                "Energias Renovables": "Renewable energy",
                "Geología, geodesia y cartografía": "Geology, geodesy and cartography",
                "Industrial": "Industrial",
                "Minas": "Mines",
                "Naval y oceánico": "Naval and oceanic",
                "Organización industrial": "Industrial organization",
                "Otras ingenierías": "Other engineering",
                "Químico": "Chemical",
                "Sistemas de defensa": "Defense systems",
                "Administración inmobiliaria": "Real estate administration",
                "Arquitectura y proyección": "Architecture and projection",
                "Dirección y gestión de obras": "Direction and management of works",
                "Ingeniería civil y obras públicas": "Civil engineering and public works",
                "Ingeniería de materiales": "Materials engineering",
                "Interiorismo": "Interior design",
                "Oficios de la construcción": "Construction trades",
                "Derecho civil, penal y constitucional": "Civil, criminal and constitutional law",
                "Derecho internacional": "International right",
                "Derecho procesal": "Procedural law",
                "Derecho y empresa": "Law and business",
                "Notaría y registros": "Notary and records",
                "Comunicación corporativa": "Corporate communication",
                "Desarrollo de marca y producto": "Brand and product development",
                "Investigación de mercados": "Market research",
                "Marketing": "Marketing",
                "Periodismo y edición": "Journalism and publishing",
                "Producción": "Production",
                "Publicidad": "Advertising",
                "RRPP y eventos": "PR and events",
                "Técnicas audiovisuales": "Audiovisual techniques",
                "Agricultura y jardinería": "Agriculture and gardening",
                "Artes interpretativas": "Performing arts",
                "Artes plásticas": "Plastic arts",
                "Artesanía": "Crafts",
                "Automoción": "Automotive",
                "Carpintería": "Carpentry",
                "Confección": "Making",
                "Consumo y alimentación": "Consumption and feeding",
                "Electricidad": "Electricity",
                "Estética y cosmética": "Aesthetics and cosmetics",
                "Fontanería": "Plumbing",
                "Fotografía": "Photography",
                "Limpieza": "Cleaning",
                "Otros oficios": "Other trades",
                "Seguridad y vigilancia": "Security and vigilance",
                "Traducción e interpretación": "Translation and interpretation",
                "Transporte": "Transport",
                "Formación": "Training",
                "Prevención de riesgos": "Risks prevention",
                "Relaciones laborales": "Labor Relations",
                "Selección de personal": "Staff pick",
                "Enfermería": "Nursing",
                "Farmacia": "Pharmacy",
                "Medicina especializada": "Specialized medicine",
                "Medicina general": "General medicine",
                "Medicinas alternativas": "Alternative medicines",
                "Odontología": "Odontology",
                "Otras profesiones sanitarias": "Other health professions",
                "Psicología": "Psychology",
                "Veterinaria": "Veterinary",
                "Acceso al mercado y relaciones institucionales": "Market access and institutional relations",
                "Asuntos regulatorios": "Regulatory issues",
                "Calidad, producción e I+D": "Quality, production and R&D",
                "Comercial y ventas": "Trade and sales",
                "Investigación clínica y asuntos médicos": "Clinical research and medical affairs",
                "Marketing y comunicación": "Marketing and Communication",
                "Hostelería": "Hostelry",
                "Restauración": "Restoration",
                "Turismo": "Tourism",
                "Venta al detalle": "Retail",
                "Sin especificar": "Unspecified"
            },
            "staff": {
                "(Seleccionar)": "(To select)"
            },
            "salaries": {
                "(Seleccionar)": "(To select)"
            },
            "salaryTypes": {
                "(Seleccionar)": "(To select)",
                "Bruto/año": "Gross / year",
                "Bruto/mes": "Gross / month",
                "Bruto/hora": "Gross / hour"
            },
            "contractTypes": {
                "(Seleccionar)": "(To select)",
                "Autónomo": "Autonomous",
                "De duración determinada": "Time-bound",
                "De relevo": "Substitution",
                "Fijo discontinuo": "Fixed discontinuous",
                "Formativo": "Formative",
                "Indefinido": "Undefined",
                "A tiempo parcial": "Part time",
                "Otros contratos": "Other contracts"
            },
            "contractWorkdays": {
                "(Seleccionar)": "(To select)",
                "Completa": "Complete",
                "Indiferente": "Indifferent",
                "Parcial - Mañana": "Partial - Morning",
                "Parcial - Tarde": "Partial - Afternoon",
                "Parcial - Noche": "Partial - Night",
                "Parcial - Indifirente": "Partial - Indifirent",
                "Intensiva - Mañana": "Intensive - Morning",
                "Intensiva - Tarde": "Intensive - Afternoon",
                "Intensiva - Noche": "Intensive - Night",
                "Intensiva - Indifirente": "Intensive - Indifirent"
            },
            "experience": {
                "(Seleccionar)": "(To select)",
                "No tengo": "I do not have",
                "No Requerida": "Not required",
                "Al menos 1 año": "At least 1 year",
                "Al menos 2 años": "At least 2 years",
                "Al menos 3 años": "At least 3 years",
                "Al menos 4 años": "At least 4 years",
                "Más de 5 años": "More than 5 years",
                "Más de 10 años": "More than 10 years"
            },
            "industryTypes": {
                "(Seleccionar)": "(To select)",
                "Actividades inmobiliarias": "Real estate activities",
                "Administración gubernamental": "Government administration",
                "Agricultura, ganadería y pesca": "Agriculture, Livestock and fishing",
                "Agroalimentario": "Agrifood",
                "Animación": "Animation",
                "Apuestas y casinos": "Gambling and casinos",
                "Arquitectura y planificación": "Architecture and planning",
                "Artes escénicas": "Performing arts",
                "Artesanía": "Crafts",
                "Artículos de lujo y joyería": "Luxury goods and jewelry",
                "Artículos deportivos": "Sports articles",
                "Atención sanitaria y hospitalaria": "Health and hospital care",
                "Audiovisual": "Audiovisual",
                "Automoción": "Automotive",
                "Banca": "Banking",
                "Banca de inversiones": "Investment banking",
                "Bellas Artes": "Fine arts",
                "Bibliotecas": "Libraries",
                "Biotecnología": "Biotechnology",
                "Cadena de suministro": "Supply chain",
                "Capital de riesgo y capital privado": "Venture capital and private capital",
                "Construcción": "Building",
                "Consultoría de estrategia y operaciones": "Strategy and operations consulting",
                "Cooperación y desarrollo internacional": "International cooperation and development",
                "Cosmética": "Cosmetics",
                "Cristal, cerámica y hormigón": "Glass, ceramic and concrete",
                "Departamento de defensa y del espacio exterior": "Department of defense and outer space",
                "Deportes": "Sports",
                "Desarrollo de programación": "Programming development",
                "Diseño": "Design",
                "Diseño gráfico": "Graphic design",
                "Editorial": "Editorial",
                "Educación": "Education",
                "Electrónica de consumo": "Consumer electronics",
                "Eléctrica": "Electrical",
                "Energía renovable y medio ambiente": "Renewable energy and environment",
                "Entretenimiento": "Entertainment",
                "Equipos informáticos": "Computer equipment",
                "Fotografía": "Photography",
                "Gestión de inversiones": "Investment Management",
                "Gran consumo y alimentación": "Great consumption and food",
                "Hostelería y restaurantes": "Hospitality and restaurants",
                "Importación y exportación": "Import and export",
                "Imprenta": "Printing",
                "Industria aeroespacial y aviación": "Aviation and aerospace industry",
                "Industria farmaceútica": "Pharmaceutical industry",
                "Industria química": "Chemical industry",
                "Industria textil y moda": "Textile and fashion industry",
                "Infraestructuras": "Infrastructures",
                "Ingeniería": "Engineering",
                "Instalaciones y servicios recreativos": "Recreational facilities and services",
                "Internet": "Internet",
                "Investigación": "Investigation",
                "Investigación de mercado": "Market research",
                "Logística": "Logistics",
                "Maquinaria": "Machinery",
                "Marketing y publicidad": "Marketing and publicity",
                "Material y equipo de negocios": "Business supplies and equipment",
                "Medicina alternativa": "Alternative medicine",
                "Medios de comunicación offline": "Offline media",
                "Medios de comunicación online": "Online media",
                "Mercados de capital": "Capital markets",
                "Minería y metalurgia": "Mining and metallurgy",
                "Museos e instituciones": "Museums and institutions",
                "Música": "Music",
                "Naval": "Naval",
                "ONG y servicios sociales": "NGO and social services",
                "Petróleo y energía": "Oil and energy",
                "Plástico, papel y madera": "Plastic, paper and wood",
                "Producción multimedia": "Multimedia production",
                "Programas informáticos": "Software",
                "Protección civil": "Civil protection",
                "Publicidad, RRPP y eventos": "Advertising, PR and events",
                "Salud, bienestar y fitness": "Health, wellness and fitness",
                "Seguros": "Insurance",
                "Servicios de RRHH": "HR services",
                "Servicios de asesoría y auditoría": "Advisory and audit services",
                "Servicios de seguridad": "Security services",
                "Servicios financieros": "Financial services",
                "Servicios jurídicos": "Juridical services",
                "Servicios medioambientales": "Environmental services",
                "Servicios y tecnología de la información": "Information Technology and Services",
                "Tabacalera": "Tobacco",
                "Telecomunicaciones": "Telecommunications",
                "Telemarketing": "Telemarketing",
                "Traducción": "Translation",
                "Transporte y mensajeria": "Transport and courier",
                "Turismo": "Tourism",
                "Venta al por mayor": "Wholesale",
                "Venta al por menor": "Retail",
                "Veterinaria": "Veterinary",
                "Videojuegos": "Video game",
                "Otras actividades": "Other activities"
            },
            "languages": {
                "(Seleccionar)": "(To select)",
                "Español": "Spanish",
                "Catalán": "Catalan",
                "Inglés": "English",
                "Francés": "French"
            },
            "languageLevels": {
                "(Seleccionar)": "(To select)",
                "nulo": "None",
                "basico": "Basic",
                "intermedio": "Intermediate",
                "avanzado": "Advanced",
                "nativo": "Native"
            },
            "educations": {
                "(Seleccionar)": "(To select)",
                "Enseñanzas artísticas (regladas)": "Artistic education (regulated)",
                "Enseñanzas deportivas (regladas)": "Sports education (regulated)",
                "Formación Profesional Grado Medio": "Professional Training Medium Grade",
                "Ciclo Formativo Grado Medio": "Middle Grade Training Cycle",
                "Diplomatura": "Diploma",
                "Ingeniería Técnica": "Technical engineering",
                "Grado": "Degree",
                "Licenciatura": "Bachelor's degree",
                "Ingeniería Superior": "Superior Engineering",
                "Postgrado": "Postgraduate",
                "Máster": "Master's degree",
                "Doctorado": "Doctorate"
            },
            "contactFormTypes": {
                "(Seleccionar)": "(To select)",
                "Consulta": "Query",
                "Incidencia": "Incidence",
                "Sugerencia": "Suggestion"
            },
            "promos": {
                "offer": "Offer",
                "multiprovincia": "Multiprovince"
            },
            "minimumStudies": {
                "Otros títulos, certificaciones y carnés": "Other titles, certifications and cards",
                "Otros cursos y formación no reglada": "Other courses and non-regulated training",
                "Sin estudios": "No studies",
                "Educación Secundaria Obligatoria": "Compulsory Secondary Education",
                "Enseñanzas artísticas (regladas)": "Artistic education (regulated)",
                "Enseñanzas deportivas (regladas)": "Sports education (regulated)",
                "Formación Profesional Grado Medio": "Professional Training Medium Grade",
                "Ciclo Formativo Grado Medio": "Middle Grade Training Cycle",
                "Bachillerato": "High school",
                "Formación Profesional Grado Superior": "Higher Level Professional Training",
                "Ciclo Formativo Grado Superior": "High grade formative cycle",
                "Diplomatura": "Diploma",
                "Ingeniería Técnica": "Technical engineering",
                "Grado": "Grade",
                "Licenciatura": "Bachelor's degree",
                "Ingeniería Superior": "Higher Engineering",
                "Postgrado": "Postgraduate",
                "Máster": "Master's degree",
                "Doctorado": "Doctorate"
            }
        },
        "generic": {
            "home": "Home",
            "login": "Login",
            "send": "Send",
            "on": "On",
            "back": "Back",
            "vat": "VAT",
            "cif": "CIF",
            "yes": "Yes",
            "privacy-policy": {
                "title": "privacy policy",
                "content": "We inform you that the personal data that you provide us\n            by filling in this form will be processed by Aicad Business\n            School S.L as responsible for this website. The purpose of the collection\n            and treatment of the personal data that we request is to send you\n            our publications, product and / or service promotions and resources\n            exclusive. The legitimation is carried out through the consent of the\n            interested. You can exercise your rights of access, rectification, limitation\n            and delete the data by contacting info@aicad.es. You can check the information\n            Additional and detailed information on Data Protection in our"
            },
            "loading": "Loading",
            "course": "Course",
            "degree": "Degree",
            "language": "Language",
            "dashboard": "Dashboard",
            "sign-in": "Access",
            "sign-off": "Sign off",
            "sign-up": "Register",
            "new": "New",
            "seen": "Seen",
            "inprocess": "In process",
            "accepted": "Accepted",
            "confirm": "Confirm",
            "confirmed": "Confirmed",
            "delete": "Delete",
            "rejected": "Rejected",
            "reject": "Reject",
            "pending": "Pending",
            "optional": "optional",
            "success": "Success",
            "error": "Error",
            "warning": "Warning",
            "something-went-wrong": "Something went wrong",
            "try-to-refresh": "Try to refresh the page",
            "try-again": "Please try again",
            "limited-features": "Some of the features might be limited",
            "offer": "Offer",
            "multiprovince": "Multiprovince",
            "actions": "Actions",
            "clear": "Clear",
            "reset": "Reset",
            "edit": "Edit",
            "save": "Save",
            "save-draft": "Save draft",
            "change": "Change",
            "save-changes": "Save changes",
            "cancel": "Cancel",
            "ok": "OK",
            "accept": "Accept",
            "select": "Select",
            "continue": "CONTINUE",
            "hidden-contact-details": "Contact details hidden",
            "hidden-company-name": "Company name not available",
            "previous": "Previous",
            "next": "Next",
            "add-more": "Add more",
            "add": "Add",
            "add-new": "Add new",
            "question": "Question {no}",
            "answer": "Answer {no}",
            "archived": "Archived",
            "unpaid": "Unpaid",
            "active": "Active",
            "verified": "Verified",
            "type": "Type",
            "code": "Code",
            "limit": "Limit",
            "id": "ID",
            "phone": "Phone",
            "status": "Status",
            "present": "Present",
            "abroad": "Abroad",
            "all-spain": "All Spain",
            "year": "year",
            "month": "month",
            "hour": "hour",
            "browse": "Browse",
            "char-counter": "{current}/{max} characters",
            "result": "Result",
            "salary-from-to": "{min} - {max} {type}",
            "salary-from-to.placeholder": "Min - max",
            "salary-more-than": "More than {min} {type}",
            "salary-more-than.placeholder": "More than",
            "salary-dont-show": "Salary not available",
            "english": "English",
            "spanish": "Spanish",
            "ingles": "English",
            "espanol": "Spanish",
            "catalan": "Catalan",
            "frances": "French"
        },
        "validations": {
            "alphanumeric": "This field can only have alphanumeric characters",
            "number": "This field must be a number",
            "min-length": "This field must have at least {count} characters",
            "max-length": "This field can have at most {count} characters",
            "required": "This is a required field",
            "required.number": "This is a required field and must be a number",
            "required.min-length": "This is a required field and must have at least {count} characters",
            "email.unique": "Email is already taken",
            "first_name.required": "First name is required",
            "last_name.required": "Last name is required",
            "city.required": "City is required",
            "phone.required": "Phone is required",
            "password.required": "Password is required",
            "promocode.unique": "Promo code name must be unique"
        },
        "pages": {
            "home": {
                "filters-offers": {
                    "title": "FIND A JOB",
                    "apprenticeships": "SCHOLARSHIPS & INTERNSHIPS",
                    "it-jobs": "IT JOBS",
                    "remote-jobs": "WORK FROM HOME",
                    "director-jobs": "MANAGERS"
                },
                "city-offers": {
                    "title": "WORK IN THE PLACE YOU WANT",
                    "madrid": "MADRID",
                    "barcelona": "BARCELONA",
                    "valencia": "VALENCIA",
                    "bilbao": "BILBAO"
                }
            },
            "accept-cookies": {
                "alert-title": "By continuing to browse, you agree to our use of",
                "cookies": "Cookies",
                "accept": "Agree"
            },
            "public-offers": {
                "search-keyword-status": "{total} job offers for {phrase} found",
                "search-location-status": "{total} jobs offers found in {place}",
                "search-status": "{total} job offers found",
                "no-offers": "No offers yet...",
                "view-all-offers": "See all offers",
                "filters": {
                    "order-by": {
                        "order-by": "Sort offers by:",
                        "by-date": "Publication date"
                    },
                    "date": {
                        "date": "Date:",
                        "any-date": "Any date",
                        "24-hours": "Last 24 hours",
                        "7-days": "Last 7 days",
                        "15-days": "Last 15 days"
                    },
                    "keyword": {
                        "keyword": "Keyword:",
                        "ok": "OK"
                    },
                    "place": {
                        "place": "Place:"
                    },
                    "category": {
                        "category": "Job Category:"
                    },
                    "min-studies": {
                        "min-studies": "Minimum studies:"
                    },
                    "experience": {
                        "experience": "Experience (years)",
                        "min": "Min",
                        "max": "Max"
                    },
                    "salary": {
                        "salary": "Minimum salary"
                    },
                    "contract": {
                        "contract": "Contract type"
                    },
                    "shifts": {
                        "shifts": "Work shifts"
                    },
                    "expansion-bag": {
                        "show-more": "Show more",
                        "show-less": "Show less"
                    },
                    "show-filters": "Show filters"
                },
                "card": {
                    "no-company-name": "Company name not available",
                    "new": "New",
                    "contract": {
                        "contract": "Contract"
                    },
                    "workday": {
                        "workday": "Workday"
                    },
                    "salary": {
                        "more-than": "More than",
                        "no-salary": "Salary not available"
                    }
                }
            },
            "help": {
                "title": "Help and tips",
                "subtitle": "Help and tips {portal}",
                "no-answer": "Can't find the answer you're looking for or do you want to suggest improvements?",
                "contact-us": "CONTACT US",
                "register-validate-email": {
                    "subject": "Sign up / Validate email",
                    "enquiry1": {
                        "question": "How can I sign up for {portal}?",
                        "answer": "In the main menu of the web (on the right in the version\ncomputer and below in the mobile version) you will find the button \"Sign up\".\nYou just have to click and start filling in your details. For reasons of\nsecurity, once your information is filled in, we will send you an email\nelectronic verification. To confirm that it is yours and that everything is\ncorrect, open it and click on Confirm Account. Ready! Your account is already\nconfirmed and you can start signing up for job offers. We wish you\ngood luck and we hope you find a job soon."
                    },
                    "enquiry2": {
                        "question": "How is the email validated after the registration process?",
                        "answer": "Once you have completed the registration process in {portal},\nto be able to sign up for offers or access your account; first you must validate\nyour email address (email). To do this, you only have to access the email you have indicated\nin the registration process and look for the mail of {portal}. Open it and click on Confirm Account.\nReady! You already have it."
                    },
                    "enquiry3": {
                        "question": "I do not receive the email to validate my account. What I do?",
                        "answer": "First of all: have you checked that the email has not gone to the Spam folder or\nUnwanted mail? To avoid this, add the address: {portal} to your list of\nsafe senders and then request the email again (by clicking on \"send from\nnew \"). If you still do not receive it, make sure you have entered your email address correctly\nWhen you register, if despite following these steps, you continue without being able to validate your account, contact\ncontact us through the button \"contact us\" at the bottom of this page."
                    }
                },
                "access-my-account": {
                    "subject": "Access to my account",
                    "enquiry1": {
                        "question": "I have forgotten my password, what should I do?",
                        "answer": "I have forgotten my password, what should I do? Please go to Login\n                and write the email you use in your {portal} account. Then\n                We will send you an email with the instructions to create your new password."
                    },
                    "enquiry2": {
                        "question": "I do not receive the email to change my password",
                        "answer": "First of all: Have you checked that the email has not gone to the Spam folder or\nUnwanted mail? To avoid this, add the address {portal} es to your list\nof safe senders. When done, repeat the process to change\nenter the password by doing"
                    },
                    "enquiry3": {
                        "question": "No puedo acceder a mi cuenta porque no recuerdo o no puedo entrar al email que uso para {portal}",
                        "answer": "I can't access my account because I can't remember or can't enter the email I use\n            to {portal}. To help you regain access to your account, we must first check\n            your identity. Please, send us through this form, the following information: Name and\n            Surname, ID, Street, Number and Floor, Postal Code, Town and Province. A contact phone\n            Your old email and the new email you want to use to access {portal}. As soon as possible,\n            Our team will make the appropriate modifications and will contact you at the email from which\n            send us your data."
                    },
                    "enquiry4": {
                        "question": "Can I change my email or password {portal}?",
                        "answer": "Yes, you can change your current email and password without your data or applications suffering any\nchange or loss of information. Click here to change your current email and password."
                    }
                },
                "cv-my-data": {
                    "subject": "CV / My data",
                    "enquiry1": {
                        "question": "How do I modify my CV?",
                        "answer": "Go to the My CVs section of the main menu. Once there you can\nadd experiences, studies or others, as well as edit any existing ones. Alone\nyou have to click on the \"Edit\" button for each field or click on the field\nthat you want to edit if you are on the web from your mobile device."
                    },
                    "enquiry2": {
                        "question": "How can I create another CV or edit others that I already have?",
                        "answer": "In the My CVs section of the main menu you can create more than one CV or edit\nthose that you already have created. You will see in the right column (from computer) or below everything\n(from mobile device) the \"My CVs\" section. There you will see the ones you already have in blue\ncreated. Click on them to edit them, or create a new one with the button below."
                    },
                    "enquiry3": {
                        "question": "How can I create, attach or edit a cover letter?",
                        "answer": "In the My CVs section of the main menu, you can create a cover letter or\nedit the ones you already have created. You will see in the right column (from computer) or below everything\n(from mobile device) the section \"Presentation letters\". There you will see in blue those that\nyou already have created. Click on them to edit them, or create a new one with the button below."
                    }
                },
                "offers-and-recommendations": {
                    "subject": "Offers and recommendations",
                    "enquiry1": {
                        "question": "What can I do if I see offers that are repeated or appear to be fraudulent?",
                        "answer": "If you are logged in you will see that under the sign up button (the one below\nof the page) there is a link in which you can report the offers that you consider fraudulent\nindicating the reason. From {portal} we will take the measures we deem appropriate to stop\nany behavior that does not fit with what is stated in our characteristics and rules of use\nfor the publication of offers in {portal}"
                    },
                    "enquiry2": {
                        "question": "What are the Offers for you?",
                        "answer": "They are offers recommended for you, based on your searches, registrations and experience\nlabor. We analyze what offers you are looking for, what offers you sign up for and the work experience of your\nCV. So we can find offers that fit your interests and recommend them to you. Where do i find\nthe Offers for you? In the Android app, you will find them as a menu section. On the web, they are\nlocated at the bottom of the \"My {portal}\" page. Do they replace the searches I do\nhabitually? They do not replace them, they complement them. Keep searching and registering as before,\nso we can learn about your interests and recommend those offers that may interest you. By\ndo I see few recommendations? The list of recommendations has a maximum of 10 offers. But they leave\nrenewing so you always have new offers. Why do I sometimes have no recommendations? Maybe in\nsometimes the section is empty. In order for us to offer you recommendations, you must first seek and\nsign up for offers as you usually do. Thus, we can learn about your interests and\nwe will find those interesting offers for you."
                    }
                },
                "inscriptions-and-applications": {
                    "subject": "Registrations and candidatures",
                    "enquiry1": {
                        "question": "I'm registered, why can't I sign up for the offers?",
                        "answer": "After you have registered in {portal}, to be able to register for the offers\nYou must complete, at least, the first 3 steps of your CV (Personal data,\nStudies and Experience). When these steps are complete you can sign up for offers."
                    },
                    "enquiry2": {
                        "question": "How many states of the candidacy are there and what do they mean?",
                        "answer": "Enrolled: You have successfully enrolled in said offer. CV Read: The company has read\nyour CV. You are still in process: The company has included your CV among those that are still in the process Message\nof the company: The company has sent you a message by email Dismissed: The company has considered\nthat your profile does not match the profile they are looking for. In some cases: portal may\ncommunicate the reasons why you have been discarded exported CV: Only for this registration,\nyou have accepted that the company use the data of your CV in another external tool and different from\n{portal} You have returned to the process: The company has once again considered your application within the process\nof selection. Closed process: The company has closed the selection process and is not accepting any more registrations.\nFrom {portal} we can no longer give you more information about this selection process. Process reopened:\nThe company has reopened the selection process that it had previously closed. The company has\nmanaged CVs: The company has made any movement, visualization or change in the selection process.\nIf you do not have any new status in the chronology, it means that the changes do not affect you."
                    }
                },
                "notifications-and-emails": {
                    "subject": "Email notifications / alerts",
                    "enquiry1": {
                        "question": "What is the difference between Notifications and Alerts, and how do I enable / disable them?",
                        "answer": "Email alerts: If you want to create a new email alert, make a\njob search and then click on the [Create Alert] button.\nmoment you will receive a daily email with the results of that job search that you have\nTo manage the alerts you have created, you can do it from Settings\nfrom the main menu. There you can also create new ones and delete those that you no longer\ninterest in. Notifications of the applications on your mobile devices: You can\nactivate or deactivate from Settings in the menu of each application (Android and iOS) By\nAt the moment, the notifications of the Android App and the email alerts are not synchronized.\nWe hope to be able to offer you later, a complete and transversal management of all the\nnotifications from any device."
                    }
                },
                "networking": {
                    "subject": "Network of contacts",
                    "enquiry1": {
                        "question": "Where is the network of contacts of {portal}?",
                        "answer": "The network of contacts is no longer available in {portal}\nYour opinion and that of other candidates is very important to us and after evaluating it and\nspeak it internally we have decided to eliminate this service and focus on\nto create other tools that are more tailored to your needs.\nservice \"network of contacts\" has been discontinued. If you have questions, queries or\nany incident, you can always contact Customer Service at the end\nof this page"
                    }
                },
                "my-privacy": {
                    "subject": "Who sees me",
                    "enquiry1": {
                        "question": "My CV has received visits. What does that mean?",
                        "answer": "In this section (only available from the web) you can see what\ncompanies have found and consulted your CV. Companies can view CVs\nregistered to an offer they have published, or search the database of\n{portal}. In this section you will see those who have found you through the\ndatabase. If you don't want companies to find you at the base\ndata, in the Privacy section of the Settings section, you can deactivate\nsaid option."
                    }
                },
                "executive-account": {
                    "subject": "Executive Account",
                    "enquiry1": {
                        "question": "How do I activate my Executive account?",
                        "answer": "You should know that the accounts {portal} Executive portal\nactivated automatically and happens with those high-level profiles\n(such as directors or managers) who have positions of responsibility\nand with personnel under her charge. These types of profiles must also have more\n5 years of experience, as well as a salary commensurate with the position."
                    }
                },
                "unsubscribe": {
                    "subject": "Low",
                    "enquiry1": {
                        "question": "How can I unsubscribe from {portal}?",
                        "answer": "Keep your data in {portal}, it can be very\nuseful if in the future you want to look for work again, so you will not have\nhave to fill in all your information again. Also, if your CV is in\n{portal}, even if you are not looking for a job, it will be available\nfor companies looking for candidates like you, maybe one day you will receive a\nvery interesting offer from a company. Please go to the\nSettings section, there you will find the Unsubscribe section. You can choose\nbetween: Stop receiving emails with job offers Delete all my\napplications of the offers where I have previously registered Hide my\nCV to companies looking for candidates in {portal} If you don't want any\noption above and you prefer to unsubscribe, permanently eliminating all your\ndata from {portal}, you can do it by clicking the button\n[I want to unsubscribe]. Do you have a problem with the unsubscribe process? U.S\nWe can do it for you if you send us this completed form."
                    },
                    "enquiry2": {
                        "question": "I have found a job. Shall I unsubscribe?",
                        "answer": "Needless! If you want, you can continue in {portal}, but minimize\ncommunications, cancel applications or edit your privacy. In the section\nSettings, you will find the Unsubscribe section and you can choose between: Stop\nreceive emails with job offers Delete all my applications from the\noffers where I have previously registered Hide my CV from companies that\nthey look for candidates in {portal}"
                    }
                }
            },
            "contact-us": {
                "title": "Send us your query",
                "form": {
                    "type": "Query type",
                    "subject": "Subject of your query",
                    "text": "Your question",
                    "name": "Your name",
                    "email": "Your e-mail"
                },
                "validation.error": "Please correct the errors in the form",
                "privacy-notice": "We inform you that the personal data that you provide us\nBy filling in this form they will be processed by Aicad Business\nSchool S.L as responsible for this website. The purpose of the collection\nand treatment of the personal data that we request is for\nsend you our publications, product promotions and / or\nexclusive services and resources. The legitimation is done through\nof the consent of the interested party. You can exercise your rights to\naccess, rectification, limitation and delete the data in\ninfo@aicad.es. You can consult the additional and detailed information\non Data Protection in our",
                "privacy-policy-link": "Privacy Policy",
                "success": "Your inquiry has been sent successfully! Our team will contact you in a maximum of 48 hours. Thank you!",
                "search-offers": "Search offers"
            },
            "general-conditions": {
                "content": "<div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        GENERAL CONDITIONS OF ELECTRONIC CONTRACTING\n      </h1>\n      <p>Read our legal terms and conditions</p>\n      <div class=\"mt-5\">\n        <p>The parties that are linked through these conditions are Aicad Business School SL, with registered office at Calle León y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria CIF B76062199, Company registered in the Mercantile Registry of Las Palmas 30 / 04/2010 Volume 1958 book 0 Folio 116, which offers its products and services through the Internet platform Aicad.es (www.aicad.es), hereinafter Aicad, and the user who accesses it, either Through a personal computer, either through any application developed for \"smartphones\" or by any other means and which, where appropriate, uses the services offered by it. Consequently, the mere access to Aicad by any means implies acceptance by the user of these conditions and terms of use. You can contact us by email info@aicad.es or by phone (+34) 928 35 46 68 to request more information.</p>\n        <p class=\"text-center\">\n        The Client undertakes to comply with the provisions of the CONTRACTING CONDITIONS published by Aicad on its website at the time of purchase of the product.\n        </p>\n      </div>\n    </div>\n    \n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-center mb-4\">\n        General Contracting Conditions\n      </h1>\n      <div>\n        <h2 class=\"text-uppercase --bold\">\n          CONTRACTING CONDITIONS\n        </h2>\n        <p>In compliance with the provisions of Royal Decree 1906/99 of December seventeenth, which regulates electronic contracting with general conditions, and of the Retail Trade Organization Law (Law 7/1996 of January 15, modified by Law 47/2002 of December 19) as applicable to the provisions on distance sales in articles 38 and following, AICAD BUSINESS SCHOOL, SL (hereinafter The Company or Aicad), informs: This document supposes the general regulation of the services provided by Aicad through the site www.aicad.es, constituting the legal framework in which this contractual purchase-sale relationship is developed . These General Conditions are subject to the provisions of Law 7/1996, of January 15, on the Regulation of Retail Trade, to Law 7/1988 of April 13, on General Contracting Conditions, to Royal Decree 1906/1999 of December 17, 1999, which regulates Telephone or Electronic Contracting with general conditions, the General Data Protection Regulation (EU) 2016/679 (hereinafter, RGPD), to Law 34/2002 of 11 of July, of Aicad Information and Electronic Commerce Services (LSSI) and Royal Legislative Decree 1/2007, of November 16 (approving the revised text of the General Law for the Defense of Consumers and Users and other complementary laws). The services offered by Aicad may be hired by any users who meet the requirements established in these CONTRACTING CONDITIONS and PRIVACY POLICY available at all times on the website www.aicad.es</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          1. OBJECT OF THE CONTRACT.\n        </h4>\n        <p>The purpose of the contract is to regulate the general conditions of service offered by Aicad: The services that Aicad currently provides and that are the subject of this contract, are for the sale of training products, consulting services, technological products, web design, implementation of new technologies in the company, digital marketing services (including intermediation with other providers) and franchise systems. Access to the information is completely free, while the product purchase and contracting service is expensive, specifying at all times the current prices of the product, shipping prices, and tax charges. The contracting procedure will be carried out in the Spanish language, being able to establish the possibility of carrying out the contracting of the service in other specified languages.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          2.IDENTIFICATION OF THE CONTRACTING PARTIES.\n        </h4>\n        <p>On the one hand, AICAD BUSINESS SCHOOL, S.L. hereinafter Aicad with registered office at Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria, with CIF B76062199, Company registered in the Mercantile Registry of Las Palmas 04/30/2010 Volume 1958 book 0 Folio 116, la which offers its products and services through the Internet platform Aicad.es (www.aicad.es)</p>\n        <p>And from somewhere else,</p>\n        <p>THE CLIENT,</p>\n        <p>whose data entered to make the purchase or to make a suggestion, through the form established for this purpose, are those that have been entered by him. All the data included in it have been entered directly by the Client, so the responsibility for their authenticity corresponds directly and exclusively to the CLIENT.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          3. OBLIGATIONS RELATED TO THE PURCHASE PROCEDURE.\n        </h4>\n        <p>The Customer is solely responsible for the veracity of the data entered by himself in the purchase procedure, and accepts the obligation to provide true, accurate and complete data. If the Client breaches this obligation, it will be under his responsibility to respond for possible damages caused to Aicad or a third party.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          4. CONDITIONS OF SERVICE\n        </h4>\n        <p>The commercial conditions of this service and the offers that may eventually be carried out by Aicad always appear on the aforementioned website www.aicad.es, so they can be consulted, filed or printed. Aicad reserves the right to modify these General Contracting Conditions at any time, as well as any other documents displayed on its website.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          5. RESPONSIBILITIES\n        </h4>\n        <p>Aicad will not be responsible for delays or failures that may occur in the access, operation and operation of the website, or in its services and / or content, as well as any interruptions, suspensions or malfunctions of the same, when they have its origin in breakdowns produced by natural catastrophes or situations of force majeure, or extreme urgency, such as strikes, attacks or computer intrusions or any other situation of force majeure or fortuitous cause, as well as errors in the telematic data transfer networks and in any case when the error had been produced by a third party outside the aforementioned business organization.</p>\n        <p>Aicad is responsible for the reliability, veracity and accuracy of the content, data or information regarding the products offered on its website, unless these have been modified by third parties, external or not to the organization, without express authorization from the party. of the company. The service provided by Aicad is limited exclusively to informing and making the products available to customers, being responsible for products that do not conform to what was contracted by the Customer.</p>\n        <p>In the event that the websites owned by Aicad contain links or banners that allow the user to access websites or links owned by third parties, it is not responsible for the content that may be hosted on it and will proceed to remove them at in the event that a user communicates any type of illegal content, once the company has verified it.</p>\n        <p>Aicad will not be liable in any case for errors or damages caused by the inefficient and bad faith use of the service by the Client. Nor will it be responsible for the major or minor consequences due to the lack of communication between Aicad and the Client when it is attributable to the non-functioning of the email provided or falsification of the data provided by the Client in their aicad.es user registration.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          6. SERVICES OFFERED ON THIS WEBSITE\n        </h4>\n        <p>Aicad makes the following services available:</p>\n        <ul>\n          <li class=\"p-0\">\n            Sale of training products\n          </li>\n          <li class=\"p-0\">\n            Consulting services\n          </li>\n          <li class=\"p-0\">\n            Technological products\n          </li>\n          <li class=\"p-0\">\n            Web design\n          </li>\n          <li class=\"p-0\">\n            Implementation of new technologies and technologies\n          </li>\n          <li class=\"p-0\">\n            Digital marketing services (including intermediation between other providers)\n          </li>\n        </ul>\n        <p>The provisions of this Regulation shall apply, in particular, to the registration and form of correspondence and proportionate information in the register. The information in the register is proportionately accurate, complete and actualized at that moment. Elsewhere as a result of the violation of the space, the result is a dissolution.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          7. THIRD PARTY SOLUTIONS\n        </h4>\n        <p>Some services may include third-party solutions. Aicad may provide links to third party websites as partners associated with Aicad for the provision of some services. (Example: Google GSuite) You also agree that the Service may include security solutions that limit the use and that you must use these services in accordance with the rules of use established by Aicad and its security Partners and that any other use may constitute a right copyright infringement. </p>\n        <p>It is forbidden to alter, circumvent, reverse engineer, decompile, disassemble or alter in any way the security technology provided by Aicad for any reason. System or network security breaches can result in civil or criminal liability.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          8. PRICES AND PAYMENT METHODS\n        </h4>\n        <p>You agree to pay the services contracted to Aicad in the forms of payment accepted by its website and for any additional amount (including taxes and late fees, as the case may be).</p>\n        <p>Payment is 100% in advance and services will be provided when we confirm payment, except for written confirmation for personalized offers or direct debits. The prices applicable to each product and / or service are those indicated on the website on the date of the order.</p>\n        <p>Common system of value added tax of the European Union: In accordance with the provisions of Law 37/1992, of December 28, regulating said tax and European Directive 2008/8 / EC, the operation is exempt or not subject VAT:</p>\n        <p>\"In our national territory, the Canary Islands, Ceuta and Melilla are excluded from the scope of the harmonized VAT system, although the Canary Islands are part of the Customs Union.\"</p>\n        <p>Prices for the Services may change at any time at the sole and exclusive discretion of Aicad. The Services do not provide price protection or refunds in the event of price reductions or promotional offers..</p>\n        <p>In Aicad these forms of payment are accepted:</p>\n        <ol>\n          <li>Transfer</li>\n          <li>Paypal</li>\n          <li>Credit card (SSL environment via the CaixaBank portal)</li>\n          <li>Bank Domiciliation</li>\n          <li>Fractional payments through Sequra</li>\n        </ol>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          9. CONFIRMATION OF ORDER AND SHIPPING\n        </h4>\n        <p>The order and payment confirmations, as well as all contacts with the Client, are made via email, so it is very important that the Client makes sure to include a valid email address, as well as a number of Contact telephone number in case there is an incident and the mail does not work. If the Client has doubts about the operation of the payment gateway, they can contact the customer service by email info@aicad.es or by phone (+34) 928 35 46 68.</p>\n        <p>The delivery times of the contracted products may be different depending on the case and product / service purchased. The times indicated are approximate and may vary slightly in a few days (up or down) depending on the time of year (for offline services), the circumstances of immediate availability and communication. The Client knows these circumstances and accepts them, not being a reason for the return of the order the breach of the exact term of 10 working days.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          10. ORDER FORM\n        </h4>\n        <p>In any of the systems to place the order, before making the payment, the Client will have to provide some personal data necessary to deliver the order. The fields that you must complete will be all or some of the following:</p>\n        <ul>\n          <li class=\"p-0\">\n            First name\n          </li>\n          <li class=\"p-0\">\n            Last name\n          </li>\n          <li class=\"p-0\">\n            Address\n          </li>\n          <li class=\"p-0\">\n            Postal code\n          </li>\n          <li class=\"p-0\">\n            City\n          </li>\n          <li class=\"p-0\">\n            Province\n          </li>\n          <li class=\"p-0\">\n            City\n          </li>\n          <li class=\"p-0\">\n            Phone\n          </li>\n          <li class=\"p-0\">\n            DNI/CIF/NIE for billing\n          </li>\n          <li class=\"p-0\">\n            Promotional Code (if any)\n          </li>\n        </ul>\n        <p>Once these details have been completed, the next step is to pay for the order.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          11. RETURN POLICY\n        </h4>\n        <p>The cancellation policy is applicable to people who wish to cancel their registration or registration to Aicad training and events. Enrollment in any training or event implies accepting the following conditions:</p>\n        <p><strong>Cancellation of enrollment by the student.</strong></p>\n        <p>Enrollment cancellations by the student must be reported in writing, by sending an email to the email address administracion@aicad.es. Cancellations informed by any other means are not accepted. In said email, the registration data must be included, including name and surname, telephone number and name of the training as it appears on our website.</p>\n        <p>Refund of tuition for face-to-face or blended training or events.</p>\n        <ul>\n          <li>If the student cancels the enrollment up to 20 calendar days before the start, the enrollment fee will be refunded, subtracting 15% from the full cost of the training as “management fees”. The minimum applicable for \"management expenses\" will be € 50 and the maximum € 150, justifying the possible contracting of products / services to third parties or the time used for processing / management.</li>\n          <li>If the registration is canceled up to 5 calendar days before the start of the training, the registration fee will be refunded, subtracting 50% from the full cost of the training.</li>\n          <li>There will be no refunds of the registration fee for cancellations made 5 days or less before the start of the training, when the training is in progress or after the training has finished.</li>\n          <li>The full amount of the tuition will be returned in any case if the cancellation is due to: (1) medical reasons that prevent the proper execution of the training and a doctor provides the certification, (2) extreme medical causes of a first degree relative and a doctor provides the certification, (3) Civil obligations imposed by the authorities after the date of completion of the pre-registration or enrollment, (4) Unexpected death of a first degree relative.</li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\" />\n        <p />\n        <p />\n        <p />\n        <p />\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          12. COMMERCIAL WITHDRAWAL\n        </h4>\n        <p>Withdrawal is the ability of a consumer of a good to return it to the trade within a legal period of 14 days, without having to argue or give any explanation in this regard or suffer a penalty.</p>\n        <p>The right of withdrawal may not be exercised (except for an error or defect in the product or service contracted), in the following cases provided for by article 45 of the Trade Law:</p>\n        <ul>\n          <li>Contracts for the supply of goods made according to the consumer's specifications or clearly personalized, or which, due to their nature, cannot be returned or may deteriorate or expire quickly.</li>\n          <li>Contracts for the supply of sound or video recordings, discs and computer programs that have been unsealed by the consumer, as well as computer files, supplied electronically, capable of being downloaded or reproduced immediately for permanent use.</li>\n          <li>And in general, all those products ordered remotely that are made to our measure: clothing, photographic development, etc., or that are susceptible to copying (books, music, video games, etc.).</li>\n        </ul>\n        <p>The withdrawal period for digital content products (such as online courses) will be suspended at the time the keys are used to access digital content: In accordance with art. 103, a) of Royal Legislative Decree 1/2007, of November 16: The supply of digital content that is not provided in a material medium when the execution has begun with the prior express consent of the consumer and user with the knowledge on their part that consequently you lose your right of withdrawal.</p>\n        <p>The withdrawal period for digital content products (such as courses) will be suspended at the time the keys for access to digital content are sent. The right of withdrawal, in accordance with article 103.a of Law 1/2007, will not be applicable to the provision of services, once the service has been fully executed, when the execution has begun, with the prior express consent of the consumer and user and with the acknowledgment on their part that they are aware that, once the contract has been completely executed by Aicad, they will have lost their right of withdrawal.</p>\n        <p>After accepting the execution of the contracted works, Aicad will notify you of the start date of the same. Likewise, Aicad may proceed to terminate the contract if the user does not make the corresponding payment or if any of the actions set out in the section on causes of dissolution of the contract are incurred.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          13. HOW TO CANCEL THE SERVICE CONTRACT\n        </h4>\n        <p>If you wish to cancel a contract related to the monthly services offered by Aicad, you must contact us with a request to withdraw from the contract before the contracted service has started to run (see the withdrawal process and form below). Aicad guarantees the client the reimbursement of the amounts paid within a period of fourteen (14) calendar days from the date of reliable communication of the exercise of their right of withdrawal provided that it complies with the requirements and has been accepted by Aicad.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          14. CONSEQUENCES OF WITHDRAWAL\n        </h4>\n        <p>In the event of withdrawal on your part, we will refund all payments received that you have made to us without any undue delay and, in any case, no later than 14 calendar days from the date on which we are informed of your decision to withdraw. of this contract and provided that it has been notified 10 days in advance of the start date of the contracted works.</p>\n        <p><strong>Claim or withdrawal form model</strong></p>\n        <p>The user / buyer may notify us of the claim or withdrawal, either by email to: administracion@aicad.es or by postal mail at the address indicated in the withdrawal form, indicating your name, the contracted services, dates and any other information of interest that will help identify the purchase made. You can use the following:</p>\n        <p>Withdrawal form model</p>\n        <p>(You only have to fill in and send this form if you want to withdraw from the contract)</p>\n        <ul>\n          <li>For the attention of Aicad Business School SL, with CIF B76062199, located at with registered office at Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria and which can be contacted through the portal www.aicad.es or to the email info@aicad.es:</li>\n          <li>I hereby inform you / we communicate (*) that I withdraw from me / we withdraw from our (*) sale contract of the following good / provision of the following service (*)</li>\n          <li>Ordered on / received on (*)</li>\n          <li>Name of the consumer and user or consumers and users</li>\n          <li>Address of the consumer and user or consumers and users</li>\n          <li>Signature of the consumer and user or consumers and users (only if this form is submitted on paper)</li>\n          <li>Date</li>\n          <li>Signature and stamp</li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          15. PARTIAL NULLITY\n        </h4>\n        <p>If any part of these conditions of service is contrary to Law and, therefore, invalid, this will not affect the other provisions in accordance with Law. The parties undertake to renegotiate those parts of the service conditions that are void and to incorporate them into the rest of the service conditions.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          16. APPLICABLE LAW AND JURISDICTION\n        </h4>\n        <p>For any litigious matter or that concerns the website of www.aicad.es or any of those that depends on it, Spanish legislation will be applicable, being competent for the resolution of all conflicts derived or related to the use of this website, the Courts and Tribunals of Las Palmas de Gran Canaria (Spain).</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          17. PERSONAL DATA PROTECTION\n        </h4>\n        <p>In accordance with the provisions of the General Data Protection Regulation (EU) 2016/679 (hereinafter, RGPD) and other regulations in force regarding the protection of personal data, we inform you that your personal data is treated as responsible of the treatment by AICAD BUSINESS SCHOOL SL, with registered office at Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria.</p>\n        <p>You can contact us by email at the following address: info@aicad.es and obtain any other information. Likewise, we inform you that in each commercial communication users may express their refusal to continue receiving such communications by clicking on the \"Unsubscribe\" or \"Cancel Subscription\" button.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          18. COMPLAINTS, DOUBTS AND EXERCISE OF THE RIGHT\n        </h4>\n        <p>You can direct your communications and exercise the rights of access, rectification, cancellation and opposition by ordinary mail addressed to Aicad Business School, Ref. LOPD, Calle Leon y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria, Las Palmas. To exercise these rights, and in compliance with Instruction 1/1998, of January 19, of the Data Protection Agency, it is necessary that you prove your personality to the Company by sending a photocopy of the National Identity Document or any other valid means in Law.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          19. EUROPEAN CONSUMER REGULATIONS\n        </h4>\n        <p>The European Commission has created the first European platform for the resolution of conflicts in online commerce, protected by the latest consumer law. In this sense, as those responsible for an online sales platform, we have the duty to inform our users about the existence of an online platform for alternative dispute resolution.</p>\n        <p>To use the conflict resolution platform, the user must use the following link: http://ec.europa.eu/odr</p>\n      </div>\n    </div>\n</div>"
            },
            "company-home": {
                "hero": {
                    "title": "WE HELP YOU FIND THE IDEAL CANDIDATE QUICKLY, EASY AND SAFE",
                    "subtitle": "In <span style=\"color: #D24943\">{portal}</span>, we work with you to find the ideal candidate",
                    "button": "PUBLISH A FREE OFFER"
                },
                "sections": {
                    "publish-offer": {
                        "title": "PUBLISH A JOB OFFER",
                        "publish-card": {
                            "title": "PUBLISH AN OFFER",
                            "subtitle": "Create the profile of the position you are looking for"
                        },
                        "receive-card": {
                            "title": "RECEIVE CVs IN YOUR ACCOUNT",
                            "subtitle": "We will suggest the candidates who fit the profile best"
                        },
                        "select-card": {
                            "title": "SELECT THE RIGHT ONE",
                            "subtitle": "Filter among the registered and contact the ones that interest you the most"
                        },
                        "button": "PUBLISH AN OFFER"
                    },
                    "find-talent": {
                        "title": "FIND TALENT IN OUR CVs SEARCH",
                        "findcv-card": {
                            "title": "SEARCH IN THE CVs BAG",
                            "subtitle": "Access more than 2 million CVs without having to publish an offer"
                        },
                        "interest-card": {
                            "title": "FIND THE INTEREST",
                            "subtitle": "Find out if they are interested in your job offer before paying for the CV"
                        },
                        "payment-card": {
                            "title": "PAY FOR EACH CV VIEWED",
                            "subtitle": "Pay only to see the contact details of those that interest you"
                        },
                        "button": "PUBLISH AN OFFER"
                    },
                    "partners": {
                        "title": "Thousands of companies trust {portal}"
                    },
                    "selection": {
                        "title": "WE ARE YOUR ALLY TEAM IN THE SELECTION PROCESS",
                        "subtitle": "Call us whenever you need, we will be on your side to advise you on the best solution for your offer or selection process"
                    },
                    "candidate": {
                        "title": "THE CANDIDATE YOU NEED IN THE FASTEST, EASIEST AND SAFEST WAY",
                        "button": "PUBLISH AN OFFER"
                    }
                }
            },
            "privacy-policy": {
                "content": "<div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        Privacy Policy and Legal Notice\n      </h1>\n      <p>Read our privacy policy and legal notice</p>\n      <div>\n        <h2>Ownership</h2>\n        <p>In compliance with the provisions of Law 34/2002, of July 11, on Services of the Information Society and Electronic Commerce, it is reported that the owner of this website is the following entity:</p>\n        <p class=\"text-center\">\n          AICAD BUSINESS SCHOOL SL with CIF: B76062199, Company registered in the Mercantile Registry of Las Palmas 04/30/2010 Volume 1958 book 0 Folio 116 and with registered office at Calle León y Castillo 54, 1º Planta, 35003, Las Palmas of Gran Canaria.\n        </p>\n      </div>\n      <div>\n        <h2>Acceptance of the legal notice</h2>\n        <p>We remind you that Aicad offers its products and services through the Internet platform Aicad.es (www.aicad.es), hereinafter Aicad, and the user who accesses it, either through a personal computer, or Through any application developed for \"smartphones\" or by any other means and that, where appropriate, uses the features offered by it. Consequently, the mere access to Aicad by any means implies acceptance by the user of these conditions and terms of use. You can contact us by email info@aicad.es or by phone (+34) 928 35 46 68 to request more information.</p>\n      </div>\n      <div>\n        <h2 class=\"text-uppercase\">\n          LEGAL NOTICE OF THE AICAD BUSINESS SCHOOL PORTAL\n        </h2>\n        <p>The clauses listed below regulate the conditions of use of the Internet Web Portal \"www.aicad.es\" (hereinafter, the Portal) of Aicad Business School, S.L.</p>\n        <p>The expression \"user\" includes any person who accesses the Portal, either directly or from any other Internet site. The general conditions that regulate the use of the Portal are the following:</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          1.- GENERIC.\n        </h4>\n        <p>The services offered by Aicad Business School, S.L. on this website are regulated by the clauses contained in these conditions (without prejudice to the other legal notices and conditions that appear on the Portal).</p>\n        <p>Aicad Business School, S.L. reserves the right to modify, totally or partially, these general conditions, being the new ones that it agrees from the moment they are inserted on the page.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          2.- IDENTIFICATION AND COMPANY NAME OF THE OFFERING COMPANY.\n        </h4>\n        <p>AICAD BUSINESS SCHOOL SL with CIF: B76062199, Company registered in the Mercantile Registry of Las Palmas 04/30/2010 Volume 1958 book 0 Folio 116 and with address at Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria, whose commercial name is Aicad Business School, SL</p>\n        <p>For any query, suggestion or claim, the user can go to the offices of our company located at the address mentioned above, or to the email address info@aicad.es, by phone: +34 928 35 46 68 or using the Contact Form.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          3.- CONDITIONS OF USER ACCESS.\n        </h4>\n        <p>The user undertakes to use the information contained in this Internet site for the purposes of the Portal exclusively, specifically for the purpose of obtaining information about the services offered and making suggestions and not to directly or indirectly carry out any type of exploitation commercial different from authorized uses.</p>\n        <p>The user of the website will have the right to free and free access to the public information collected therein, although Aicad Business School, S.L. reserves the right to restrict access to certain sections and services of the Portal to registered customers.</p>\n        <p>Aicad Business School, S.L. strictly prohibits the use of items restricted to a certain group of users to unauthorized users by name and password.</p>\n        <p>Aicad Business School, S.L. has made available to users authorized to access the private area of the website a name and password whose custody is the sole and exclusive responsibility of the user. Consequently, Aicad Business School, S.L. is not responsible under any circumstances for the misuse of user names and passwords.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          4.- INTELLECTUAL AND INDUSTRIAL PROPERTY.\n        </h4>\n        <p>The rights relating to industrial and intellectual property (by way of example and not limited to the brands, logos, texts, photographs, icons, images, etc., as well as the graphic design, source code and other software elements contained in this page Web), are property of Aicad Business School, SL or of the other entities that may offer information through the Portal. Therefore, they are subject to intellectual and industrial property rights protected by Spanish and international legislation.</p>\n        <p>Without the prior written authorization of Aicad Business School, S.L. or, where appropriate, of the entity that owns the rights, it is not allowed to use, reproduce, transmit, manipulate, as well as make any use that exceeds the visit of the page and the use of the services offered.</p>\n        <p>Access to the services provided does not imply on the part of Aicad Business School, SL, nor on the part of the respective owner, waiver, transmission, or total or partial transfer of the rights derived from intellectual and industrial property, nor does it attribute rights of use, alteration, exploitation, reproduction, distribution or public communication of these contents without the prior and express authorization in writing of the respective holders of said rights, without prejudice to the right to view and obtain a private security copy of such contents, provided that said right is exercised according to the principles of good faith and provided that the intellectual and industrial property of the owner of such rights remains unaltered, it is used for non-commercial purposes and exclusively for the user's personal information.</p>\n        <p>The responsibility derived from the use of materials protected by the intellectual and industrial property rights contained in this page will correspond exclusively to the user.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          5.- OBJECT OF THE PORTAL.\n        </h4>\n        <p>This page has been designed by Aicad Business School, S.L. to provide information about its services and other activities of the company. The web pages have contact information and forms through which users can contact the company for the purposes provided in each case, according to the regulation of the Portal clauses.</p>\n        <p>The mere access to the Website, the completion of forms, the sending of information requests, inquiries, complaints, hiring offers, curriculum vitae and, in general, any act of a similar nature to the previous ones carried out through the forms and / or electronic mailboxes on the Website will imply, for its part, the unreserved acceptance of each and every one of the standards that make up this Legal Notice and the acquisition of the consideration of User of the Website. Consequently, you must carefully read and know the content of this Legal Notice.</p>\n        <p>Aicad Business School, S.L. reserves the right to make as many modifications and updates as it deems appropriate on the website.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          6.- DISCLAIMER OF LIABILITY.\n        </h4>\n        <p>Aicad Business School, S.L. will not be liable for interruptions that may occur in electrical or telecommunications services that prevent users from using the services offered. Aicad Business School, S.L. will not respond to any possible liability for damages of any kind that may be due to the lack of veracity, validity, completeness or authenticity of the information provided by users.</p>\n        <p>Likewise, Aicad Business School, S.L. It will not be liable for the Web pages to which it may refer through links, banners or other devices, nor for the content that they may include.</p>\n      </div>\n    </div>\n\n    <div class=\"bg-card p-4\">\n      <h1 class=\"--bold\">\n        PERSONAL DATA PROTECTION\n      </h1>\n      <h2>For what purpose do we process your personal data?</h2>\n      <p>In accordance with the provisions of the General Data Protection Regulation (EU) 2016/679 (hereinafter, RGPD) and other regulations in force regarding the protection of personal data, we inform you that your personal data is treated as responsible of the treatment by AICAD BUSINESS SCHOOL SL (hereinafter, Aicad), with registered office at Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria.</p>\n      <div>\n        <h4 class=\"--bold\">\n          a) Infiormation\n        </h4>\n        <p>The information received by Aicad Business School, S.L. Through any of its web pages it will be treated with the utmost reserve and confidentiality in accordance with current regulations.</p>\n        <p>Aicad Business School S.L. will process your personal data in order to manage the relationship you have with us, as well as to send you commercial communications by any means, even after the relationship with you has ended, to keep you informed of those of our products and services similar to those contracted by you.</p>\n      </div>\n      <div>\n        <h4 class=\"--bold\">\n          b) Sending and recording of personal data\n        </h4>\n        <p>Sending personal data on this website is mandatory to contact, comment on or contract any product available for sale on our website.</p>\n        <p>Likewise, not providing the requested personal data or not accepting this data protection policy means that it is impossible to subscribe to content and process requests made on this website.</p>\n        <p>You do not need to provide any personal data to browse this website.</p>\n        <p>The cases in which this website requires personal data are:</p>\n        <ul>\n          <li class=\"p-0\">\n            Para realizar la suscripción a la newsletter\n          </li>\n          <li class=\"p-0\">\n            To comment on posts published on the blog.\n          </li>\n          <li class=\"p-0\">\n            To download some of the materials offered on the blog.\n          </li>\n          <li class=\"p-0\">\n            To make inquiries through the contact form.\n          </li>\n          <li class=\"p-0\">\n            To share content on social networks.\n          </li>\n          <li class=\"p-0\">\n            To apply for job offers.\n          </li>\n          <li class=\"p-0\">\n            To contract the services available on this website\n          </li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"--bold\">\n          c) Exercise of ARCO rights, the right to be forgotten and portability\n        </h4>\n        <p>To exercise the rights of access, rectification, oblivion, portability, cancellation and opposition provided for in the Law, you can write <strong> to Aicad Business School, S.L. Ref. Data protection, Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria or to the email address info@aicad.es. </strong> In the event that there is no contractual relationship, You can delete your account whenever you want from the user panel, accessing your customer profile.</p>\n        <p>Aicad Business School, S.L. declares and guarantees that it maintains the security levels of protection of personal data in accordance with Royal Decree 994/1999, of June 11, regarding the security measures of automated files that contain personal data; that it has established all the technical means at its disposal to prevent the loss, misuse, alteration, unauthorized access and theft of data provided by users, without prejudice to informing that Internet security measures are not impregnable.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          EXACTITUD Y VERACIDAD DE LOS DATOS\n        </h4>\n        <p>The user is solely responsible for the veracity and correctness of the data sent to the portal (or to its affiliates, partners and collaborators), exonerating the Provider from any responsibility in this regard. Users guarantee and respond, in any case, to the accuracy, validity and authenticity of the personal data provided, and undertake to keep them duly updated. The user agrees to provide complete and correct information in the contact or subscription form.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          ACCEPTANCE AND CONSENT\n        </h4>\n        <p>The legal basis for the processing of your personal data is the execution and maintenance of the relationship with you, as well as the express consent that, where appropriate, you have provided us for additional treatments consisting of sending your own commercial communications and / or or third parties, the preparation of commercial profiles and the transfer of said data and profiles for the purposes indicated in the section \"Sending and recording of personal data\" Previous.</p>\n        <p>For any other use other than those expressly permitted, it will be necessary to obtain the prior written consent of the owner of the rights in question.</p>\n        <p><strong>The acceptance and consent of the interested party:</strong> In those cases where to make a request it is necessary to fill out a form and click on the send button, our forms have the symbol * in the mandatory data. If you do not provide these fields, or do not mark the \"checkbox\" of acceptance of the privacy policy, the sending of the information will not be allowed. Normally it has the following formula: \"□ I have read and accept the Privacy and / or Data Protection Policy.\"</p> \n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          PERSONAL DATA CAPTURE SYSTEMS USED BY THIS WEBSITE\n        </h4>\n        <p>This website uses different systems for capturing personal information. This website always requires the prior consent of users to process their personal data for the indicated purposes.</p>\n        <p>The user has the right to revoke their prior consent at any time.</p>\n        <p>Personal information capture systems used by Aicad:</p>\n        <p>1)  Content subscription forms: within the web there are several forms to activate the subscription. You will need to confirm your subscription in order to validate your email address. The data provided will be used exclusively to send the Newsletter and keep you updated on news and specific, exclusive offers.</p>\n        <p>2)  Comments form: The web includes a form to comment on articles, leave your review for the products and / or other posts of the personalized type. The user will be able to post comments on the posts that are published. The personal data entered in the form to insert these comments will be used exclusively to moderate and publish them.</p>\n        <p>3)  Contact form: There is also a contact form for inquiries, suggestions or service contracting. In this case, the email address will be used to respond to them and send the information that the user requires through the web.</p>\n        <p>4)  Cookies: When the user registers or browses this website, \"cookies\" are stored. The user can consult the cookie policy at any time to expand information on the use of cookies and how to deactivate them.</p>\n        <p>5)  Download Systems: On this website you can download different content that is periodically incorporated into our blog, in other portals belonging to Aicad and users have the possibility of downloading any course syllabus in PDF format.</p>\n        <p>6)  Navigation and IP Address: When browsing this website, the user automatically provides the web server with information regarding your IP address, date and time of access, the hyperlink that has been forwarded to them, your operating system and the browser used. The Spanish Agency for Data Protection considers the IP as personal data. This website will not use the IP to identify its users, this data will be saved and used only for the control and realization of statistics of access and visits to the web, to analyze trends, administer the site, and to collect demographic information on our basis of users as a whole. In no case will they be communicated or transferred to third parties.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          COMMERCIAL MAIL\n        </h4>\n        <p>In accordance with the LSSICE, Aicad does not carry out SPAM practices, so it does not send commercial emails that have not been previously requested or authorized by the User, on some occasions, it may send its own promotions and offers and those of third parties, only in cases where you have the authorization of the recipients. Consequently, in each of the forms on the Website, the User has the possibility of giving their express consent to receive my “Newsletter”, regardless of the commercial information requested on time. You can also cancel your subscription automatically in the same Newsletters.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          SECURITY MEASURES\n        </h4>\n        <p>In accordance with current legislation, the person in charge of this site has adopted the levels and security measures for the protection of personal data established in the General Data Protection Regulation (EU) 2016/679 for the protection of personal data. personal, respecting the obligations and the duty of confidentiality established by law, and installing in their systems and files the necessary technical measures to guarantee the confidential treatment of the data, avoid its loss, alteration and unauthorized access.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          Child protection policy\n        </h4>\n        <p>Whoever provides the data through the forms on this website and accepts its treatment formally declares to be over 14 years of age. Access to and use of the portal to minors under 14 years of age is prohibited.</p>\n        <p>Aicad reminds people of legal age who are in charge of minors, that it will be their sole responsibility if a minor incorporates their data to request a service.</p>\n        <p>It also informs them that there are computer programs to limit browsing by filtering or blocking certain content.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          APPLICABLE LEGISLATION\n        </h4>\n        <p>All disputes, controversies or claims arising from the interpretation or execution of the general conditions of sale will be governed by Spanish law, and will be subject to the jurisdiction of the Courts and Tribunals of the domicile of the owner of the Website.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          CHANGES TO THIS PRIVACY POLICY\n        </h4>\n        <p>Aicad Business School reserves the right to modify this policy to adapt it to new legislation or jurisprudence, as well as industry practices. In such cases, the Provider will announce on this page the changes introduced with reasonable anticipation of their implementation.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          CONFIDENTIALITY\n        </h4>\n        <p>All information and documentation used during the contracting, development and execution of the contractual conditions that regulate the relations between Aicad and the Client is confidential. Confidential information shall not be understood as that which is disclosed by agreement between the Parties, that which becomes public for the same reason or that which has to be disclosed in accordance with the law or with a judicial resolution of a competent authority, and that which is obtained by a third party that is not under any obligation of confidentiality. Both parties undertake to comply with the duty of confidentiality and to maintain it for a minimum period of two (2) years after the end of the aforementioned contractual conditions that regulate the relations of Aicad and the Client.</p>\n        <p>All information received by the client, be it images, texts, access data such as WordPress users and passwords, hosting or others, will be treated confidentially, the transfer to third parties being totally prohibited unless we have their consent and always for the same purpose for which the data has been obtained.</p>\n      </div>\n    </div>\n  </div>"
            },
            "cookies-policy": {
                "content": "  <div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        COOKIES POLICY\n      </h1>\n      <p>We give you the warmest welcome to Aicad Business School!</p>\n      <div class=\"mt-5\">\n        <p>The parties that are linked through these conditions are Aicad Business School SL, with registered office at Calle León y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria CIF B76062199, Company registered in the Mercantile Registry of Las Palmas 30 / 04/2010 Volume 1958 book 0 Folio 116, which offers its products and services through the Internet platform Aicad.es (www.aicad.es), hereinafter Aicad, and the user who accesses it, either Through a personal computer, either through any application developed for \"smartphones\" or by any other means and which, where appropriate, uses the services offered by it. Consequently, the mere access to Aicad by any means implies acceptance by the user of these conditions and terms of use. You can contact us by email info@aicad.es or by phone (+34) 928 35 46 68 to request more information.</p>\n      </div>\n    </div>\n\n    <div class=\"bg-card p-4\">\n      <div>\n        <h2 class=\"text-uppercase --bold\">\n          COOKIES POLICY\n        </h2>\n        <p>A cookie is a small text file that is stored in your browser when you visit almost any web page. Its usefulness is that the web is able to remember your visit when you return to browse that page. Cookies usually store technical information, personal preferences, content personalization, usage statistics, links to social networks, access to user accounts, etc. The purpose of the cookie is to adapt the content of the web to your profile and needs, without cookies the services offered by any page would be significantly reduced. If you want to consult more information about what cookies are, what they store, how to delete them, deactivate them, etc.</p>\n        \n        <p><strong>Cookies used on this website</strong></p>\n        <table style=\"width{100}%\">\n          <tr>\n            <th>TYPE OF COOKIES</th>\n            <th>PURPOSE</th>\n          </tr>\n          <tr>\n            <td>OF OPERATION</td>\n            <td>These cookies allow navigation through the web and the use of the different options or services that are provided. They are also used to improve your browsing experience and to optimize the operation of our website. They store service configurations so that the user does not have to reconfigure them each time they visit us.</td>\n          </tr>\n          <tr>\n            <td>ANALYTICS</td>\n            <td>These cookies are used to collect information about the use of our website by visitors. We use the information to compile reports and to improve the site. These cookies are only associated with an anonymous user and their computer / device without providing references that allow knowing personal data. They collect the number of visitors to the site, the duration of the visits, the browser, the type of terminal, the place of origin of the visitors and the pages visited.</td>\n          </tr>\n          <tr>\n            <td>OF GEOLOCATION</td>\n            <td>These cookies are used to store geolocation data of the computer and devices to offer more appropriate services and content.</td>\n          </tr>\n        </table>\n        <p class=\"mt-4\">\n        Following the guidelines of the Spanish Agency for Data Protection, we proceed to detail the use of cookies made by this website in order to inform you as accurately as possible.\n        </p>\n        <p>This website uses the following own cookies:</p>\n        <li>Session cookies, to ensure that users who write comments on the blog are human and not automated applications. In this way spam is fought.</li>\n        <p>This website uses the following third-party cookies:</p>\n        <li>Google Analytics: Stores cookies to be able to compile statistics on the traffic and volume of visits to this website. By using this website you are consenting to the processing of information about you by Google. Therefore, the exercise of any right in this regard must be done by communicating directly with Google.</li>\n        <li>Social networks: Each social network uses its own cookies so that you can click on buttons such as Like or Share.</li>\n        <p class=\"mt-4\">\n          <strong>Deactivation or elimination of cookies</strong>\n        </p>\n        <p>At any time you can exercise your right to deactivate or delete cookies from this website. These actions are performed differently depending on the browser you are using. Later we give specific instructions for any type of browser.</p>\n        \n        <p class=\"mt-4\">\n          <strong>Additional notes</strong>\n        </p>\n        <ul>\n          <li>Neither this website nor its legal representatives are responsible for the content or the veracity of the privacy policies that the third parties mentioned in this cookie policy may have.</li>\n          <li>Web browsers are the tools in charge of storing cookies and from this place you must exercise your right to eliminate or deactivate them. Neither this website nor its legal representatives can guarantee the correct or incorrect handling of cookies by the aforementioned browsers.</li>\n          <li>In some cases it is necessary to install cookies so that the browser does not forget your decision not to accept them.</li>\n          <li>In the case of Google Analytics cookies, this company stores cookies on servers located in Spain and undertakes not to share them\n          with third parties, except in cases where it is necessary for the operation of the system or when the law requires it to do so.</li>\n          <li>WEB ANALYTICS: The website uses Google Analytics, a web analytics service provided by Google, Inc., a Delaware company whose main office is at 1600 Amphitheater Parkway, Mountain View (California), CA 94043, United States (“Google”) . Google Analytics uses “cookies”, which are text files located on your computer, to help the website analyze how users use the website. The information generated by the cookie about your use of the website (including your IP address) will be directly transmitted and filed by Google on servers in the United States. Google will use this information on our behalf in order to keep track of your use of the website, compiling reports on website activity and providing other services related to website activity and Internet use. Google may transmit said information to third parties when required by law, or when said third parties process the information on behalf of Google. Google will not associate your IP address with any other data that Google has. You can reject the treatment of data or information by rejecting the use of cookies by selecting the appropriate configuration of your browser, however, you should know that if you do so, you may not be able to use the full functionality of this website. By using this website, you consent to the processing of information about you by Google in the manner and for the purposes indicated above.</li>\n          <li>For any questions or queries about this cookie policy, do not hesitate to contact us through the contact section.</li>\n        </ul>\n\n        <p class=\"mt-4\">\n          <strong>¿What is a cookie?</strong>\n        </p>\n        <p>A cookie is a harmless text file that is stored in your browser when you visit almost any web page. The usefulness of the cookie is that the web is able to remember your visit when you return to browse that page. Although many people do not know it, cookies have been used for 20 years, when the first browsers for the World Wide Web appeared.</p>\n\n        <p class=\"mt-4\">\n          <strong>What is NOT a cookie?</strong>\n        </p>\n        <p>It is not a virus, not a Trojan, not a worm, not spam, not spyware, nor does it open pop-up windows.</p>\n\n        <p class=\"mt-4\">\n          <strong>What information does a cookie store?</strong>\n        </p>\n        <p>Cookies do not usually store sensitive information about you, such as credit cards or bank details, photographs, your ID or personal information, etc. The data they keep is of a technical nature, personal preferences, personalization of content, etc.</p>\n        <p>The web server does not associate you as a person but with your web browser. In fact, if you regularly browse with Internet Explorer and try to browse the same website with Firefox or Chrome, you will see that the website does not realize that you are the same person because it is actually associating the browser, not the person.</p>\n\n        <p class=\"mt-4\">\n          <strong>What type of cookies are there?</strong>\n        </p>\n        <ul>\n          <li>Technical cookies: These are the most basic and allow, among other things, to know when a human or an automated application is browsing, when an anonymous user and a registered user are browsing, basic tasks for the operation of any dynamic website.</li>\n          <li>Analysis cookies: They collect information about the type of navigation you are doing, the sections you use the most, products consulted, time zone of use, language, etc.</li>\n          <li>Advertising or commercial cookies: They can periodically show advertising based on your browsing, your country of origin, language, etc.</li>\n          <li>Affiliate Cookies: They track our affiliate network to help them report sales.</li>\n        </ul>\n        \n        <p class=\"mt-4\">\n          <strong>What are own and third party cookies?</strong>\n        </p>\n        <p>Own cookies are those generated by the page you are visiting and those of third parties are those generated by external services or providers such as Facebook, Twitter, Google, etc.</p>\n\n        <h2>Typology, purpose and operation of Cookies in Aicad.es</h2>\n        <table style=\"width{100}%\">\n          <tr>\n            <th>Business</th>\n            <th>Domain</th>\n            <th>Name of the cookie</th>\n            <th>Objective / Purpose</th>\n          </tr>\n          <tr>\n            <td>Aicad</td>\n            <td>Aicad.es</td>\n            <td>cdp-cookies-plugin-wp / __smToken /sc_is_visitor_unique / pll_language/ SnapABugHistory/ PHPSESSID/ __hstc / hubspotutk /SnapABugChatWindow / _gat_pub_social / _gat_shr_post_share / woocommerce / __zlcmid / ssupp.chatid / tk_r3d / euCookiesAcc</td>\n            <td>These cookies are intended to improve website navigation. Some have the characteristic that they are persistent and others only session</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Google.com</td>\n            <td>HSID/ SID/ Conversion</td>\n            <td>They are used by Google to verify the user account and the most recent login</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Adwords</td>\n            <td>test_cookie / _ads   /    ga-audiences / ads/user-lists/#</td>\n            <td>Advertising service</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Analytics</td>\n            <td>__utmv / _ga</td>\n            <td>Used for Google Analytics</td>\n          </tr>\n          <tr>\n            <td>Twitter</td>\n            <td>Twitter</td>\n            <td>guest_id</td>\n            <td>Use Twitter to verify the user account</td>\n          </tr>\n          <tr>\n            <td>Alexa</td>\n            <td>Alexa.com</td>\n            <td>tbver</td>\n            <td>Barra Alexa</td>\n          </tr>\n          <tr>\n            <td>Facebook</td>\n            <td>Facebook.com</td>\n            <td>datr</td>\n            <td>Utilizada por Faceebook para validar al usuario</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>TAGMANAGER</td>\n            <td>ym_metrika_enabled_   / _gat /   _gid / yabs-sid</td>\n            <td>Used by Google TagManager to improve the user experience and offer content related to their interests.</td>\n          </tr>\n        </table>\n\n        <p class=\"mt-4\">\n          <strong>What are own and third party cookies?</strong>\n        </p>\n        <p>To understand the scope of disabling cookies, we show you some examples:</p>\n        <ul>\n          <li>You will not be able to share content from that website on Facebook, Twitter or any other social network.</li>\n          <li>The website will not be able to adapt the contents to your personal preferences, as is often the case in online stores.</li>\n          <li>You will not be able to access the personal area of that website, such as My account, or My profile or My orders.</li>\n          <li>Online stores: It will be impossible for you to make purchases online, they will have to be by phone or visiting the physical store if you have one.</li>\n          <li>It will not be possible to customize your geographical preferences such as time zone, currency or language.</li>\n          <li>The website will not be able to perform web analytics on visitors and traffic on the web, which will make it difficult for the web to be competitive.</li>\n          <li>You will not be able to write on the blog, you will not be able to upload photos, post comments, rate or rate content. The web will also not be able to know if you are a human or an automated application that publishes spam.</li>\n          <li>Business tracking will not be possible, which will reduce the revenue of our affiliate network.</li>\n          <li>All social networks use cookies, if you deactivate them you will not be able to use any social network.</li>\n          <li>You will not be able to access periodic promotions, your user, publisher or affiliate account.</li>\n        </ul>\n\n        <p class=\"mt-4\">\n          <strong>Can you delete cookies?</strong>\n        </p>\n        <p>Yes. Not only delete, but also block, in a general or particular way for a specific domain.</p>\n        <p>To delete cookies from a website, you must go to your browser settings and there you can search for those associated with the domain in question and proceed to delete them.</p>\n      \n        <p class=\"mt-4\">\n          <strong>Cookie settings for the most popular browsers</strong>\n        </p>\n        <p>Here's how to access a specific cookie from the Chrome browser. Note: these steps may vary depending on the browser version:</p>\n        <ol>\n          <li>Go to Settings or Preferences through the File menu or by clicking on the customization icon that appears in the upper right.</li>\n          <li>You will see different sections, click the option Show advanced options.</li>\n          <li>Go to Privacy, Content Settings.</li>\n          <li>Select All cookies and site data.</li>\n          <li>A list will appear with all the cookies ordered by domain. To make it easier for you to find the cookies of a certain domain, enter the address partially or completely in the Search for cookies field.</li>\n          <li>After performing this filter, one or more lines with the cookies of the requested web will appear on the screen. Now you just have to select it and press the X to proceed with its elimination.</li>\n        </ol>\n        <p>To access the cookie settings of the Internet Explorer browser, follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Go to Tools, Internet Options</li>\n          <li>Click on Privacy.</li>\n          <li>Move the slider to adjust the level of privacy you want.</li>\n        </ol>\n        <p>To access the cookie settings of the Firefox browser, follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Go to Options or Preferences depending on your operating system.</li>\n          <li>Click on Privacy.</li>\n          <li>Under History choose Use custom settings for history.</li>\n          <li>Now you will see the option Accept cookies, you can activate or deactivate it according to your preferences.</li>\n        </ol>\n        <p>To access the cookie settings of the Safari browser for OSX follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Go to Preferences, then Privacy.</li>\n          <li>In this place you will see the option Block cookies so that you can adjust the type of block you want to perform.</li>\n        </ol>\n        <p>To access the cookie settings of the Safari browser for iOS follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Go to Settings, then Safari.</li>\n          <li>Go to Privacy and Security, you will see the option Block cookies to adjust the type of block you want to perform.</li>\n        </ol>\n        <p>To access the cookie settings of the Microsoft Windows Edge browser, follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Go to the sidebar by clicking on the 3 dots to open the General Settings.</li>\n          <li>Go to Advanced Settings, you will see the option Block cookies to adjust the type of blocking you want to perform.</li>\n        </ol>\n        <p>To access the browser cookie settings for Android devices, follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Launch the browser and press the Menu key, then Settings.</li>\n          <li>Go to Security and Privacy, you will see the option Accept cookies to enable or disable the box.</li>\n        </ol>\n        <p>To access the browser cookie settings for Windows Phone devices follow these steps (they may vary depending on the browser version):</p>\n        <ol>\n          <li>Open Internet Explorer, then More, then Settings</li>\n          <li>You can now enable or disable the Allow cookies box.</li>\n        </ol>\n      </div>\n    </div>\n  </div>"
            },
            "login": {
                "login": {
                    "title": "Access",
                    "email-resend": "or Resend the verification email.",
                    "button": "LOGIN",
                    "forgot-password": "Forgot your password?"
                },
                "register": {
                    "title": "Are you a candidate?",
                    "subtitle": "We have the professional opportunity you are looking for!",
                    "the-point": "Access new career opportunities every day",
                    "first-point-title": "Bag of qualified CVs",
                    "first-point-subtitle": "Thousands of resumes by specialty",
                    "second-point-title": "Diversity of profiles",
                    "second-point-subtitle": "You can find commercial, administrative, programmer ...",
                    "third-point-title": "We help you get it",
                    "third-point-subtitle": "We take care of attracting the largest network of qualified professionals",
                    "first-offer": "Publish your 1st offer",
                    "button": "Register now!"
                },
                "register-company": {
                    "title": "Are you a company?",
                    "subtitle": "We have the professional opportunity you are looking for!",
                    "work-success": "We work to succeed",
                    "best-opportunities": "The best opportunities in Planetajob!",
                    "first-point-title": "Bag of qualified CVs",
                    "first-point-subtitle": "Thousands of resumes by specialty",
                    "second-point-title": "Diversity of profiles",
                    "second-point-subtitle": "You can find commercial, administrative, programmer ...",
                    "third-point-title": "We help you get it",
                    "third-point-subtitle": "We take care of attracting the largest network of qualified professionals",
                    "first-offer": "Publish your 1st offer",
                    "button": "Register now!"
                },
                "email-resent": "Email resent!"
            },
            "register": {
                "title": "Create your account",
                "try-again": "Please try again.",
                "hotmail-warning": "We are having trouble verifying Hotmail and Outlook mail. Please use gmail or another type of alternative email. Thank you for your patience.",
                "im-a-company": "I am a company",
                "company-type": {
                    "company": "Company",
                    "temporar": "ETT",
                    "headhunter": "Headhunter",
                    "hr": "Human Resources Consultant"
                },
                "invalid-cif": "Invalid CIF or NIF",
                "read-the": "I have read and accept the",
                "accept-conditions": "Please accept the conditions",
                "button": "CREATE ACCOUNT"
            },
            "forgot-password": {
                "title": "Forgot your password?",
                "instructions": "We will send you the instructions to reset your password to your email.",
                "reset-password": "Reset your password",
                "success-message": "Email successfully sent to {email}. Please follow the instructions sent to your email."
            },
            "reset-password": {
                "title": "Reset the password",
                "instructions": "In order to reset your password, please enter the requested details.",
                "new-password": "Enter new password",
                "repeat-new-password": "Repeat new password",
                "change-password": "CHANGE PASSWORD",
                "oops": "Oops... You shouldn't be here...",
                "if-error": "If you think this is an error, please contact administration.",
                "success-msg": "Password successfully changed! You can now login to your account, using your new password.",
                "error-msg": "We were unable to reset the password using the information you've provided. Try to request another password reset link or if the problem persists - contact support.",
                "request-link": "REQUEST LINK"
            },
            "verify-email": {
                "verifying": "Verifying...",
                "success-msg": "Your email has been verified successfully. Now you can log into your account.",
                "success": "Cuenta verificada con éxito"
            },
            "dashboards": {
                "navigation": {
                    "dashboard": "Dashboard",
                    "all-offers": "All offers",
                    "offers": "Offers",
                    "candidates": "Candidates",
                    "companies": "Companies",
                    "users": "Users",
                    "payments": "Payments",
                    "promo-codes": "Promo codes",
                    "referrals": "Referrals",
                    "delegations": "Delegations",
                    "headhunters": "Headhunters",
                    "publish-offer": "Publish an offer",
                    "your-offers-and-applications": "Your offers and candidates",
                    "all-your-candidates": "All your candidates",
                    "applications": "Candidates",
                    "my-cv": "My CV",
                    "my-account": "My account"
                },
                "admin": {
                    "statistics": {
                        "offers": {
                            "title": "Total offers",
                            "total-candidates": "Total candidates"
                        },
                        "companies": {
                            "title": "Total companies",
                            "confirmed": "Condirmed",
                            "pending": "Pending",
                            "rejected": "Rejected"
                        },
                        "users": {
                            "title": "Total users",
                            "companies": "Companies",
                            "users": "Users"
                        }
                    }
                },
                "candidate": {
                    "hello": "Hello, {name}!",
                    "stat-cards": {
                        "offers": {
                            "title": "New offers",
                            "subtitle": "published in the last 24 hours"
                        },
                        "cv": {
                            "title": "Who sees your CV?",
                            "subtitle": "Keep your CV updated and increase the chances of boosting your professional career",
                            "link": "Go to my CV"
                        },
                        "applications": {
                            "title": "Active applications",
                            "subtitle": "There are news in your application",
                            "link": "Go to Applications"
                        }
                    },
                    "new-offers": {
                        "title": "New offers",
                        "no-offers": "There are no new offers that match your CV at this time."
                    }
                },
                "employer": {
                    "verification": {
                        "info": "Your company account(<strong>{companyTitle}</strong>) is limited.\n                You cannot publish offers until the Administrator of {appName} confirms your account.\n                Our staff will contact you in the next 48 hours by phone\n                provided on registration (<strong>{companyPhone}</strong>).",
                        "wrong-phone": "Wrong phone number?",
                        "update-profile": "Update it in your profile",
                        "rejected-info": "Unfortunatelly, your company account (<strong>{companyTitle}</strong>)\n                has been <strong><i>Rejected</i></strong>! Your contact details looked suspicous for our\n                team of {appName}. Thanks for your understanding."
                    },
                    "free-offer-alert": "Congratulations! You have <strong>{offersCount}</strong> free offer(s)",
                    "free-offer-alert-expire": "The free offer will expire on {offerExpirationDateFormatted}",
                    "publish": {
                        "title": "Publish a job offer now:",
                        "switch": {
                            "standart": "Standard plans",
                            "corporate": "Corporate plans"
                        }
                    },
                    "standard": {
                        "basic": {
                            "label": "Basic offer",
                            "header": "Basic announcement",
                            "footer": {
                                "line-1": "Infoempleo",
                                "line-2": "Social networks"
                            }
                        },
                        "standard": {
                            "label": "Standard offer",
                            "header": "Standard announcement",
                            "footer": {
                                "line-1": "LinkedIn",
                                "line-2": "Infoempleo",
                                "line-3": "Social networks"
                            }
                        },
                        "premium": {
                            "label": "Premium offer",
                            "header": "Corporate announcement",
                            "footer": {
                                "line-2": "Infoempleo",
                                "line-1": "LinkedIn",
                                "line-3": "Infojobs",
                                "line-4": "Social networks"
                            }
                        }
                    },
                    "corporate": {
                        "standard": {
                            "label": "x10 in 3 portals",
                            "header": "Standard pack",
                            "footer": {
                                "line-1": "Infoempleo",
                                "line-2": "Social networks"
                            }
                        },
                        "company": {
                            "label": "x25 in 4 portals",
                            "header": "Company pack",
                            "footer": {
                                "line-1": "LinkedIn",
                                "line-2": "Infoempleo",
                                "line-3": "Social networks"
                            }
                        },
                        "corporate": {
                            "label": "x100 in 5 portals",
                            "header": "Corporate pack",
                            "footer": {
                                "line-2": "Infoempleo",
                                "line-1": "LinkedIn",
                                "line-3": "Infojobs",
                                "line-4": "Social networks"
                            }
                        }
                    },
                    "headhunter": {
                        "title": "Are you Headhunter?",
                        "card": {
                            "header": "Headhunter Offer",
                            "title": "We help you to get it",
                            "subtitle": "We search and screen curricula to",
                            "subtitle2": "SUCCESS",
                            "button": "CONTACT US",
                            "content": "We do the entire selection process without you having to worry about anything. 10% of gross annual salary for IT, medical and specialist positions.",
                            "cols": {
                                "first": {
                                    "title": "We take care of the entire process",
                                    "first-point": "Publication of offers",
                                    "second-point": "CV screening",
                                    "third-point": "Potential candidate interviews"
                                },
                                "second": {
                                    "title": "Written report of the ideal profiles",
                                    "first-point": "Final interview coordination",
                                    "second-point": "Evaluation and follow-up for 3 months"
                                }
                            }
                        }
                    }
                },
                "hr": {
                    "hello": "Hello {name},",
                    "actions": "Actions",
                    "all-offers": "Offers",
                    "all-users": "Candidates",
                    "all-delegations": "Dlegations",
                    "no-companies-warning": "You have no companies assigned! You will not be able to see any offers or users."
                }
            },
            "one-company": {
                "company-control": {
                    "company-data": "Company data",
                    "confirm": "Are you sure you want to <strong style=\"color: green\">CONFIRM</strong> this company?",
                    "reject": "Are you sure you want to <strong style=\"color: red\">REJECT</strong> this company?",
                    "delete": "Are you sure you want to <strong style=\"color: red\">DELETE</strong> this company?",
                    "undo": "You cannot undo this action!",
                    "adminNote": {
                        "title": "Private Note:",
                        "no-note": "No note yet...",
                        "btnAdd": "Add note",
                        "btnEdit": "Edit note",
                        "modal": {
                            "title": "Modify Private Note",
                            "formLabel": "Enter private note:",
                            "formValidation": "Maximum 1000 characters!"
                        }
                    }
                }
            },
            "one-offer": {
                "no-company-name": "Company name not available",
                "requirements": "Requirements",
                "minimum-studies": "Minimum studies",
                "minimum-experience": "Minimum experience",
                "necessary-knowledge": "Necessary knowledge",
                "description": "Description",
                "category": "Offer category",
                "industry-type": "Offer industry type",
                "contract-type": "Contract type",
                "level": "Level",
                "number-vacancies": "Vacancy numbers",
                "salary": "Salary",
                "salary-from-to": "{min} - {max} {type}",
                "salary-more-than": "More than {min} {type}",
                "salary-dont-show": "Salary not available",
                "benefits": "Benefits",
                "other-benefits": "Other",
                "apply-to-this-offer": "Apply to this offer",
                "already-enrolled": "Already applied",
                "archived": "Archived",
                "published": "Published",
                "sidebar": {
                    "share-offer": {
                        "title": "Share this offer",
                        "default-message": "I have found a job offer in {portal}"
                    },
                    "courses": {
                        "title": "Expand your training",
                        "course1": {
                            "title": "The impact of the coronavirus on the international economic environment",
                            "url": "https://www.aicad.es/el-impacto-del-coronavirus-en-el-entorno-economico-internacional"
                        },
                        "course2": {
                            "title": "Investment Management and Real Estate Assets",
                            "url": "https://www.aicad.es/master-en-gestion-de-inversiones-y-patrimonios-inmobiliarios"
                        },
                        "course3": {
                            "title": "Marketing Intelligence Specialist",
                            "url": "https://www.aicad.es/especialista-en-marketing-intelligence"
                        },
                        "see-more": "See more courses",
                        "see-more.url": "https://www.aicad.es/cursos-online"
                    }
                }
            },
            "offer-apply": {
                "title": "Application in:",
                "current-document": "Your current CV document:",
                "last-updated": "Last update on: {date}",
                "presentation-text": {
                    "text": "Cover letter for this offer:",
                    "dont-include": "Don't include letter",
                    "include": "Create a letter"
                },
                "alert": {
                    "correct-errors": "Please correct the errors in the form",
                    "answer-killer-questions": "Please answer some killer questions"
                },
                "answer-questions": "Please answer the following questions:",
                "confirm": "CONFIRM YOUR APPLICATION",
                "cv-warning": {
                    "title": "Oops! It looks like you haven't completed your CV yet!",
                    "subtitle": "In order to apply for job offers, you must complete the necessary information on your CV.",
                    "button": "Go to My CV now"
                },
                "sidebar": {
                    "title": "Offer details",
                    "company": "Company",
                    "place": "Location",
                    "salary": "Salary",
                    "publish-date": "Publication date",
                    "min-exp": "Minimal experience",
                    "contract-type": "Type of contract"
                }
            },
            "copy-offer": {
                "title": "Publish this offer in other provinces",
                "subtitle": "To publish this offer in other provinces you must enter the discount code*",
                "obtain-promo": "*To obtain your discount code you must contact the portal administrator through the email info@plantetajob.es",
                "promo-applied": "Congratulations! You got free copy to <strong> {discount} </strong> provinces!",
                "promo-invalid": "Promo code is invalid!",
                "promo-placeholder": "Enter the code",
                "promo-apply": "APPLY",
                "add": "Add",
                "dialog-title": "Are you sure you want to create {number} records? *",
                "dialog-warning": "*WARNING: if you click OK, <strong style=\"font-size: 1rem\"> {provincesSelected}</strong> records will be created",
                "save-sucess": "Successfully saved {savedCount} offers.",
                "view-offers": "View my offers",
                "alert": {
                    "must-enter-valid-promo": "Must enter valid promo code!",
                    "can-only-copy-to": "You can only make a copy to {count} provinces with this promo code"
                }
            },
            "offer-intern": {
                "no-candidates": "No candidates yet",
                "rejected-interns": {
                    "title": "Rejected candidates"
                }
            },
            "my-applications": {
                "total-label": "Total applications:",
                "title": "Applications",
                "subtitle": "Updates on the status of your job offers",
                "no-applications": "You have not applied to any offer yet!"
            },
            "my-candidates": {
                "no-candidates": "No candidates yet",
                "filters": {
                    "status": {
                        "new": "New",
                        "seen": "Seen",
                        "inprocess": "In process",
                        "accepted": "Accepted",
                        "rejected": "Rejected",
                        "invalid": "Unsuitable"
                    },
                    "order": {
                        "date": "Sort by application date",
                        "candidate": "Sort by candidate",
                        "last_change": "Sort by latest update",
                        "offer_creation": "Sort by offer date"
                    }
                }
            },
            "my-offers": {
                "total-label": "Total offers:",
                "no-offers": "No offers yet",
                "add-new-offer": "Add new offer",
                "filters": {
                    "order-by-title": "Order offers",
                    "show-title": "Filter offers",
                    "order-by": {
                        "newest": "By newest",
                        "last_update": "By latest update",
                        "title": "Alphabetical order",
                        "province": "By province"
                    },
                    "show": {
                        "all": "All offers",
                        "active": "Active",
                        "archived": "Archived",
                        "unpaid": "Draft"
                    }
                },
                "share-offer": {
                    "default-message": "I have found a job offer in {portal}"
                }
            },
            "payment-callback": {
                "success": "Your payment for the offer was successful! Your offer will be visible publicly from now on",
                "fail": "Unfortunately, your payment failed. Your card was not charged. Please try again...",
                "thank-you": "Thank you for choosing us.",
                "continue": "Continue..."
            },
            "my-account": {
                "tabs": {
                    "payments": "Purchases and orders",
                    "company": "Your company data",
                    "profile": "Your user data",
                    "notifications": "Notifications",
                    "promo-codes": "Promo codes"
                },
                "company": {
                    "cif": "CIF",
                    "phone": "Phone no.",
                    "form": {
                        "title": "Edit information",
                        "logo": {
                            "label": "Update the company logo",
                            "placeholder": "Select an image or drop it here",
                            "drop-placeholder": "Drop here...",
                            "browse-text": "Examine"
                        },
                        "category": {
                            "label": "Category"
                        },
                        "company-name": {
                            "label": "Company name",
                            "validation": "Must be more than 4 characters",
                            "tooltip": "To change company 's title please contact administration"
                        },
                        "country": {
                            "label": "Country",
                            "validation": "Must be more than 4 characters"
                        },
                        "province": {
                            "label": "Province",
                            "validation": "Must be more than 4 characters"
                        },
                        "phone": {
                            "label": "Contact phone",
                            "validation": "Must be more than 4 characters"
                        },
                        "company-cif": {
                            "label": "Tax ID (C.I.F o N.I.F)",
                            "validation": "Must be more than 4 characters",
                            "tooltip": "¡You cannot change CIF!"
                        },
                        "description": {
                            "label": "Company description",
                            "placeholder": "Describe your company how you want it to appear to candidates. Tip: Use the description of your corporate website."
                        }
                    },
                    "update-success": "Company updated successfully!"
                },
                "profile": {
                    "upload-new-avatar": "Upload new avatar",
                    "avatar-updated": "Avatar has been updated",
                    "role": {
                        "admin": "Administrator",
                        "user": "User",
                        "employer": "Employer",
                        "candidate": "Candidate",
                        "headhunter": "Headhunter"
                    },
                    "actions": {
                        "edit": "Edit profile",
                        "settings": "Account settings"
                    },
                    "edit-profile-form": {
                        "title": "Edit profile",
                        "name": {
                            "label": "First name",
                            "validation": "Must be more than 4 characters"
                        },
                        "last_name": {
                            "label": "Last name",
                            "validation": "Must be more than 4 characters"
                        },
                        "phone": {
                            "label": "Phone number",
                            "validation": "Must be valid phone number"
                        },
                        "address": {
                            "label": "Address"
                        },
                        "country": {
                            "label": "Country"
                        },
                        "province": {
                            "label": "Province"
                        },
                        "city": {
                            "label": "City"
                        },
                        "about-me": {
                            "label": "About me",
                            "placeholder": "Tell us something about yourself..."
                        }
                    },
                    "account-settings-form": {
                        "locale-settings": "Regional settings",
                        "language": {
                            "label": "Preferred language",
                            "validation": "Invalid option"
                        },
                        "change-password": "Change password",
                        "old_password": {
                            "label": "Old Password",
                            "validation": "Must be at least 6 characters"
                        },
                        "new_password": {
                            "label": "New password",
                            "validation": "Must be at least 6 characters"
                        },
                        "repeat_password": {
                            "label": "Repeat the new password",
                            "validation": "Must be at least 6 characters"
                        },
                        "reactivate-account": {
                            "title": "Reactivate Account",
                            "button": "Reactivate Account"
                        },
                        "deactivate-account": {
                            "title": "Deactivate account",
                            "caption": "Once you deactivate your account, only the administrator can recover it. Please be sure",
                            "button": "Deactivate account"
                        }
                    }
                },
                "notifications": {
                    "title": "Notifications",
                    "changes-successful": "Notification settings has been updated",
                    "no-changes-made": "No changes were made",
                    "new-applications": {
                        "title": "Notice of new applications",
                        "caption": "Receive notification e-mails when new CVs are registered in your offers.",
                        "notifications-period": "Notice periodicity *",
                        "daily-email": "Daily notification of application to an offer.",
                        "instant-email": "Notification in real time of application to an offer."
                    },
                    "candidate-offers": {
                        "title": "Configure your communications",
                        "caption": "Select the communications that you would like to receive by email.",
                        "daily-new-offers": "Daily report of new offers",
                        "application-status-change": "Application status change"
                    },
                    "admin": {
                        "new-companies": "Report of newly registered companies",
                        "title": "Configure your communications",
                        "caption": "No notification settings yet..."
                    },
                    "submit": "Save settings"
                },
                "promos": {
                    "title": "Promo codes",
                    "card": {
                        "uses": "{remaining} uses out of {limit}",
                        "discount": "{discount} € discount for offer!",
                        "multiprovince": "Multiprovince promo for {count} provinces!"
                    },
                    "no-promos": "There are no promo codes available"
                }
            },
            "publish-offer": {
                "publishable-offers": {
                    "basic": "Basic",
                    "standard": "Standard",
                    "premium": "Premium"
                },
                "which-type": "What type of offer do you want to publish?",
                "unfinished-offer": "You have an unfinished offer",
                "continue-link": "Do you want to continue?",
                "reset-form-link": "You can also create a new offer.",
                "progress": {
                    "job-description": "Job Description",
                    "candidate-requirements": "Candidate requirements",
                    "pay-for-offer": "Pay for the offer"
                },
                "alert": {
                    "select-offer-type": "Please select offer type",
                    "correct-errors": "Please correct the errors in the form",
                    "offer-created": "Offer created successfully",
                    "offer-updated": "Offer updated successfully"
                },
                "sidepanel": {
                    "title": "Selected services",
                    "offer-in": "Job offer in {place}",
                    "hide-company-name": "Hide company name",
                    "promotion": "Promotion",
                    "free-offer": "free offer",
                    "promo-code": "promo code"
                },
                "first-page": {
                    "company-data": "Company data",
                    "company-name": "Your company name",
                    "dont-show-company-name": "Don't show my company name",
                    "title-and-place": "Offer title and vacancy",
                    "offer-title": "Offer title",
                    "offer-title.placeholder": "Example: Administrative Assistant with native English",
                    "num-vacancies": "Nº of vacancies",
                    "level": "Level",
                    "num-personnel": "Personnel in charge",
                    "job-description": "Job Description",
                    "job-description.length": "{current} / {max} (minimum {min} characters)",
                    "job-description.help.title": "What to write here?",
                    "job-description.help.text": "Briefly explain what the vacancy consists of and what functions the profile you are looking for will do.",
                    "job-category-and-industry-type": "Category and type of industry of the position",
                    "category-and-subcategory": "Category and subcategory",
                    "supply-industry-type": "Supply Industry Type",
                    "job-location": "Position location",
                    "country": "Country",
                    "province": "Province",
                    "municipality": "Municipality",
                    "postal-code": "Postal code",
                    "type-of-contract-and-working-day": "Type of contract and working hours",
                    "type-of-contract": "Type of contract",
                    "duration": "Duration",
                    "workday": "Workday",
                    "schedule": "Schedule",
                    "salary": {
                        "salary": "Salary",
                        "caption": "Indicating the salary helps us to better understand what type of profiles you are looking for, and how we can help you find it",
                        "type": "Type",
                        "minimum": "Minimum",
                        "maximum": "Maximum",
                        "show-in-offer": "Show in the offer"
                    },
                    "job-benefits.title": "Laboral benefits",
                    "job-benefits.caption": "Increase the probability of receiving enrolled in this offer indicating the labor benefits that employees will enjoy",
                    "job-benefits.other": "Other benefits",
                    "job-benefit": {
                        "percentage-on-targets": "Percentage on targets",
                        "telecommuting": "Remote work",
                        "health-insurance": "Health insurance",
                        "vehicle-mileage": "Vehicle / mileage",
                        "flexible-schedule": "Flexible schedule",
                        "mobile-phone": "Mobile phone",
                        "restaurant-check": "Restaurant checks"
                    }
                },
                "second-page": {
                    "candidate-requirements": "Candidate requirements",
                    "minimum-studies": "Minimum studies",
                    "minimum-job-experience": "Minimum experience in the position",
                    "minimum-requirements": "Minimum requirements",
                    "minimum-requirements.length": "{current} / {max} characters",
                    "minimum-requirements.caption": "Indicates experience, availability, certifications and other essential requirements for the position.",
                    "killer-questions": {
                        "short-title": "Killer questions",
                        "title": "Mandatory preliminary questionnaire for candidates: killer questions",
                        "caption": "Define <strong>closed questions</strong> and assign each answer a\n<strong>punctuation</strong> to discard, filter and identify\ncandidates. If you want <strong>automatic discard</strong> to the\ncandidates that do not meet your requirements, select the value\n\"Discard\" as the answer score. If you wish, you can use the\nquestion templates.",
                        "example": {
                            "title": "Killer question example",
                            "question": "What is your level of english?",
                            "answer1": "Native (10 pts.)",
                            "answer2": "I use it regularly at work (8 pts.)",
                            "answer3": "I speak it but I don't use it regularly (4 pts.)",
                            "answer4": "I don't speak it but I understand it (2 pts.)",
                            "answer5": "I don't speak it (Discard)"
                        },
                        "question.placeholder": "Enter a question",
                        "answer.placeholder": "Enter an answer",
                        "select-predefined": "Select predefined question",
                        "accept": "Accept",
                        "discard": "Discard",
                        "use-in-this-offer": "Use Killer Questions for this offer",
                        "maximum-5-offers": "Maximum 5 questions!",
                        "predefined-modal": {
                            "title": "Select predefined question",
                            "message": "Select a question from the list below and click Select to use the question"
                        }
                    }
                },
                "third-page": {
                    "tax-data": {
                        "title": "Tax data",
                        "tax-id": "Tax ID (CIF o NIF)",
                        "business-name": "Business name"
                    },
                    "billing-information": {
                        "title": "Billing information",
                        "address": "Address",
                        "contact-person": "Contact person",
                        "email": "Email"
                    },
                    "discount-code": {
                        "title": "Discount code",
                        "success": "Congratulations! You got <strong>{discount} €</strong> discount!",
                        "placeholder": "Enter the code",
                        "invalid": "PROMO CODE IS INVALID!",
                        "apply": "APPLY CODE",
                        "caption": "You can use 1 discount code for each order."
                    },
                    "payment-method": {
                        "title": "Payment mode",
                        "credit-card": "Credit card",
                        "credit-card.caption": "Payment will be made immediately and the service will be activated instantly.",
                        "free-first-offer": "Free first offer",
                        "free-first-offer.caption": "Welcome to {portal}. As a gift you can publish this offer for free! Enjoy and good luck."
                    }
                }
            },
            "payments": {
                "total-label": "Total payments:",
                "table": {
                    "date": "Date",
                    "id_and_details": "Order Nº and details of services",
                    "amount": "Amount",
                    "status": "Status"
                },
                "no-payments": "No payments yet",
                "failed": "Payment failed",
                "success": "Payment successful",
                "offer": "Offer",
                "details": {
                    "offer-publish": "Offer Publication"
                }
            },
            "admin": {
                "offers": {
                    "total-label": "Total offers:",
                    "filter-options": {
                        "order": {
                            "newest": "Sort by newest",
                            "updated-at": "Sort by latest update",
                            "alphabetically": "Sort alphabetically",
                            "province": "By province"
                        },
                        "filter": {
                            "all-offers": "All offers",
                            "archived": "Archived offers",
                            "active": "Active offers",
                            "unpaid": "Unpaid offers"
                        }
                    }
                },
                "companies": {
                    "total-label": "Total companies:",
                    "no-companies": "No companies yet...",
                    "active": "Active",
                    "pending": "Pending",
                    "rejected": "Rejected",
                    "verify-success": "Company verified successfully!",
                    "reject-success": "Company rejected successfully!"
                },
                "users": {
                    "total-label": "Total users:",
                    "something-wrong": "Something wrong happened! Please try refreshing the page...",
                    "no-recover": "You will not be able to recover it later!",
                    "confirm-delegate": "Are you sure you want to delegate selected user to this offer?",
                    "delegate-success": "Delegated an offer for the user successfully!",
                    "deleted-success": "Deleted successfully",
                    "no-users": "No users found...",
                    "filter-options": {
                        "order": {
                            "label": "Order by...",
                            "newest": "Sort by newest",
                            "name": "By name",
                            "email": "By email"
                        },
                        "filter": {
                            "label": "Filter uusers",
                            "all-users": "All users",
                            "companies": "Only companies",
                            "candidates": "Only candidates",
                            "hrs": "Only headhunters",
                            "withcv": "Candidates with CV"
                        }
                    },
                    "only-active": "Only active"
                },
                "promos": {
                    "total-label": "Total promo codes:",
                    "create-new-promo": "Add new promo code",
                    "promo-code-added": "Promo code added!",
                    "promo-code-deleted": "Promo code deleted!",
                    "form": {
                        "code": "Promo code name",
                        "code.placeholder": "Enter promo code name..",
                        "type": "Promo code type",
                        "discount": "Discount",
                        "discount.caption": "* € for offers or number of provinces for multiprovince",
                        "limit": "Limit",
                        "user": "For user",
                        "user.placeholder": "Select a user"
                    },
                    "table": {
                        "discount": "Discount",
                        "used-times": "Times used",
                        "created-at": "Created at",
                        "updated-at": "Updated at",
                        "for": "For",
                        "actions": "Actions"
                    },
                    "existing-promos": "Existing promos"
                },
                "referrals": {
                    "total-label": "Total referrals:",
                    "referral": {
                        "title": "Referrals",
                        "enable": "Activate",
                        "disable": "Disable",
                        "enabled": "Active",
                        "disabled": "Disabled",
                        "link": "Link",
                        "created-at": "Created",
                        "updated-at": "Updated",
                        "counter": "Counter",
                        "referred-users": "Referred users",
                        "no-users-referred": "No referred users yet..."
                    },
                    "add-new-referral": {
                        "title": "Add new referral",
                        "name.placeholder": "Enter description",
                        "disabled": "Disabled",
                        "success": "Referral created!",
                        "validation": "Title must be at least {minLength} characters long"
                    },
                    "disable-success": "Referral disabled",
                    "enable-success": "Referral enabled",
                    "filter-options": {
                        "order": {
                            "newest": "Sort by newest",
                            "last-updated": "Sort by last updated",
                            "counter": "Counter"
                        },
                        "filter": {
                            "all": "All referrals",
                            "only-enabled": "Only enabled",
                            "only-disabled": "Only disabled"
                        }
                    },
                    "list": {
                        "title": "Referrals",
                        "no-referrals": "No referrals yet"
                    }
                },
                "headhunters": {
                    "title": "Manage Headhunters",
                    "assign-companies": "Assign companies to Headhunter",
                    "select-companies": "Select",
                    "select-all": "Select All",
                    "select-companies-title": "Select companies",
                    "select-companies.mark-explain": "Check the box to Assign",
                    "select-companies.unmark-explain": "Uncheck the box to Unassign",
                    "no-companies": "No companies selected yet...",
                    "companies-update-success": "Headhunter companies updated successfully",
                    "create-new": {
                        "title": "Fill in the Headhunter information",
                        "name": "First name",
                        "last-name": "Last name",
                        "place": "Enter place",
                        "city": "City",
                        "phone": "Enter phone",
                        "email": "Enter email",
                        "password": "Password",
                        "password-confirm": "Confirm password",
                        "button": "Create headhunter"
                    }
                },
                "permissions": {
                    "permission": "Permission",
                    "assign": "Assign",
                    "assign.success": "Assigned successfully",
                    "unassign.success": "Unassigned successfully",
                    "no-permissions": "No permissions yet!"
                },
                "one-company": {
                    "company-offers.title": "Company offers",
                    "no-offers": "No offers yet..."
                }
            },
            "delegations": {
                "title": "All my delegations of candidates and offers ({count})",
                "no-delegations": "No delegations yet"
            },
            "hr": {
                "delegating-user-for-offer": "You are delegating a user for this offer.",
                "delegating-offer-for-user": "You are delegating an offer for this user.",
                "select-user": "Select the user",
                "select-offer": "Select the offer"
            },
            "user-cv": {
                "fill-cv-pretext": "In order to apply for job offers, you must complete the necessary information:",
                "upload-cv": "Upload a CV document",
                "fill-employment-status": "Indicate employment status",
                "profile-complete-note": "Great job! Now you can apply for job offers.",
                "search-for-offers": "Search job offers now",
                "my-cv": "My CV {first} {last}",
                "multiselect": {
                    "press-enter-select": "Press enter to select",
                    "press-enter-remove": "Press enter to remove",
                    "press-enter-selected": "Selected"
                },
                "personal-data": {
                    "title": "My personal information"
                },
                "profile-update.success": "Profile updated successfully!",
                "profile-update.failure": "All fields must be filled!",
                "employment": {
                    "title": "Employment status",
                    "edit-button": "Edit employment status",
                    "preferred-levels": "Preferred levels",
                    "my-experience": "My experience",
                    "preferred-categories": "My preferred categories",
                    "preferred-industries": "My preferred industries",
                    "preferred-contracts": "My preferred contracts",
                    "modal": {
                        "title": "Edit employment status",
                        "experience": {
                            "title": "Your levels and experience",
                            "preference": "What levels of work are you interested in?",
                            "current": "How much experience do you have?"
                        },
                        "industries": {
                            "title": "Your industries and categories",
                            "categories": "Your categories",
                            "industries": "Your industries"
                        },
                        "contracts": {
                            "title": "Your contracts",
                            "contracts": "Contracts"
                        }
                    }
                },
                "languages": {
                    "title": "Languages",
                    "edit-button": "Edit languages",
                    "speaking": "Speaking",
                    "writing": "Writing",
                    "reading": "Reading",
                    "comments": "Comments",
                    "modal": {
                        "title": "Edit languages",
                        "your-languages": "Your language data",
                        "no-languages": "No languages yet!"
                    }
                },
                "document": {
                    "title": "Document",
                    "edit-button": "Edit document",
                    "current-cv-document": "Your current CV document",
                    "last-updated": "Last updated at:",
                    "modal": {
                        "title": "Edit document",
                        "update-document": "Update document",
                        "requirements": "*Max. 2MB, .doc, .docx or .pdf",
                        "select-file": "Select a file",
                        "drop-file": "Drop the file here ...",
                        "please-select-file": "Please select a document.",
                        "invalid-file": "The selected document does not meet the requirements."
                    }
                },
                "skills": {
                    "title": "Skills",
                    "edit-button": "Edit skills",
                    "my-skills": "My skills",
                    "modal": {
                        "title": "Edit skills",
                        "skills": "Skills",
                        "skills.placeholder": "Write a skill",
                        "skills.tag-placeholder": "Press enter to create a label",
                        "skills.no-options": "Write a skill and press enter"
                    }
                },
                "text-cv": {
                    "title": "CV in text",
                    "edit-button": "Edit CV in text",
                    "modal": {
                        "title": "Edit CV in text",
                        "text": "CV in text",
                        "text.placeholder": "Write your text here"
                    }
                },
                "education": {
                    "title": "Education",
                    "edit-button": "Edit education",
                    "entry": "{title} in {name}",
                    "modal": {
                        "title": "Edit education",
                        "education": "Your education data",
                        "no-educations": "No educations yet!",
                        "form": {
                            "title": "Title",
                            "specialty": "Name of the course / Specialty",
                            "ongoing": "Currently studying",
                            "start-date": "Start date",
                            "end-date": "End date",
                            "study-center": "Study center"
                        }
                    }
                },
                "experience": {
                    "title": "Experience",
                    "edit-button": "Edit experience",
                    "entry": "{company} in {position}",
                    "modal": {
                        "title": "Edit experience",
                        "experience": "Your experience data",
                        "no-experience": "No experience yet!",
                        "form": {
                            "company": "Company",
                            "sector": "Company sector",
                            "position": "Position",
                            "ongoing": "Currently working here",
                            "start-date": "Start date",
                            "end-date": "End date",
                            "level": "Level",
                            "description": "Job description",
                            "description.placeholder": "Indicate your functions, achievements and knowledge acquired and used. Companies use this information to evaluate your applications."
                        }
                    }
                },
                "my-recommendations": {
                    "title": "My recommendations",
                    "edit-button": "My recommendations",
                    "name": "Name",
                    "phone": "Phone",
                    "email": "Email",
                    "text": "Text",
                    "modal": {
                        "title": "Edit my recommendations",
                        "your-recommendations": "Your recommendations",
                        "no-recommendations": "No recommendations yet!"
                    }
                },
                "sidebar": {
                    "please-complete-profile": "Please complete your profile.",
                    "completion": "Is at {perc} %",
                    "necessary": "Necessary",
                    "optional": "Optional",
                    "profile-completed": "Profile completed!",
                    "last-updated": "Date of the last update of your CV",
                    "find-courses": "Find courses",
                    "internships": {
                        "title": "Internships in companies",
                        "company-interns": {
                            "title": "Internships in companies",
                            "subtitle": "We hold the key to professional employability"
                        },
                        "vip-interns": {
                            "title": "VIP internships",
                            "subtitle": "Publish a multitude of offers and find scholars without borders"
                        },
                        "find-interns": {
                            "title": "Hire scholars",
                            "subtitle": "Internship agreements in companies"
                        },
                        "agency-interns": {
                            "title": "Internship agency",
                            "subtitle": "The most qualified through pre-selection processes"
                        },
                        "erasmus-interns": {
                            "title": "Erasmus internships",
                            "subtitle": "We coordinate and manage mobility programs and European funds"
                        },
                        "alien-interns": {
                            "title": "Foreign scholars",
                            "subtitle": "We are the link between students, universities and companies"
                        }
                    },
                    "partner-services": {
                        "title": "Partner Services"
                    }
                }
            },
            "not-found": {
                "title": "We have not found this page",
                "subtitle": "But don't worry, we have thousands of offers for you.",
                "search-offers": "Search offers"
            },
            "company-page": {
                "title": "Company offers",
                "view-offers": "View offers",
                "company-description": "Company description",
                "total-offers": "{total} offers in {companyTitle}"
            },
            "one-candidate": {
                "status": "Status: {status}",
                "accept": "ACCEPT",
                "toInProcess": "Put IN PROCESS",
                "reject": "REJECT",
                "accepted": "ACCEPTED",
                "rejected": "REJECTED",
                "view-cv": "View CV",
                "modal.title": "Warning!",
                "no-document": "No CV Document...",
                "modal-accept": "Are you sure you want to <strong style=\"color: green\">ACCEPT</strong> this candidate?",
                "modal-reject": "Are you sure you want to <strong style=\"color: red\">REJECT</strong> this candidate?",
                "modal-inprocess": "Are you sure you want to change status of this candidate to <strong style=\"color: green\">IN PROCESS</strong>?"
            },
            "intern-control": {
                "title": "Personal data",
                "save": "Save",
                "update.success": "Intern updated successfully"
            },
            "verify-announcement": {
                "thank-you": "Thanks for signing up. Please verify your account.",
                "system-use-caption": "To use the {portal} platform, you must verify your account. An email has been sent to {email} with a link to verify your account. If you have not received the email after a few minutes, please check your spam folder."
            },
            "workwithus": {
                "title": "It is part of our team",
                "subtitle-1": "We want to count on you!",
                "subtitle-2": "Fill in the following form and attach your CV",
                "cv": "CV",
                "requirements": "*Max. 2MB, .pdf",
                "select-file": "Select a file",
                "drop-file": "Drop the file here ...",
                "please-select-file": "Please select a document.",
                "invalid-file": "The selected document does not meet the requirements."
            },
            "vip-services.recruitment": {
                "hero": {
                    "title": "Successfull recruitment and selection",
                    "subtitle": "We help you find the ideal candidate and take care of the entire process.",
                    "form-title": "Find the right talent now",
                    "form-btn-send": "Request our service"
                },
                "services": {
                    "title": "We take care of everything",
                    "card-1-title": "Offer publication",
                    "card-2-title": "CV Screening",
                    "card-3-title": "Interviews with potential candidates",
                    "card-4-title": "Written report of the ideal profile",
                    "card-5-title": "Final interview coordination",
                    "card-6-title": "Evaluation and follow-up for 3 months"
                },
                "successfull-work": {
                    "title": "WE WORK SUCCESSFULLY",
                    "subtitle": "PAY ONLY IF YOU HIRE ONE OF OUR CANDIDATES"
                },
                "contact-us": {
                    "title": "Contact us",
                    "card-1": {
                        "title": "About us",
                        "info-1": "We are experts in recruitment and selection of personnel",
                        "info-2": "24 years of experience training people and developing organizations"
                    },
                    "card-2": {
                        "title": "Business Hours",
                        "info-1": "Monday to Thursday from 09:00 to 17:00",
                        "info-2": "Friday from 09:00 to 15:00"
                    },
                    "card-3": {
                        "title": "Contacts",
                        "info-1": "Calle León y Castillo, 54, 1st Floor, 35003 Las Palmas de Gran Canaria, Las Palmas, Spain",
                        "info-2": "Email: info@planetajob.es",
                        "info-3": "Phone: +34928354668"
                    }
                },
                "bottom-form": {
                    "btn-send": "Request our service"
                },
                "form-success-1": "Your inquiry has been sent successfully!",
                "form-success-2": "Our team will contact you shortly."
            },
            "killer-questions-templates": {
                "main": {
                    "title": "Killer Questions Templates",
                    "existing-questions": "Existing questions structure",
                    "view-questions": "View folder's questions",
                    "selected-question": "Selected Question",
                    "must-create-root": "You must create a root folder first"
                },
                "actions": {
                    "title": "Actions",
                    "new-question-title": "New Killer Question",
                    "new-question-desc": "Create a question and save it to use in different offers.",
                    "new-folder-title": "New Folder",
                    "new-folder-desc": "Organize your questions in folders so you can easily locate them.",
                    "edit-question-title": "Manage Killer Questions",
                    "edit-question-desc": "Modify or delete the questions you have previously created.",
                    "edit-folder-title": "Manage Folders",
                    "edit-folder-desc": "Modify or delete the folders that you have previously created."
                },
                "add-question": {
                    "title": "New Killer Question",
                    "subtitle": "Choose one of your Killer Questions. You can modify the selected question to suit you.",
                    "rule-1": "Define 2 to 5 different answers per question.",
                    "rule-2": "Rate each answer from 0 to 10, to order the candidates by score.",
                    "rule-3": "Decide if a specific answer excludes the candidate. Candidates who select those answers will be classified as \"Does not fit.\"",
                    "save-in-folder": "Save to folder",
                    "save-in-folder-subtitle": "Select the location of the new Killer Question template:",
                    "must-select-folder": "You must select a folder!",
                    "view-questions": "See the folder questions",
                    "select-save-folder": "Must select save folder"
                },
                "add-folder": {
                    "title": "New folder",
                    "subtitle": "To create a new folder in which to organize your Killer Questions, you must give it a name and select where to save it.",
                    "folder-name": "Folder name:",
                    "save-folder-in": "Save folder to:",
                    "must-select-folder": "You must select a folder!",
                    "failure": "All fields must be filled!"
                },
                "manage-question": {
                    "title": "Manage Killer Question",
                    "subtitle": "Choose one of Killer Questions. You can modify the selected question to suit you.",
                    "must-select-folder": "Must select a folder!",
                    "rule-1": "Define 2 to 5 different answers per question.",
                    "rule-2": "Rate each answer from 0 to 10, to order the candidates by score.",
                    "rule-3": "Decide if a specific answer excludes the candidate. Candidates who select those answers will be classified as \"Does not fit.\"",
                    "save-in-folder": "Save to folder",
                    "save-in-folder-subtitle": "Select the location of the new Killer Question template:",
                    "view-questions": "See the folder questions",
                    "select-question": "Must select a question",
                    "you-sure-delete": "Are you sure you want to delete selected question?"
                },
                "manage-folder": {
                    "title": "Manage Folders",
                    "must-select-folder": "Must select a folder!",
                    "select-folder": "Select the folder you want to modify",
                    "edit-folder-name": "Modify the name of your folder",
                    "folder-name": "Folder name:",
                    "folder-location": "Modify the location of your folder",
                    "failure": "All fields must be filled!",
                    "cannot-move": "Cannot move root folder!",
                    "cannot-delete": "Cannot delete root folder!",
                    "delete-modal": {
                        "selected": "You have selected ",
                        "folders": " folders",
                        "you-sure": "Are you sure?",
                        "you-sure-delete": "Are you sure you want to delete it?"
                    }
                }
            }
        }
    },
    "es": {
        "hero": {
            "search-offers": {
                "title": "OFERTAS DE EMPLEO",
                "filters": {
                    "keyword": {
                        "label": "Busca ofertas de...",
                        "placeholder": "Puesto, empresa o palabra clave"
                    },
                    "province": {
                        "label": "en..."
                    }
                },
                "search": "BUSCAR",
                "view-offers": {
                    "pretext": "o ",
                    "link": "ver todas las ofertas"
                }
            }
        },
        "modals": {
            "delete": {
                "confirm": "¿Estás seguro que quieres eliminar?",
                "success": "Borrado exitosamente"
            },
            "archive": {
                "confirm": "Advertencia",
                "title": "¿Seguro quieres archivar la oferta?",
                "success": "Archivado con éxito"
            },
            "deactivate": {
                "confirm": "¿Estás seguro de que quieres desactivar?",
                "success": "¡Desactivado con éxito!",
                "form": {
                    "confirm-password": "Confirma tu contraseña para desactivar tu cuenta",
                    "confirm-password.validation": "La contraseña debe contener 6 caracteres como mínimo",
                    "confirm-password.placeholder": "Ingresa tu contraseña"
                }
            },
            "reactivate": {
                "confirm": "¿Estás seguro de que quieres reactivar?",
                "success": "¡Reactivado con éxito!"
            },
            "delegate-user": {
                "confirm": "¿Está seguro de que desea delegar la oferta seleccionada a este usuario?",
                "success": "¡Delegó una oferta para el usuario con éxito!"
            },
            "irrecoverable-action": "¡No podrás recuperarlo más tarde!",
            "copy-offer": {
                "title": "¡Advertencia!"
            }
        },
        "main": {
            "you-are-in": "Estás en {place}",
            "routes": {
                "hr-delegations": "Delegaciones",
                "hr-delegate-user": "Delegar un usuario",
                "hr-delegate-offer": "Delegar una oferta",
                "one-offer": "Oferta",
                "one-company": "Empresa",
                "my-offers": "Mis ofertas",
                "offer-payment": "Pago de la oferta",
                "publish-offer": "Publicar oferta",
                "edit-offer": "Editar oferta",
                "copy-offer": "Copiar oferta",
                "multiprovince-offer": "Oferta multiprovincia",
                "my-candidates": "Mis candidatos",
                "offer-candidates": "Candidaturas",
                "one-candidate": "Candidatura",
                "offer-interns": "Interns candidaturas",
                "all-offers": "Ofertas",
                "all-companies": "Empresas",
                "all-users": "Usuarios",
                "one-user": "Usuario",
                "all-payments": "Pagos",
                "all-promos": "Códigos de activación",
                "all-referrals": "Referencias",
                "one-referral": "Referencia",
                "all-hrs": "Administrar headhunters",
                "manage-hr": "Administrar headhunter",
                "add-hr": "Añadir headhunter",
                "roles": "Roles",
                "permissions": "Permisos",
                "dashboard": "Panel",
                "profile": "Perfil",
                "my-account": "Mi cuenta",
                "apply-offer": "Inscripción en Oferta",
                "applied-offers": "Candidaturas",
                "my-cv": "Mi CV",
                "killer-questions-templates": {
                    "main": "Plantillas de Killer Questions",
                    "add-question": "Añadir Killer Question",
                    "add-folder": "Añadir Carpeta de Killer Questions",
                    "manage-question": "Gestionar Killer Question",
                    "manage-folder": "Gestionar Carpeta de Killer Question"
                },
                "external-candidate": "Candidato externo"
            },
            "navbar": {
                "login-as-company": "Acceso Empresas",
                "login-as-candidate": "Acceso Candidatos"
            },
            "footer": {
                "help": "Ayuda",
                "contact-us-via-email": "Contáctanos por e-mail",
                "contact-us-via-email.caption": "No recibimos solicitudes para ofertas de empleo por esta vía.",
                "contact-us": "Contáctanos",
                "working-hours-line-1": "Lunes a jueves de {from} a {to} Horas",
                "working-hours-line-2": "Viernes de {from} a {to} Horas"
            },
            "footer2": {
                "about-us": {
                    "title": "Nosotros",
                    "general-conditions": "Condiciones legales",
                    "privacy-policy": "Política de Privacidad",
                    "help": "Ayuda",
                    "about-us": "Quienes somos",
                    "cookies-policy": "Política de cookies"
                },
                "on": {
                    "title": "Sobre {portal}",
                    "work-with-us": "Trabaja con nosotros"
                },
                "vip-services": {
                    "title": "Servicios VIP",
                    "recruitment": "Reclutamiento y selección a éxito"
                },
                "job-offers": {
                    "title": "Ofertas de empleo",
                    "employment-counseling": "Orientación laboral",
                    "executive-education": "Executive education",
                    "employment-training": "Formación para el empleo",
                    "trusted-professional": "Profesional de confianza"
                },
                "group-company": "Es una empresa del Grupo",
                "our-brands": "Nuestras Marcas"
            }
        },
        "inputs": {
            "email": {
                "title": "Email",
                "title-full": "Correo electrónico",
                "validation": "Dirección de correo electrónico inválida",
                "placeholder": "Dirección de correo electrónico..."
            },
            "password": {
                "title": "Contraseña",
                "validation": "La contraseña debe contener 6 caracteres como mínimo",
                "placeholder": "Contraseña..."
            },
            "password-confirm": {
                "title": "Confirma la contraseña",
                "validation": "Las contraseñas no coinciden",
                "placeholder": "Repite la contraseña..."
            },
            "first-name": {
                "title": "Nombre",
                "validation": "Campo obligatorio"
            },
            "last-name": {
                "title": "Apellido",
                "validation": "Campo obligatorio"
            },
            "place": {
                "title": "Lugar",
                "city": {
                    "title": "Ciudad"
                }
            },
            "phone": {
                "title": "Teléfono",
                "title-full": "Número de teléfono",
                "validation": "Campo obligatorio"
            },
            "comment": {
                "title": "Comentario",
                "placeholder": "Ingrese algo..."
            },
            "company-title": {
                "title": "Nombre de la empresa*",
                "validation": "Campo obligatorio"
            },
            "company-phone": {
                "title": "Teléfono móvil*",
                "validation": "Campo obligatorio (Verificación por sms o llamada)"
            },
            "company-cif": {
                "title": "Identificación fiscal (C.I.F o N.I.F)*",
                "validation": "Debe ser válido C.I.F o N.I.F"
            },
            "company-description": {
                "title": "Descripción de la empresa",
                "placeholder": "Describe tu empresa como quieres que se muestre a los candidatos. Consejo: Utiliza la descripción de vuestra web corporativa."
            },
            "keyword": {
                "title": "Palabras clave",
                "placeholder": "Palabras clave"
            },
            "option": {
                "placeholder": "Seleccionar opción"
            }
        },
        "backend": {
            "responses": {
                "auth": {
                    "incorrect-credentials": "Credenciales incorrectas",
                    "account-disabled": "¡Cuenta deshabilitada!",
                    "account-unverified": "¿Aún no has verificado tu cuenta? Revisa tu correo electrónico y sigue las instrucciones que te hemos enviado. ¿No has recibido el correo de verificación?",
                    "logout-success": "Cerrar sesión correctamente",
                    "email-verify-success": "Ha verificado correctamente su dirección de correo electrónico.",
                    "email-already-verified": "¡Cuenta ya verificada!",
                    "email-code-invalid": "El código de verificación no es válido.",
                    "user-by-email-not-found": "¡No se encontró el usuario con el correo electrónico proporcionado!"
                },
                "company": {
                    "invalid-cif": "CIF o NIF no válido",
                    "no-company": "¡No pude encontrar empresa!",
                    "only-your-company": "Solo se puede editar la propia empresa"
                },
                "file-upload": {
                    "invalid-category": "Categoría de archivo no válida"
                },
                "offer": {
                    "any-offers": "¡No se pudo encontrar ninguna oferta!",
                    "no-offer": "¡No se pudo encontrar la oferta!",
                    "no-offers": "¡No se pudieron encontrar ofertas!",
                    "killer-questions": {
                        "already-exist": "¡Ya existen preguntas asesinas para esta oferta!",
                        "cant-save-question": "No se puede salvar pregunta asesino!"
                    },
                    "promo": {
                        "not-found": "¡Promoción no encontrada!",
                        "limit-reached": "¡Límite de provincias promocionales alcanzado!"
                    }
                },
                "user": {
                    "user-no-exist": "El usuario no existe",
                    "not-found": "No se pudo encontrar el usuario!",
                    "deleted": "Usuario eliminado!",
                    "cant-delete": "No se pudo eliminar el usuario",
                    "new-psw-no-match": "Las nuevas contraseñas no coinciden",
                    "psw-no-match": "Contraseñas no coinciden",
                    "psw-change-success": "Contraseña cambiada con éxito"
                },
                "payments": {
                    "not-proccessed": "No se pudo procesar el pago"
                },
                "referral": {
                    "cant-create": "No se pudo crear una referencia",
                    "incorrect-id": "ID de referencia incorrecta",
                    "not-found": "Referencia no encontrada"
                },
                "roles-and-permissions": {
                    "role-not-found": "¡No se pudo encontrar el rol!"
                },
                "user-cv": {
                    "not-found": "No se pudo encontrar el usuario cv!"
                },
                "locale": {
                    "own-saved": "Se actualizó su configuración regional!",
                    "target-saved": "Se ha actualizado la configuración regional del usuario!"
                },
                "common-errors": {
                    "unauthorized": "No autorizado!",
                    "no-permissions": "No tienes permisos para esto"
                }
            },
            "emails": {
                "generic": {
                    "hello": "¡Hola!",
                    "hello-name": "Hola {name},",
                    "click-to-see-more": "Haz clic aquí para ver más",
                    "click-to-see": "Haz clic aquí para ver",
                    "contact-us-doubt": "Contáctanos en caso de cualquier duda.",
                    "team-of": "Equipo de {appName} .",
                    "footer-msg-psw-reset": "Recibiste este mensaje porque hemos recibido una solicitud para cambiar la contraseña de {appName} especificando tu dirección de correo electrónico. Si no fuiste tú, puedes eliminar este mensaje.",
                    "footer-msg-verification": "Te mandamos este mensaje porque hemos recibido una solicitud de registro en nuestro portal de empleo Planetajob.es especificando tu dirección de correo electrónico. Si no fuiste tú, puedes eliminar este mensaje."
                },
                "footer": {
                    "made-with": "Hecho con",
                    "by": "por",
                    "dont-receive": "Si no deseas recibir más comunicaciones puedes",
                    "unsubscribe": "darte de baja",
                    "auto-msg": "Este mensaje ha sido enviado automáticamente.",
                    "dont-reply": "No respondas a este correo electrónico."
                },
                "new-company": {
                    "subject": "Una nueva empresa registrada en el portal",
                    "title": "Una nueva empresa registrada en el portal: {companyName}",
                    "company-name": "Nombre de empresa: {title}",
                    "company-cif": "CIF/NIF: {cif}",
                    "company-phone": "Teléfono: {phone}"
                },
                "candidatura-change": {
                    "subject": "Tu estado de candidatura ha cambiado",
                    "accepted": "Tu estado de candidatura en la oferta \" {offerTitle} \" ha cambiado. Has sido aceptado.",
                    "rejected": "Lamentamos informarte que tu candidatura en la oferta \" {offerTitle} \" ha sido rechazada."
                },
                "offers-report": {
                    "subject": "Nuevas ofertas en {appName}",
                    "you-have": "Tenemos",
                    "offers-yesterday": "nuevas ofertas",
                    "offers-below": "Se han publicado las siguientes ofertas",
                    "no-company-name": "Nombre de empresa no disponible",
                    "contract": "Contrato: {contract}",
                    "workday": "Jornada: {workday}"
                },
                "applications-realtime": {
                    "subject": "Alguien ha solicitado en tu oferta!",
                    "user-applied": "{userName} ha solicitado esta oferta!",
                    "view-all": "VER TODAS INSCRIBCIONES"
                },
                "applications-report": {
                    "subject": "Aplicaciones en tus ofertas desde ayer",
                    "title": "Aplicaciones en tus empresas ofertas desde ayer:"
                },
                "company-status-realtime": {
                    "subject": "El estado de su empresa ha cambiado",
                    "accepted": "¡Felicidades! El estado de tu empresa ( {companyTitle} ) ha cambiado a activo.",
                    "publish-now": "Ahora puedes publicar ofertas en el portal.",
                    "rejected": "Lamentamos informarte que el registro de tu empresa ( {companyTitle} ) ha sido rechazado.",
                    "free-offer": "Haz clic aquí para publicar tu primera oferta GRATIS"
                },
                "contacts": {
                    "subject": "Alguien envió una consulta de soporte desde {appName}",
                    "title": "Alguien envió una consulta de soporte desde {appName}",
                    "name": "Nombre",
                    "type": "Tipo",
                    "topic": "Tema",
                    "content": "Contenido",
                    "reply-user": "Puede responder a este mensaje para responder al usuario ( {email} )"
                },
                "reset-password-success": {
                    "subject": "Se ha cambiado la contraseña de su cuenta de {appName}",
                    "change-success": "Su contraseña ha sido cambiada exitosamente.",
                    "contact-support": "Si no fue usted, comuníquese con el soporte de inmediato."
                },
                "reset-password": {
                    "subject": "Solicitud de cambio de contraseña",
                    "title": "¿Olvidaste tu contraseña?",
                    "reset-psw-msg": "Recibimos una solicitud para cambiar la contraseña de tu cuenta de {appName}. Puede hacerlo haciendo clic en el botón a continuación:",
                    "reset-psw": "RESTABLECER CONTRASEÑA",
                    "copy-link-msg": "También puedes copiar el siguiente enlace y pegarlo en el navegador web para restablecer la contraseña:"
                },
                "verification": {
                    "subject": "Confirma tu registro en {appName}",
                    "title": "Gracias por registrarte en {appName}",
                    "neccessary-confirm": "Estás a un paso de confirmar tu cuenta y de activar nuestros servicios.",
                    "activate-now": "ACTIVA TU CUENTA AHORA",
                    "copy-link-msg": "También puedes copiar el siguiente enlace y pegarlo en tu navegador web y continuar con la activación:"
                },
                "workwithus": {
                    "subject": "Alguien envió una consulta de trabaja con nosotros desde {appName}",
                    "title": "Alguien envió una consulta de trabaja con nosotros desde {appName}",
                    "reply-user": "Puede responder a este mensaje para responder al usuario ( {email} )"
                },
                "recruitment": {
                    "subject": "Alguien envió una consulta de reclutamiento y selección a éxito desde {appName}",
                    "title": "Alguien envió una consulta de reclutamiento y selección a éxito desde {appName}",
                    "reply-user": "Puede responder a este mensaje para responder al usuario ( {email} )"
                }
            }
        },
        "cards": {
            "offer-candidate": {
                "last-status-change": "Último cambio de estado"
            },
            "offer-employer": {
                "no-company-name": "Nombre de empresa no disponible",
                "status": {
                    "archived": "Cerrado",
                    "draft": "Borrador",
                    "open": "Abierto"
                },
                "actions": {
                    "view": "Ver anuncio",
                    "edit": "Editar anuncio",
                    "archive": "Archivar",
                    "copy": "Copiar",
                    "view-candidates": "Ver lista de candidatos",
                    "view-interns": "Ver becario para entrevista",
                    "multiprovince": "Multiprovincia",
                    "multiprovince.only-in-spain": "Solo en España!",
                    "multiprovince.only-active-offers": "Solo ofertas activas!",
                    "destroy": "Eliminar",
                    "share": "Compartir"
                },
                "candidate": {
                    "new": "Nuevo",
                    "seen": "Visto",
                    "accepted": "Aceptado",
                    "rejected": "Rechazado",
                    "invalid": "No se ajustan"
                }
            },
            "offer-application": {
                "accepted-text": "La empresa tiene en cuenta tu candidatura en el proceso.",
                "rejected-text": "La empresa ha desestimado tú candidatura."
            },
            "publish-offer": {
                "publish-now": "Publicar Ahora",
                "less-info": "Menos informacíon",
                "more-info": "Más informacíon",
                "your-ad-on": "Tu anuncio en"
            },
            "one-offer": {
                "actions": {
                    "view": "Ver oferta",
                    "view-candidates": "Ver candidatos",
                    "delegate-user": "Delegar candidato",
                    "delegate-offer": "Delega esta oferta",
                    "delegate-external-user": "Delegar candidato externo",
                    "archive": "Archivar",
                    "delete": "Borrar"
                }
            },
            "one-company": {
                "phone": "Teléfono",
                "status": "Estado",
                "status.confirmed": "Confirmada",
                "status.pending": "Pendiente",
                "status.rejected": "Rechazada"
            },
            "one-user": {
                "actions": {
                    "view": "Ver perfil",
                    "delegate-offer": "Delegar a una oferta",
                    "delegate-user": "Delegar a este usuario",
                    "manage-companies": "Administrar empresas"
                },
                "role": {
                    "candidate": "Candidato",
                    "company": "Empresa",
                    "headhunter": "Headhunter",
                    "admin": "Administrador"
                }
            },
            "referral": {
                "disabled": "Deshabilitado",
                "enabled": "Activo",
                "link": "Enlace",
                "created-at": "Creado",
                "updated-at": "Actualizado",
                "counter": "Contador"
            }
        },
        "data": {
            "countries": {
                "(Seleccionar)": "(Seleccionar)",
                "España": "España",
                "--- Extranjero ---": "--- Extranjero ---",
                "Andorra": "Andorra",
                "United Arab Emirates": "Emiratos Árabes Unidos",
                "Afghanistan": "Afganistán",
                "Antigua and Barbuda": "Antigua y Barbuda",
                "Anguilla": "Anguila",
                "Albania": "Albania",
                "Armenia": "Armenia",
                "Angola": "Angola",
                "Antarctica": "Antártida",
                "Argentina": "Argentina",
                "American Samoa": "Samoa Americana",
                "Austria": "Austria",
                "Australia": "Australia",
                "Aruba": "Aruba",
                "Aland Islands": "Islas Aland",
                "Azerbaijan": "Azerbaiyán",
                "Bosnia and Herzegovina": "Bosnia y Herzegovina",
                "Barbados": "Barbados",
                "Bangladesh": "Bangladesh",
                "Belgium": "Bélgica",
                "Burkina Faso": "Burkina Faso",
                "Bulgaria": "Bulgaria",
                "Bahrain": "Bahréin",
                "Burundi": "Burundi",
                "Benin": "Benin",
                "Saint Barthelemy": "San Bartolomé",
                "Bermuda": "Bermuda",
                "Brunei": "Brunei",
                "Bolivia": "Bolivia",
                "Bonaire, Saint Eustatius and Saba": "Bonaire, Sint Eustatius y Saba",
                "Brazil": "Brasil",
                "Bahamas": "Bahamas",
                "Bhutan": "Bután",
                "Bouvet Island": "Isla Bouvet",
                "Botswana": "Botswana",
                "Belarus": "Bielorrusia",
                "Belize": "Belice",
                "Canada": "Canadá",
                "Cocos Islands": "Islas Cocos",
                "Democratic Republic of the Congo": "República Democrática del Congo",
                "Central African Republic": "República Centroafricana",
                "Republic of the Congo": "Republic of the Congo",
                "Switzerland": "Suiza",
                "Ivory Coast": "Costa de Marfil",
                "Cook Islands": "Islas Cook",
                "Chile": "Chile",
                "Cameroon": "Camerún",
                "China": "China",
                "Colombia": "Colombia",
                "Costa Rica": "Costa Rica",
                "Cuba": "Cuba",
                "Cape Verde": "Cape Verde",
                "Curacao": "Curacao",
                "Christmas Island": "Isla de Navidad",
                "Cyprus": "Chipre",
                "Czech Republic": "Republica checa",
                "Germany": "Alemania",
                "Djibouti": "Djibouti",
                "Denmark": "Dinamarca",
                "Dominica": "Dominica",
                "Dominican Republic": "República Dominicana",
                "Algeria": "Argelia",
                "Ecuador": "Ecuador",
                "Estonia": "Estonia",
                "Egypt": "Egipto",
                "Western Sahara": "Sahara Occidental",
                "Eritrea": "Eritrea",
                "Ethiopia": "Etiopía",
                "Finland": "Finlandia",
                "Fiji": "Fiyi",
                "Falkland Islands": "Islas Malvinas",
                "Micronesia": "Micronesia",
                "Faroe Islands": "Islas Faroe",
                "France": "Francia",
                "Gabon": "Gabón",
                "United Kingdom": "Reino Unido",
                "Grenada": "Granada",
                "Georgia": "Georgia",
                "French Guiana": "Guayana Francesa",
                "Guernsey": "Guernsey",
                "Ghana": "Ghana",
                "Gibraltar": "Gibraltar",
                "Greenland": "Groenlandia",
                "Gambia": "Gambia",
                "Guinea": "Guinea",
                "Guadeloupe": "Guadeloupe",
                "Equatorial Guinea": "Guinea Ecuatorial",
                "Greece": "Grecia",
                "South Georgia and the South Sandwich Islands": "Georgia del sur y las islas Sandwich del sur",
                "Guatemala": "Guatemala",
                "Guam": "Guam",
                "Guinea-Bissau": "Guinea-Bissau",
                "Guyana": "Guayana",
                "Hong Kong": "Hong Kong",
                "Heard Island and McDonald Islands": "Islas Heard y McDonald",
                "Honduras": "Honduras",
                "Croatia": "Croacia",
                "Haiti": "Haití",
                "Hungary": "Hungría",
                "Indonesia": "Indonesia",
                "Ireland": "Irlanda",
                "Israel": "Israel",
                "Isle of Man": "Isla del hombre",
                "India": "India",
                "British Indian Ocean Territory": "Territorio Británico del Océano Índico",
                "Iraq": "Irak",
                "Iran": "Iran",
                "Iceland": "Islandia",
                "Italy": "Italia",
                "Jersey": "Jersey",
                "Jamaica": "Jamaica",
                "Jordan": "Jordán",
                "Japan": "Japón",
                "Kenya": "Kenia",
                "Kyrgyzstan": "Kirguistán",
                "Cambodia": "Camboya",
                "Kiribati": "Kiribati",
                "Comoros": "Comoros",
                "Saint Kitts and Nevis": "Saint Kitts y Nevis",
                "North Korea": "Corea del Norte",
                "South Korea": "Corea del Sur",
                "Kuwait": "Kuwait",
                "Cayman Islands": "Islas Caimán",
                "Kazakhstan": "Kazajstán",
                "Laos": "Laos",
                "Lebanon": "Líbano",
                "Saint Lucia": "Santa Lucía",
                "Liechtenstein": "Liechtenstein",
                "Sri Lanka": "Sri Lanka",
                "Liberia": "Liberia",
                "Lesotho": "Lesoto",
                "Lithuania": "Lituania",
                "Luxembourg": "Luxemburgo",
                "Latvia": "Letonia",
                "Libya": "Libia",
                "Morocco": "Marruecos",
                "Monaco": "Mónaco",
                "Moldova": "Moldavia",
                "Montenegro": "Montenegro",
                "Saint Martin": "San Martín",
                "Madagascar": "Madagascar",
                "Marshall Islands": "Islas Marshall",
                "Macedonia": "Macedonia",
                "Mali": "Mali",
                "Myanmar": "Myanmar",
                "Mongolia": "Mongolia",
                "Macao": "Macao",
                "Northern Mariana Islands": "Islas Marianas del Norte",
                "Martinique": "Martinica",
                "Mauritania": "Mauritania",
                "Montserrat": "Montserrat",
                "Malta": "Malta",
                "Mauritius": "Mauricio",
                "Maldives": "Maldivas",
                "Malawi": "Malawi",
                "Mexico": "México",
                "Malaysia": "Malasia",
                "Mozambique": "Mozambique",
                "Namibia": "Namibia",
                "New Caledonia": "Nueva Caledonia",
                "Niger": "Níger",
                "Norfolk Island": "Isla Norfolk",
                "Nigeria": "Nigeria",
                "Nicaragua": "Nicaragua",
                "Netherlands": "Países Bajos",
                "Norway": "Noruega",
                "Nepal": "Nepal",
                "Nauru": "Nauru",
                "Niue": "Niue",
                "New Zealand": "Nueva Zelanda",
                "Oman": "Omán",
                "Panama": "Panamá",
                "Peru": "Perú",
                "French Polynesia": "Polinesia Francés",
                "Papua New Guinea": "Papúa Nueva Guinea",
                "Philippines": "Filipinas",
                "Pakistan": "Pakistán",
                "Poland": "Polonia",
                "Saint Pierre and Miquelon": "San Pedro y Miquelón",
                "Pitcairn": "Pitcairn",
                "Puerto Rico": "Puerto Rico",
                "Palestinian Territory": "Territorio Palestino",
                "Portugal": "Portugal",
                "Palau": "Palau",
                "Paraguay": "Paraguay",
                "Qatar": "Katar",
                "Reunion": "Reunión",
                "Romania": "Rumania",
                "Serbia": "Serbia",
                "Russia": "Rusia",
                "Rwanda": "Ruanda",
                "Saudi Arabia": "Arabia Saudita",
                "Solomon Islands": "Islas Salomón",
                "Seychelles": "Seychelles",
                "Sudan": "Sudán",
                "Sweden": "Suecia",
                "Singapore": "Singapur",
                "Saint Helena": "Santa Elena",
                "Slovenia": "Eslovenia",
                "Svalbard and Jan Mayen": "Svalbard y Jan Mayen",
                "Slovakia": "Eslovaquia",
                "Sierra Leone": "Sierra Leona",
                "San Marino": "Sierra Leona",
                "Senegal": "Senegal",
                "Somalia": "Somalia",
                "Suriname": "Surinam",
                "South Sudan": "Sudán del Sur",
                "Sao Tome and Principe": "Santo Tomé y Príncipe",
                "El Salvador": "El Salvador",
                "Sint Maarten": "Sint Maarten",
                "Syria": "Siria",
                "Swaziland": "Swazilandia",
                "Turks and Caicos Islands": "Islas Turcas y Caicos",
                "Chad": "Chad",
                "French Southern Territories": "Territorios Franceses del Sur",
                "Togo": "Togo",
                "Thailand": "Tailandia",
                "Tajikistan": "Tayikistán",
                "Tokelau": "Tokelau",
                "East Timor": "Timor Oriental",
                "Turkmenistan": "Turkmenistán",
                "Tunisia": "Túnez",
                "Tonga": "Tonga",
                "Turkey": "Turquía",
                "Trinidad and Tobago": "Trinidad and Tobago",
                "Tuvalu": "Tuvalu",
                "Taiwan": "Taiwán",
                "Tanzania": "Tanzania",
                "Ukraine": "Ucrania",
                "Uganda": "Uganda",
                "United States Minor Outlying Islands": "Islas menores alejadas de los Estados Unidos",
                "United States": "Estados Unidos",
                "Uruguay": "Uruguay",
                "Uzbekistan": "Uzbekistan",
                "Vatican": "Vaticano",
                "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
                "Venezuela": "Venezuela",
                "British Virgin Islands": "Islas Vírgenes Británicas",
                "U.S. Virgin Islands": "Islas Vírgenes de EE.UU",
                "Vietnam": "Vietnam",
                "Vanuatu": "Vanuatu",
                "Wallis and Futuna": "Wallis and Futuna",
                "Samoa": "Samoa",
                "Kosovo": "Kosovo",
                "Yemen": "Yemen",
                "Mayotte": "Mayotte",
                "South Africa": "Sudáfrica",
                "Zambia": "Zambia",
                "Zimbabwe": "Zimbabue"
            },
            "provinces": {
                "(Seleccionar)": "(Seleccionar)",
                "A Coruña": "A Coruña",
                "Álava/Araba": "Álava/Araba",
                "Albacete": "Albacete",
                "Alicante/Alacant": "Alicante/Alacant",
                "Almería": "Almería",
                "Asturias": "Asturias",
                "Ávila": "Ávila",
                "Badajoz": "Badajoz",
                "Barcelona": "Barcelona",
                "Burgos": "Burgos",
                "Cáceres": "Cáceres",
                "Cádiz": "Cádiz",
                "Cantabria": "Cantabria",
                "Castellón/Castelló": "Castellón/Castelló",
                "Ceuta": "Ceuta",
                "Ciudad Real": "Ciudad Real",
                "Córdoba": "Córdoba",
                "Cuenca": "Cuenca",
                "Girona": "Girona",
                "Granada": "Granada",
                "Guadalajara": "Guadalajara",
                "Guipúzcoa/Gipuzkoa": "Guipúzcoa/Gipuzkoa",
                "Huelva": "Huelva",
                "Huesca": "Huesca",
                "Islas Baleares/Illes Balears": "Islas Baleares/Illes Balears",
                "Jaén": "Jaén",
                "La Rioja": "La Rioja",
                "Las Palmas": "Las Palmas",
                "León": "León",
                "Lleida": "Lleida",
                "Lugo": "Lugo",
                "Madrid": "Madrid",
                "Málaga": "Málaga",
                "Melilla": "Melilla",
                "Murcia": "Murcia",
                "Navarra": "Navarra",
                "Ourense": "Ourense",
                "Palencia": "Palencia",
                "Pontevedra": "Pontevedra",
                "Salamanca": "Salamanca",
                "Santa Cruz de Tenerife": "Santa Cruz de Tenerife",
                "Segovia": "Segovia",
                "Sevilla": "Sevilla",
                "Soria": "Soria",
                "Tarragona": "Tarragona",
                "Teruel": "Teruel",
                "Toledo": "Toledo",
                "Valencia/València": "Valencia/València",
                "Valladolid": "Valladolid",
                "Vizcaya/Bizkaia": "Vizcaya/Bizkaia",
                "Zamora": "Zamora",
                "Zaragoza": "Zaragoza"
            },
            "levels": {
                "Becario/a - Prácticas": "Becario/a - Prácticas",
                "Becario/a - Formación Profesionals": "Becario/a - Formación profesional",
                "Becario/a - Grado universitario o Máster": "Becario/a - Grado universitario o Máster",
                "Empleado/a": "Empleado/a",
                "Especialista": "Especialista",
                "Mando intermedio": "Mando intermedio",
                "Dirección / gerencia": "Dirección / gerencia",
                "Consejo directivo": "Consejo directivo"
            },
            "categories": {
                "(Seleccionar)": "(Seleccionar)",
                "Administración Publica": "Administración pública",
                "Administración de empresas": "Administración de empresas",
                "Atención a clientes": "Atención a clientes",
                "Calidad, producción e I+D": "Calidad, producción e I+D",
                "Comercial y ventas": "Comercial y ventas",
                "Compras, logística y almacén": "Compras, logística y almacén",
                "Diseño y artes gráficas": "Diseño y artes gráficas",
                "Educación y formación": "Educación y formación",
                "Finanzas y banca": "Finanzas y banca",
                "Informática y telecomunicaciones": "Informática y telecomunicaciones",
                "Inginerios y técnicos": "Ingenieros y técnicos",
                "Immobiliario y construcción": "Immobiliario y construcción",
                "Legal": "Legal",
                "Marketing y comunicación": "Marketing y comunicación",
                "Profesionales, artes y oficios": "Profesionales, artes y oficios",
                "Recursos humanos": "Recursos humanos",
                "Sanidad y salud": "Sanidad y salud",
                "Sector Farmacéutico": "Sector Farmacéutico",
                "Turismo y restauración": "Turismo y restauración",
                "Ventas al detalle": "Ventas al detalle",
                "Otros": "Otros"
            },
            "subcategories": {
                "(Seleccionar)": "(Seleccionar)",
                "Administraciones europeas": "Administraciones europeas",
                "Administración autonómica": "Administración autonómica",
                "Administración del Estado": "Administración del Estado",
                "Administración local": "Administración local",
                "Cuerpos de seguridad": "Cuerpos de seguridad",
                "Empresas públicas": "Empresas públicas",
                "Empresa Privada": "Empresa Privada",
                "Administración": "Administración",
                "Auditoría": "Auditoría",
                "Consultoría": "Consultoría",
                "Dirección y gerencia": "Dirección y gerencia",
                "Facturación, cobros y pagos": "Facturación, cobros y pagos",
                "Finanzas y contabilidad": "Finanzas y contabilidad",
                "Negociación y contratación": "Negociación y contratación",
                "Operaciones societarias": "Operaciones societarias",
                "Organización de la empresa": "Organización de la empresa",
                "Recepción": "Recepción",
                "Secretariado": "Secretariado",
                "Atención al cliente": "Atención al cliente",
                "Promoción y ferias": "Promoción y ferias",
                "Certificación de calidad": "Certificación de calidad",
                "Gestión de la calidad": "Gestión de la calidad",
                "Gestión de proyectos": "Gestión de proyectos",
                "Investigación y desarrollo": "Investigación y desarrollo",
                "Mantenimiento": "Mantenimiento",
                "Medio ambiente": "Medio ambiente",
                "Metrología": "Metrología",
                "Operaciones": "Operaciones",
                "Agente comercial": "Agente comercial",
                "Comercial": "Comercial",
                "Comercio exterior": "Comercio exterior",
                "Gran cuenta": "Gran cuenta",
                "Televenta y marketing telefónico": "Televenta y marketing telefónico",
                "Almacén": "Almacén",
                "Compras y aprovisionamiento": "Compras y aprovisionamiento",
                "Distribución y logística": "Distribución y logística",
                "Creación audiovisual": "Creación audiovisual",
                "Diseño gráfico": "Diseño gráfico",
                "Diseño industrial": "Diseño industrial",
                "Diseño web": "Diseño web",
                "Editorial e imprenta": "Editorial e imprenta",
                "Moda y confección": "Moda y confección",
                "Educación especial": "Educación especial",
                "Educación social": "Educación social",
                "Enseñanza": "Enseñanza",
                "Gestión de centros educativos": "Gestión de centros educativos",
                "Pedagogía": "Pedagogía",
                "Puericultura": "Puericultura",
                "Banca empresarial": "Banca empresarial",
                "Banca privada": "Banca privada",
                "Bolsa, valores e inversión": "Bolsa, valores e inversión",
                "Productos y servicios bancarios": "Productos y servicios bancarios",
                "Seguros": "Seguros",
                "Administración de bases de datos": "Administración de bases de datos",
                "Análisis": "Análisis",
                "Arquitectura": "Arquitectura",
                "Calidad": "Calidad",
                "ERP, CRM, Business Intelligence": "ERP, CRM, Business Intelligence",
                "Hardware, redes y seguridad": "Hardware, redes y seguridad",
                "Helpdesk": "Helpdesk",
                "Programación": "Programación",
                "Sistemas": "Sistemas",
                "Telecomunicaciones": "Telecomunicaciones",
                "Aeronáutico": "Aeronáutico",
                "Agrónomo y montes": "Agrónomo y montes",
                "Electrónica": "Electrónica",
                "Electrónica y automática industrial": "Electrónica y automática industrial",
                "Energias Renovables": "Energias Renovables",
                "Geología, geodesia y cartografía": "Geología, geodesia y cartografía",
                "Industrial": "Industrial",
                "Minas": "Minas",
                "Naval y oceánico": "Naval y oceánico",
                "Organización industrial": "Organización industrial",
                "Otras ingenierías": "Otras ingenierías",
                "Químico": "Químico",
                "Sistemas de defensa": "Sistemas de defensa",
                "Administración inmobiliaria": "Administración inmobiliaria",
                "Arquitectura y proyección": "Arquitectura y proyección",
                "Dirección y gestión de obras": "Dirección y gestión de obras",
                "Ingeniería civil y obras públicas": "Ingeniería civil y obras públicas",
                "Ingeniería de materiales": "Ingeniería de materiales",
                "Interiorismo": "Interiorismo",
                "Oficios de la construcción": "Oficios de la construcción",
                "Derecho civil, penal y constitucional": "Derecho civil, penal y constitucional",
                "Derecho internacional": "Derecho internacional",
                "Derecho procesal": "Derecho procesal",
                "Derecho y empresa": "Derecho y empresa",
                "Notaría y registros": "Notaría y registros",
                "Comunicación corporativa": "Comunicación corporativa",
                "Desarrollo de marca y producto": "Desarrollo de marca y producto",
                "Investigación de mercados": "Investigación de mercados",
                "Marketing": "Marketing",
                "Periodismo y edición": "Periodismo y edición",
                "Producción": "Producción",
                "Publicidad": "Publicidad",
                "RRPP y eventos": "RRPP y eventos",
                "Técnicas audiovisuales": "Técnicas audiovisuales",
                "Agricultura y jardinería": "Agricultura y jardinería",
                "Artes interpretativas": "Artes interpretativas",
                "Artes plásticas": "Artes plásticas",
                "Artesanía": "Artesanía",
                "Automoción": "Automoción",
                "Carpintería": "Carpintería",
                "Confección": "Confección",
                "Consumo y alimentación": "Consumo y alimentación",
                "Electricidad": "Electricidad",
                "Estética y cosmética": "Estética y cosmética",
                "Fontanería": "Fontanería",
                "Fotografía": "Fotografía",
                "Limpieza": "Limpieza",
                "Otros oficios": "Otros oficios",
                "Seguridad y vigilancia": "Seguridad y vigilancia",
                "Traducción e interpretación": "Traducción e interpretación",
                "Transporte": "Transporte",
                "Formación": "Formación",
                "Prevención de riesgos": "Prevención de riesgos",
                "Relaciones laborales": "Relaciones laborales",
                "Selección de personal": "Selección de personal",
                "Enfermería": "Enfermería",
                "Farmacia": "Farmacia",
                "Medicina especializada": "Medicina especializada",
                "Medicina general": "Medicina general",
                "Medicinas alternativas": "Medicinas alternativas",
                "Odontología": "Odontología",
                "Otras profesiones sanitarias": "Otras profesiones sanitarias",
                "Psicología": "Psicología",
                "Veterinaria": "Veterinaria",
                "Acceso al mercado y relaciones institucionales": "Acceso al mercado y relaciones institucionales",
                "Asuntos regulatorios": "Asuntos regulatorios",
                "Calidad, producción e I+D": "Calidad, producción e I+D",
                "Comercial y ventas": "Comercial y ventas",
                "Investigación clínica y asuntos médicos": "Investigación clínica y asuntos médicos",
                "Marketing y comunicación": "Marketing y comunicación",
                "Hostelería": "Hostelería",
                "Restauración": "Restauración",
                "Turismo": "Turismo",
                "Venta al detalle": "Venta al detalle",
                "Sin especificar": "Sin especificar"
            },
            "staff": {
                "(Seleccionar)": "(Seleccionar)"
            },
            "salaries": {
                "(Seleccionar)": "(Seleccionar)"
            },
            "salaryTypes": {
                "(Seleccionar)": "(Seleccionar)",
                "Bruto/año": "Bruto/año",
                "Bruto/mes": "Bruto/mes",
                "Bruto/hora": "Bruto/hora"
            },
            "contractTypes": {
                "(Seleccionar)": "(Seleccionar)",
                "Autónomo": "Autónomo",
                "De duración determinada": "De duración determinada",
                "De relevo": "De suplencia",
                "Fijo discontinuo": "Fijo discontinuo",
                "Formativo": "Formativo",
                "Indefinido": "Indefinido",
                "A tiempo parcial": "A tiempo parcial",
                "Otros contratos": "Otros contratos"
            },
            "contractWorkdays": {
                "(Seleccionar)": "(Seleccionar)",
                "Completa": "Completa",
                "Indiferente": "Indiferente",
                "Parcial - Mañana": "Parcial - Mañana",
                "Parcial - Tarde": "Parcial - Tarde",
                "Parcial - Noche": "Parcial - Noche",
                "Parcial - Indifirente": "Parcial - Indiferente",
                "Intensiva - Mañana": "Intensiva - Mañana",
                "Intensiva - Tarde": "Intensiva - Tarde",
                "Intensiva - Noche": "Intensiva - Noche",
                "Intensiva - Indifirente": "Intensiva - Indiferente"
            },
            "experience": {
                "(Seleccionar)": "(Seleccionar)",
                "No tengo": "No tengo",
                "No Requerida": "No Requerida",
                "Al menos 1 año": "Al menos 1 año",
                "Al menos 2 años": "Al menos 2 años",
                "Al menos 3 años": "Al menos 3 años",
                "Al menos 4 años": "Al menos 4 años",
                "Más de 5 años": "Más de 5 años",
                "Más de 10 años": "Más de 10 años"
            },
            "industryTypes": {
                "(Seleccionar)": "(Seleccionar)",
                "Actividades inmobiliarias": "Actividades inmobiliarias",
                "Administración gubernamental": "Administración gubernamental",
                "Agricultura, ganadería y pesca": "Agricultura, ganadería y pesca",
                "Agroalimentario": "Agroalimentario",
                "Animación": "Animación",
                "Apuestas y casinos": "Apuestas y casinos",
                "Arquitectura y planificación": "Arquitectura y planificación",
                "Artes escénicas": "Artes escénicas",
                "Artesanía": "Artesanía",
                "Artículos de lujo y joyería": "Artículos de lujo y joyería",
                "Artículos deportivos": "Artículos deportivos",
                "Atención sanitaria y hospitalaria": "Atención sanitaria y hospitalaria",
                "Audiovisual": "Audiovisual",
                "Automoción": "Automoción",
                "Banca": "Banca",
                "Banca de inversiones": "Banca de inversiones",
                "Bellas Artes": "Bellas Artes",
                "Bibliotecas": "Bibliotecas",
                "Biotecnología": "Biotecnología",
                "Cadena de suministro": "Cadena de suministro",
                "Capital de riesgo y capital privado": "Capital de riesgo y capital privado",
                "Construcción": "Construcción",
                "Consultoría de estrategia y operaciones": "Consultoría de estrategia y operaciones",
                "Cooperación y desarrollo internacional": "Cooperación y desarrollo internacional",
                "Cosmética": "Cosmética",
                "Cristal, cerámica y hormigón": "Cristal, cerámica y hormigón",
                "Departamento de defensa y del espacio exterior": "Departamento de defensa y del espacio exterior",
                "Deportes": "Deportes",
                "Desarrollo de programación": "Desarrollo de programación",
                "Diseño": "Diseño",
                "Diseño gráfico": "Diseño gráfico",
                "Editorial": "Editorial",
                "Educación": "Educación",
                "Electrónica de consumo": "Electrónica de consumo",
                "Eléctrica": "Eléctrica",
                "Energía renovable y medio ambiente": "Energía renovable y medio ambiente",
                "Entretenimiento": "Entretenimiento",
                "Equipos informáticos": "Equipos informáticos",
                "Fotografía": "Fotografía",
                "Gestión de inversiones": "Gestión de inversiones",
                "Gran consumo y alimentación": "Gran consumo y alimentación",
                "Hostelería y restaurantes": "Hostelería y restaurantes",
                "Importación y exportación": "Importación y exportación",
                "Imprenta": "Imprenta",
                "Industria aeroespacial y aviación": "Industria aeroespacial y aviación",
                "Industria farmaceútica": "Industria farmaceútica",
                "Industria química": "Industria química",
                "Industria textil y moda": "Industria textil y moda",
                "Infraestructuras": "Infraestructuras",
                "Ingeniería": "Ingeniería",
                "Instalaciones y servicios recreativos": "Instalaciones y servicios recreativos",
                "Internet": "Internet",
                "Investigación": "Investigación",
                "Investigación de mercado": "Investigación de mercado",
                "Logística": "Logística",
                "Maquinaria": "Maquinaria",
                "Marketing y publicidad": "Marketing y publicidad",
                "Material y equipo de negocios": "Material y equipo de negocios",
                "Medicina alternativa": "Medicina alternativa",
                "Medios de comunicación offline": "Medios de comunicación offline",
                "Medios de comunicación online": "Medios de comunicación online",
                "Mercados de capital": "Mercados de capital",
                "Minería y metalurgia": "Minería y metalurgia",
                "Museos e instituciones": "Museos e instituciones",
                "Música": "Música",
                "Naval": "Naval",
                "ONG y servicios sociales": "ONG y servicios sociales",
                "Petróleo y energía": "Petróleo y energía",
                "Plástico, papel y madera": "Plástico, papel y madera",
                "Producción multimedia": "Producción multimedia",
                "Programas informáticos": "Programas informáticos",
                "Protección civil": "Protección civil",
                "Publicidad, RRPP y eventos": "Publicidad, RRPP y eventos",
                "Salud, bienestar y fitness": "Salud, bienestar y fitness",
                "Seguros": "Seguros",
                "Servicios de RRHH": "Servicios de RRHH",
                "Servicios de asesoría y auditoría": "Servicios de asesoría y auditoría",
                "Servicios de seguridad": "Servicios de seguridad",
                "Servicios financieros": "Servicios financieros",
                "Servicios jurídicos": "Servicios jurídicos",
                "Servicios medioambientales": "Servicios medioambientales",
                "Servicios y tecnología de la información": "Servicios y tecnología de la información",
                "Tabacalera": "Tabacalera",
                "Telecomunicaciones": "Telecomunicaciones",
                "Telemarketing": "Telemarketing",
                "Traducción": "Traducción",
                "Transporte y mensajeria": "Transporte y mensajeria",
                "Turismo": "Turismo",
                "Venta al por mayor": "Venta al por mayor",
                "Venta al por menor": "Venta al por menor",
                "Veterinaria": "Veterinaria",
                "Videojuegos": "Videojuegos",
                "Otras actividades": "Otras actividades"
            },
            "languages": {
                "(Seleccionar)": "(Seleccionar)",
                "Español": "Español",
                "Catalán": "Catalán",
                "Inglés": "Inglés",
                "Francés": "Francés"
            },
            "languageLevels": {
                "(Seleccionar)": "(Seleccionar)",
                "nulo": "Nulo",
                "basico": "Básico",
                "intermedio": "Intermedio",
                "avanzado": "Avanzado",
                "nativo": "Nativo"
            },
            "educations": {
                "(Seleccionar)": "(Seleccionar)",
                "Enseñanzas artísticas (regladas)": "Enseñanzas artísticas (regladas)",
                "Enseñanzas deportivas (regladas)": "Enseñanzas deportivas (regladas)",
                "Formación Profesional Grado Medio": "Formación Profesional Grado Medio",
                "Ciclo Formativo Grado Medio": "Ciclo Formativo Grado Medio",
                "Diplomatura": "Diplomatura",
                "Ingeniería Técnica": "Ingeniería Técnica",
                "Grado": "Grado",
                "Licenciatura": "Licenciatura",
                "Ingeniería Superior": "Ingeniería Superior",
                "Postgrado": "Postgrado",
                "Máster": "Máster",
                "Doctorado": "Doctorado"
            },
            "contactFormTypes": {
                "(Seleccionar)": "(Seleccionar)",
                "Consulta": "Consulta",
                "Incidencia": "Incidencia",
                "Sugerencia": "Sugerencia"
            },
            "promos": {
                "offer": "Oferta",
                "multiprovince": "Multiprovincias"
            },
            "minimumStudies": {
                "Otros títulos, certificaciones y carnés": "Otros títulos, certificaciones y carnés",
                "Otros cursos y formación no reglada": "Otros cursos y formación no reglada",
                "Sin estudios": "Sin estudios",
                "Educación Secundaria Obligatoria": "Educación Secundaria Obligatoria",
                "Enseñanzas artísticas (regladas)": "Enseñanzas artísticas (regladas)",
                "Enseñanzas deportivas (regladas)": "Enseñanzas deportivas (regladas)",
                "Formación Profesional Grado Medio": "Formación Profesional Grado Medio",
                "Ciclo Formativo Grado Medio": "Ciclo Formativo Grado Medio",
                "Bachillerato": "Bachillerato",
                "Formación Profesional Grado Superior": "Formación Profesional Grado Superior",
                "Ciclo Formativo Grado Superior": "Ciclo Formativo Grado Superior",
                "Diplomatura": "Diplomatura",
                "Ingeniería Técnica": "Ingeniería Técnica",
                "Grado": "Grado",
                "Licenciatura": "Licenciatura",
                "Ingeniería Superior": "Ingeniería Superior",
                "Postgrado": "Postgrado",
                "Máster": "Máster",
                "Doctorado": "Doctorado"
            }
        },
        "generic": {
            "home": "Inicio",
            "login": "Iniciar sesión",
            "send": "Enviar",
            "on": "Sobre",
            "back": "Volver",
            "vat": "IVA",
            "cif": "CIF",
            "yes": "Sí",
            "privacy-policy": {
                "title": "políticas de privacidad",
                "content": "Te informamos que los datos de carácter personal que nos\nproporciones rellenando el presente formulario serán\ntratados por Aicad Business School S.L como responsable\nde Planetajob. La finalidad de la recogida y tratamiento\nde los datos personales que te solicitamos es paraenviarte\nnuestras publicaciones, promociones de productos y/o\nservicios y recursos exclusivos.\nLa legitimación se realiza a través del consentimiento del\ninteresado. Podrás ejercer tus derechos de acceso, rectificación,\nlimitación y suprimir los datos en info@planetajob.es. Puedes\nconsultar la información adicional y detallada sobre Protección\nde Datos en nuestra"
            },
            "loading": "Cargando",
            "course": "Curso",
            "degree": "Grado",
            "language": "Idioma",
            "dashboard": "Panel",
            "sign-in": "Accede",
            "sign-off": "Cerrar sesión",
            "sign-up": "Date de alta",
            "new": "Nuevo",
            "seen": "Visto",
            "inprocess": "En proceso",
            "invalid": "Inválido",
            "accepted": "Aceptado",
            "confirm": "Confirmar",
            "confirmed": "Confirmado",
            "delete": "Eliminar",
            "rejected": "Rechazado",
            "reject": "Rechazar",
            "pending": "Pendiente",
            "optional": "opcional",
            "success": "Éxito",
            "error": "Error",
            "warning": "Advertencia",
            "something-went-wrong": "Algo salió mal",
            "try-to-refresh": "Intenta actualizar la página",
            "try-again": "Por favor inténtelo de nuevo",
            "limited-features": "Algunas de las funciones pueden ser limitadas",
            "offer": "Oferta",
            "multiprovince": "Multiprovincia",
            "actions": "Acciones",
            "clear": "Limpiar",
            "reset": "Reiniciar",
            "edit": "Editar",
            "save": "Guardar",
            "save-draft": "Guardar Borrador",
            "change": "Cambiar",
            "save-changes": "Guardar cambios",
            "cancel": "Cancelar",
            "ok": "OK",
            "accept": "Aceptar",
            "select": "Seleccione",
            "continue": "CONTINUAR",
            "hidden-contact-details": "Datos de contacto ocultos",
            "hidden-company-name": "Nombre de empresa no disponible",
            "previous": "Anterior",
            "next": "Siguiente",
            "add-more": "Añadir más",
            "add": "Añadir",
            "add-new": "Añadir nuevo",
            "question": "Pregunta {no}",
            "answer": "Respuesta {no}",
            "archived": "Archivado",
            "unpaid": "No pagado",
            "active": "Activo",
            "verified": "Verificado",
            "type": "Tipo",
            "code": "Código",
            "limit": "Límite de uso",
            "id": "ID",
            "phone": "Teléfono",
            "status": "Estado",
            "present": "Actualmente",
            "abroad": "Extranjero",
            "all-spain": "Toda España",
            "year": "año",
            "month": "mes",
            "hour": "hora",
            "browse": "Examinar",
            "char-counter": "{current}/{max} caracteres",
            "result": "Resultado",
            "salary-from-to": "{min} - {max} {type}",
            "salary-from-to.placeholder": "Min - max",
            "salary-more-than": "Más de {min} {type}",
            "salary-more-than.placeholder": "Más de",
            "salary-dont-show": "Salario no disponible",
            "english": "Inglés",
            "spanish": "Español",
            "ingles": "Inglés",
            "espanol": "Español",
            "catalan": "Catalán",
            "frances": "Francés"
        },
        "validations": {
            "alphanumeric": "Este campo solo puede tener caracteres alfanuméricos",
            "number": "Este campo debe ser un número",
            "min-length": "Este campo debe tener al menos {count} caracteres",
            "max-length": "Este campo puede tener como máximo {count} caracteres",
            "required": "Este es un campo obligatorio",
            "required.number": "Este es un campo obligatorio y debe ser un número",
            "required.min-length": "Este es un campo obligatorio y debe tener al menos {count} caracteres",
            "email.unique": "El correo electronico ya ha sido tomado",
            "first_name.required": "Se requiere el primer nombre",
            "last_name.required": "Se requiere apellido",
            "city.required": "Ciudad es requerida",
            "phone.required": "Se requiere teléfono",
            "password.required": "Se requiere contraseña",
            "promocode.unique": "El nombre del código de activación debe ser único"
        },
        "pages": {
            "home": {
                "filters-offers": {
                    "title": "ENCUENTRA TRABAJO",
                    "apprenticeships": "BECAS & PRÁCTICAS",
                    "it-jobs": "TRABAJOS IT",
                    "remote-jobs": "TRABAJA DESDE CASA",
                    "director-jobs": "DIRECTIVOS"
                },
                "city-offers": {
                    "title": "TRABAJA EN EL LUGAR QUE QUIERAS",
                    "madrid": "MADRID",
                    "barcelona": "BARCELONA",
                    "valencia": "VALENCIA",
                    "bilbao": "BILBAO"
                }
            },
            "accept-cookies": {
                "alert-title": "Al continuar navegando, acepta nuestro uso de",
                "cookies": "Cookies",
                "accept": "De acuerdo"
            },
            "public-offers": {
                "search-keyword-status": "{total} ofertas de trabajo de {phrase} encontradas",
                "search-location-status": "{total} ofertas de trabajo encontradas en {place}",
                "search-status": "{total} ofertas de trabajo encontradas",
                "no-offers": "Aún no hay ofertas",
                "view-all-offers": "Ver todas las ofertas",
                "filters": {
                    "order-by": {
                        "order-by": "Ordenar ofertas por:",
                        "by-date": "Fecha de publicación"
                    },
                    "date": {
                        "date": "Fecha:",
                        "any-date": "Cualquier fecha",
                        "24-hours": "Últimas 24 horas",
                        "7-days": "Últimos 7 días",
                        "15-days": "Últimos 15 días"
                    },
                    "keyword": {
                        "keyword": "Palabra clave:",
                        "ok": "OK"
                    },
                    "place": {
                        "place": "Lugar:"
                    },
                    "category": {
                        "category": "Categoría del puesto:"
                    },
                    "min-studies": {
                        "min-studies": "Estudios mínimos:"
                    },
                    "experience": {
                        "experience": "Experiencia (años)",
                        "min": "Min",
                        "max": "Max"
                    },
                    "salary": {
                        "salary": "Salario mínimo"
                    },
                    "contract": {
                        "contract": "Tipo de contrato"
                    },
                    "shifts": {
                        "shifts": "Jornada laboral"
                    },
                    "expansion-bag": {
                        "show-more": "Mostrar más",
                        "show-less": "Mostrar menos"
                    },
                    "show-filters": "Mostrar filtros"
                },
                "card": {
                    "no-company-name": "Nombre de empresa no disponible",
                    "new": "Nueva",
                    "contract": {
                        "contract": "Contrato"
                    },
                    "workday": {
                        "workday": "Jornada"
                    },
                    "salary": {
                        "more-than": "Más de",
                        "no-salary": "Salario no disponible"
                    }
                }
            },
            "help": {
                "title": "Ayuda",
                "subtitle": "Ayuda de {portal}",
                "no-answer": "¿No encuentras lo que buscas?",
                "contact-us": "CONTÁCTANOS",
                "register-validate-email": {
                    "subject": "Darse de alta / Validar email",
                    "enquiry1": {
                        "question": "Soy candidato, ¿cómo puedo darme de alta en {portal}?",
                        "answer": "\n<ul>\n    <li class='mb-3'>\n        En la página principal, ve a la  esquina superior derecha y haz\n        clic en el botón Acceso Candidatos, serás dirigido a la página de acceso de los\n        candidatos. Una vez allí, selecciona la opción Regístrate Ahora.\n    </li>\n    <li>\n        Cumplimenta el formulario de registro. Al finalizar enviaremos a tu correo\n        electrónico un mensaje para la confirmación de tu correo electrónico y activación\n        de tu cuenta.\n    </li>\n</ul>"
                    },
                    "enquiry2": {
                        "question": "Ya me di de alta, ¿cómo se valida mi correo electrónico?",
                        "answer": "\n<div class='mb-3'>\n    Una vez que te hayas registrado en Planetajob, recibirás un correo electrónico para\n    la validación de tu correo electrónico, debes hacer clic en el botón Activar\n    PlanetaJob Ahora. \n</div>\n<div>\n    ¡Listo! ahora puedes crear tu CV e inscribirte a las ofertas de empleo.\n</div>"
                    },
                    "enquiry3": {
                        "question": "¿Qué puedo hacer  si no recibo el email para validar mi cuenta?",
                        "answer": "\n<ul>\n            <li>\n                Comprueba tu carpeta de correo no deseado o Spam.\n            </li>\n            <li>\n                Si en 48 horas no validas tu registro, intenta registrarte de nuevo. \n            </li>\n            <li>\n                <u><strong>Importante:</u></strong> Por ahora estamos teniendo problemas\n                para validar correos electrónicos de Hotmail. Te recomendamos crear tu\n                cuenta con un correo electrónico de otro proveedor como Gmail. \n            </li>\n</ul>"
                    }
                },
                "access-my-account": {
                    "subject": "Acceso a mi cuenta",
                    "enquiry1": {
                        "question": "¿Cómo accedo a mi cuenta?",
                        "answer": "\n<ul class='mb-3'>\n    <li>\n        En la página principal, ve a la  esquina superior derecha y encontrarás el botones\n        Acceso Empresas y  Acceso Candidato\n    </li>\n</ul>\n<ul class='mb-3'>\n    <li>\n        Haz clic en el botón según tu perfil \n    </li>\n    <li>\n        Serás redirigido a la página de login donde debes ingresar:\n    </li>\n    <ul>\n        <li>correo electrónico con el cual te diste de alta</li>\n        <li>contraseña</li>\n        <li>Clica en el botón Iniciar Sesión</li>\n    </ul>\n</ul>\n<div class='ml-4'>\n    ¡Listo! Ya estás en tu cuenta de Planetajob.\n</div>"
                    },
                    "enquiry2": {
                        "question": "He olvidado mi contraseña de acceso de Planetajob",
                        "answer": "\n<ul>\n    <li>\n        Si has olvidado tu contraseña de acceso a Planetajob puedes restablecerla haciendo\n        clic en el enlace ¿Has olvidado la contraseña? ubicado en la parte inferior de la\n        página de acceso a Planetajob. \n    </li>\n    <li>\n        Introduce el correo electrónico con el cual te diste de alta. \n    </li>\n    <li>\n    Te enviaremos un email con las instrucciones para restablecer tu contraseña.\n    </li>\n</ul>"
                    },
                    "enquiry3": {
                        "question": "No puedo acceder a {portal} después de cambiar la contraseña",
                        "answer": "\n<div>\n    <div class='mb-2'>\n        Si no puedes acceder a tu cuenta después de restablecer tu contraseña de acceso a Planetajob\n        prueba las siguientes opciones:\n    </div>\n    <ul>\n        <li>Verifica que tu navegador esté actualizado.</li>\n        <li>Eliminar las cookies y archivos temporales.</li>\n        <li>\n            Si los problemas de acceso persisten, ponte en contacto con nosotros a través del \n            correo electrónico info@planetajob.es.\n        </li>\n    </ul>\n</div>"
                    },
                    "enquiry4": {
                        "question": "¿Puedo cambiar mi contraseña de {portal} en cualquier momento?",
                        "answer": "Sí, puedes cambiar tu contraseña actual. Para ello debes entrar en tu perfil, ir a la\n                sección Mi cuenta / Configuraciones de cuenta, escribe la nueva contraseña, debe tener\n                como mínimo 6 caracteres, repite la nueva contraseña y guarda los cambios."
                    },
                    "enquiry5": {
                        "question": "¿Puedo eliminar mi cuenta de Planetajob?",
                        "answer": "\n<div class='mb-3'>\n    Sí, puedes eliminar tu de Planetajob. Para ello debes entrar en tu perfil, ir a la sección Mi\n    cuenta / Configuraciones de cuenta / Eliminar cuenta.\n</div>\n<div>\n    <strong>Advertencia</strong>: Una vez que borres tu cuenta, sólo el administrador podrá recuperarla\n    en un máximo de 15 días, tras ello será eliminada.\n</div>"
                    }
                },
                "cv-my-data": {
                    "subject": "CV / Mis datos",
                    "enquiry1": {
                        "question": "¿Cómo puedo crear mi CV?",
                        "answer": "\n<div>\n    <div>\n        Para crear tu CV, debes acceder a tu cuenta de Planetajob. Una vez allí, debes dirigirte a la\n        pestaña Mi CV y completar los datos de cada una de las secciones: \n    </div>\n    <ul>\n        <li>Mi situación laboral</li>\n        <li>Mis idiomas</li>\n        <li>Mis competencias</li>\n        <li>Mi educación</li>\n        <li>Lugares en donde he trabajado</li>\n        <li>Escribir tu CV en texto</li>\n        <li>Subir mi CV</li>\n    </ul>\n</div>"
                    },
                    "enquiry2": {
                        "question": "¿Puedo editar mi CV?",
                        "answer": "\n<div>\n    <div>\n        Sí, puedes actualizar la información de tu CV en cualquier momento, solo debes ingresar\n        a tu cuenta y dirigirte a la pestaña MI CV  y seleccionar la sección o secciones que\n        deseas editar. \n    </div>\n    <ul>\n        <li>Mi situación laboral</li>\n        <li>Mis idiomas</li>\n        <li>Mis competencias</li>\n        <li>Mi educación</li>\n        <li>Lugares en donde he trabajado</li>\n        <li>Escribir tu CV en texto</li>\n        <li>Subir mi CV</li>\n    </ul>\n</div>"
                    },
                    "enquiry3": {
                        "question": "¿Puedo editar mi perfil?",
                        "answer": "\n<div>\n    Sí, puedes editar la información de tu perfil en cualquier momento. Para ello, debes ingresar a tu\n    cuenta y dirigirte a la pestaña MI Cuenta / Tus datos de usuario / Editar perfil.\n</div>"
                    }
                },
                "offers-and-recommendations": {
                    "subject": "Ofertas y recomendaciones",
                    "enquiry1": {
                        "question": "¿Qué puedo hacer si veo ofertas repetidas o que parecen fraudulentas?",
                        "answer": "Si has iniciado sesión verás que debajo del botón inscribirse (el de debajo\nde la página) hay un enlace en el que puedes denunciar las ofertas que consideres fraudulentas\nindicándonos el motivo. Desde {portal} tomaremos las medidas que creamos oportunas para frenar\ncualquier comportamiento que no encaje con lo recogido en nuestras características y reglas de uso\npara la publicación de ofertas en InfoJobs."
                    },
                    "enquiry2": {
                        "question": "¿Qué son las Ofertas para ti?",
                        "answer": "Son ofertas recomendadas para ti, en base a tus búsquedas, inscripciones y experiencia\nlaboral. Analizamos qué ofertas buscas, en qué ofertas te inscribes y la experiencia laboral de tu\nCV. Así podremos encontrar ofertas que encajen con tus intereses y recomendártelas. ¿Dónde encuentro\nlas Ofertas para ti? En la app de Android, las encontrarás como sección del menú. En la Web, están\nubicadas en la parte inferior de la página “Mi {portal}”. ¿Sustituyen a las búsquedas que hago\nhabitualmente? No las sustituyen, las complementan. Sigue buscando e inscribiéndote como hasta ahora,\nasí podremos aprender sobre tus intereses y recomendarte aquellas ofertas que te pueden interesar. ¿Por\nqué veo pocas recomendaciones? El listado de recomendaciones tiene un máximo de 10 ofertas. Pero se van\nrenovando para que siempre tengas nuevas ofertas. ¿Por qué a veces no tengo recomendaciones? Puede que en\nalguna ocasión la sección esté vacía. Para que podamos ofrecerte recomendaciones, primero debes buscar e\ninscribirte en ofertas como lo haces habitualmente. Así, podremos aprender sobre tus intereses y\nencontraremos aquellas ofertas interesantes para ti."
                    }
                },
                "inscriptions-and-applications": {
                    "subject": "Inscripciones y candidaturas",
                    "enquiry1": {
                        "question": "¿Cómo puedo inscribirme a una oferta de empleo?",
                        "answer": "\n<div class='mb-3'>\n    Primero debes completar la información de tu CV, luego podrás ir al buscador de ofertas y seleccionar\n    las ofertas de empleo de tu interés. \n</div>\n<div class='mb-3'>\n    Para inscribir tu candidatura, haz clic sobre el botón Inscribirme en esta oferta, se abrirá una nueva\n    ventana en la que se mostrará tu CV actual,podrás incluir una carta de presentación y responder a las\n    preguntas del test de evaluación (si la oferta lo amerita). \n</div>\n<div>\n    Luego debes confirmar tu inscripción y ¡listo! Te has inscrito en la oferta de empleo.\n</div>\n            \n            Aunque te hayas dado de alta en {portal}, para poder inscribirte en las ofertas\nde empleo debes tener completados, como mínimo, los 3 primeros pasos de tu CV (Datos personales,\nEstudios y Experiencia). Cuando estén completos estos pasos podrás inscribirte en ofertas."
                    },
                    "enquiry2": {
                        "question": "Ya me inscribí en una oferta de empleo, ¿cómo puedo ver el estado de mi candidatura?",
                        "answer": "Para conocer el estado de tu candidatura, accede a tu cuenta y ve a la pestaña Candidaturas,\n            allí se encontrarás la actualización del estado de tus candidaturas."
                    }
                },
                "notifications-and-emails": {
                    "subject": "Notificaciones",
                    "enquiry1": {
                        "question": "¿Puedo recibir notificaciones vía correo electrónico sobre nuevas ofertas o \n            sobre la actualización del estado de mis candidaturas?",
                        "answer": "\n<div>\n    Sí, puedes activar o desactivar las notificaciones. \n</div>\n<div>\n    Accede a tu cuenta y ve a la sección Mi cuenta / Notificaciones, selecciona las opciones: \n</div>\n<ul>\n    <li>Informe diario de nuevas ofertas</li>\n    <li>Cambio de estado de tus candidaturas</li>\n</ul>"
                    }
                },
                "networking": {
                    "subject": "Red de contactos",
                    "enquiry1": {
                        "question": "¿Dónde está la red de contactos de {portal}?",
                        "answer": "La red de contactos ya no está disponible en {portal}\nTu opinión y la de otros candidatos nos importa mucho y tras valorarlo y\nhablarlo a nivel interno hemos decidido eliminar este servicio y focalizarnos\nen crear otras herramientas que se ajusten más a tus necesidades.Por tanto, el\nservicio “red de contactos” se ha descontinuado. Si tienes dudas, consultas o\nalguna incidencia, siempre puedes contactar con Atención al Cliente al final\nde esta página"
                    }
                },
                "my-privacy": {
                    "subject": "Quién me ve",
                    "enquiry1": {
                        "question": "Mi CV ha recibido visitas ¿Que significa eso?",
                        "answer": "En esta sección (únicamente disponible desde la web) puedes ver qué\nempresas han encontrado y consultado tu CV. Las empresas pueden ver los CVs\ninscritos a una oferta que hayan publicado, o buscar en la base de datos de\n{portal}. En esta sección veras los que te han encontrado a través de la\nbase de datos. Si no quieres que las empresas te puedan encontrar en la base\nde datos, en el apartado Privacidad de la sección Ajustes , puedes desactivar\ndicha opción."
                    }
                },
                "executive-account": {
                    "subject": "Cuenta Executive",
                    "enquiry1": {
                        "question": "¿Cómo activo mi cuenta Executive?",
                        "answer": "Has de saber que las cuentas {portal} Executive se\nactivan automáticamente y sucede con aquellos perfiles de alto nivel\n(como directivos o managers) que cuentan con puestos de responsabilidad\ny con personal a su cargo. Este tipo de perfiles también han de tener más\nde 5 años de experiencia, así como un salario acorde con el puesto."
                    }
                },
                "unsubscribe": {
                    "subject": "Baja",
                    "enquiry1": {
                        "question": "¿Cómo puedo darme de baja de {portal}?",
                        "answer": "Conservar tus datos en {portal}, te puede ser muy\nútil si en el futuro quieres volver a buscar trabajo, así no tendrás\nque volver a rellenar toda tu información. Además, si tu CV está en\n{portal}, aunque no estés buscando trabajo, éste estará disponible\npara las empresas que buscan candidatos como tú.Quizá un día recibes una\noferta muy interesante por parte de una empresa. Por favor dirígete a la\nsección Ajustes , allí encontrarás el apartado Darme de baja. Podrás escoger\nentre: Dejar de recibir emails con ofertas de emple Eliminar todas mis\ncandidaturas de las ofertas donde me he inscrito anteriorment Ocultar mi\nCV a las empresas que buscan candidatos en {portal} Si no quieres ninguna\nopción anterior y prefieres darte de baja, eliminando definitivamente todos tus\ndatos de {portal}, podrás hacerlo haciendo clic en el botón\n[Quiero darme de baja]. ¿Tienes algún problema con el proceso de baja? Nosotros\npodemos realizarlo por ti si nos envías este formulario cumplimentado."
                    },
                    "enquiry2": {
                        "question": "He encontrado trabajo ¿Me doy de baja?",
                        "answer": "¡No hace falta! Si quieres, puedes seguir en {portal}, pero minimizar\nlas comunicaciones, cancelar las candidaturas o editar tu privacidad. En la sección\nAjustes , encontrarás el apartado Darme de baja y podrás escoger entre: Dejar de\nrecibir emails con ofertas de empleo Eliminar todas mis candidaturas de las\nofertas donde me he inscrito anteriormente Ocultar mi CV a las empresas que\nbuscan candidatos en jobs.aiacd.es"
                    }
                }
            },
            "contact-us": {
                "title": "Envíanos tu consulta",
                "form": {
                    "type": "Tipo de consulta",
                    "subject": "Asunto",
                    "text": "Mensaje",
                    "name": "Nombre y Apellidos",
                    "email": "Correo electrónico"
                },
                "validation.error": "Por favor, corrija los errores en el formulario.",
                "privacy-notice": "Te informamos que los datos de carácter personal que nos proporciones\nrellenando el presente formulario serán tratados por Aicad Business\nSchool S.L como responsable de Planetajob. La finalidad de la recogida\ny tratamiento de los datos personales que te solicitamos es para enviarte\nnuestras publicaciones, promociones de productos y/o servicios y recursos exclusivos.\nLa legitimación se realiza a través del consentimiento del interesado.\nPodrás ejercer tus derechos de acceso, rectificación, limitación y\nsuprimir los datos en info@planetajob.es. Puedes consultar la información\nadicional y  detallada sobre Protección de Datos en nuestra\n",
                "privacy-policy-link": "Política de Privacidad",
                "success": "¡Tu consulta ha sido enviada con éxito! Nuestro equipo te contactará en un máximo de 48 horas. ¡Gracias!",
                "search-offers": "Buscar ofertas"
            },
            "general-conditions": {
                "content": "<div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        CONDICIONES GENERALES DE CONTRATACIÓN ELECTRÓNICA\n      </h1>\n      <p>Lee nuestros términos y condiciones legales</p>\n      <div class=\"mt-5\">\n        <p>Las partes que se vinculan a través de estas condiciones son Aicad Business School S.L, con domicilio social en Calle León y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria CIF B76062199, Empresa inscrita en el Registro Mercantil de las Palmas 30/04/2010 Tomo 1958 libro 0 Folio 116,  la cual ofrece sus productos y servicios a través de la plataforma de Internet Planetajob.es (www.planetajob.es), en adelante Planetajob, y el usuario que acceda, a la misma, bien a través de un ordenador personal, bien a través de cualquier aplicación desarrollada para “smartphones” o por cualquier otro medio y que, en su caso, utilice las prestaciones ofrecidas por ésta. En consecuencia, el mero acceso a Planetajob por cualquier medio implica la aceptación por el usuario de las presentes condiciones y términos de uso. Podrás contactar con nosotros al email info@planetajob.es o al teléfono (+34) 928 35 46 68 para pedir mas información.</p>\n        <p class=\"text-center\">\n          El Cliente se compromete a cumplir con lo establecido en las CONDICIONES DE CONTRATACIÓN publicadas por Planetajob en su sitio web en el momento de la compra del producto.\n        </p>\n      </div>\n    </div>\n    \n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-center mb-4\">\n        Condiciones Generales de Contratación\n      </h1>\n      <div>\n        <h2 class=\"text-uppercase --bold\">\n          CONDICIONES DE CONTRATACIÓN\n        </h2>\n        <p>En cumplimiento de lo dispuesto en el Real Decreto 1906/99 de diecisiete de diciembre, por el que se regula la contratación electrónica con condiciones generales, y de la Ley de Ordenación del Comercio Minorista (Ley 7/1996 de 15 de Enero, modificada por la Ley 47/2002 de 19 de Diciembre) en lo aplicable a lo dispuesto sobre las ventas a distancia en los artículos 38 y siguientes, AICAD BUSINESS SCHOOL, S.L. (en adelante La Empresa o Planetajob), informa: El presente documento supone la regulación general de los servicios prestados por Planetajob a través del site www.planetajob.es, constituyendo el marco jurídico en que se desarrolla la presente relación contractual de compra-venta.   Las presentes Condiciones Generales, están sujetas a lo dispuesto a la Ley 7/1996, de 15 de enero de Ordenación del Comercio Minorista, a la Ley 7/1988 de 13 de abril, sobre Condiciones Generales de Contratación, al Real Decreto 1906/1999 de 17 de diciembre de 1999, por el que se regula la Contratación Telefónica o Electrónica con condiciones generales, el Reglamento General de Protección de Datos (UE) 2016/679 (en adelante, RGPD), a la Ley 34/2002 de 11 de julio, de Servicios de Planetajob de la Información y de Comercio Electrónico (LSSI) y al Real Decreto Legislativo 1/2007, de 16 de noviembre (por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y Usuarios y otras leyes complementarias).   Los servicios ofrecidos por Planetajob podrán ser contratados por cualesquiera usuarios que cumplan con los requisitos establecidos en las presentes CONDICIONES DE CONTRATACIÓN y POLÍTICA DE PRIVACIDAD disponibles en todo momento en la página web www.planetajob.es</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          1. OBJETO DEL CONTRATO.\n        </h4>\n        <p>El contrato tiene por objeto regular las condiciones generales de servicio ofrecido por Planetajob:   Los servicios que Planetajob presta actualmente y que son objeto de este contrato, son de venta de productos de formación, servicios de consultoría, productos tecnológicos, diseño web, implementación de nuevas tecnologías en la empresa, servicios de marketing digital (incluyendo la intermediación con otros proveedores) y sistemas de franquicias.   El acceso a la información es completamente gratuito, mientras que el servicio de compra y contratación de productos es oneroso, especificándose en todo momento los precios actuales del producto, los precios de envió, y los cargos por impuestos.   El procedimiento de contratación será llevado a cabo en el idioma castellano, pudiendo establecer la posibilidad de llevar a cabo la contratación del servicio en otros idiomas especificados.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          2.IDENTIFICACIÓN DE LAS PARTES CONTRATANTES.\n        </h4>\n        <p>De una parte, AICAD BUSINESS SCHOOL, S.L. en adelante Planetajob con domicilio social en Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria, con CIF B76062199, Empresa inscrita en el Registro Mercantil de las Palmas 30/04/2010 Tomo 1958 libro 0 Folio 116, la cual ofrece sus productos y servicios a través de la plataforma de Internet Planetajob.es (www.planetajob.es)</p>\n        <p>Y, de otra parte,</p>\n        <p>EL CLIENTE,</p>\n        <p>cuyos datos introducidos para realizar la compra o para realizar alguna sugerencia, a través del formulario establecido al efecto, son los que han sido consignados por él mismo. Todos los datos incluidos en él han sido introducidos directamente por El Cliente, por lo que la responsabilidad sobre la autenticidad de los mismos corresponde, directa y exclusivamente al CLIENTE.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          3. OBLIGACIONES RELATIVAS AL PROCEDIMIENTO DE COMPRA.\n        </h4>\n        <p>El Cliente es el único responsable de la veracidad de los datos introducidos por él mismo en el procedimiento de compra, y acepta la obligación de facilitar datos veraces, exactos y completos. Si El Cliente incumple esta obligación, quedará bajo su responsabilidad el responder por los posibles daños y perjuicios producidos a Planetajob o a un tercero.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          4. CONDICIONES DEL SERVICIO\n        </h4>\n        <p>Las condiciones comerciales de este servicio y las ofertas que eventualmente puedan llevarse a cabo por Planetajob siempre aparecen en la mencionada página web www.planetajob.es por lo que pueden ser consultadas, archivadas o impresas. Planetajob se reserva el derecho de modificar en cualquier momento las presentes Condiciones Generales de Contratación, así como cualesquiera otros documentos expuestos en su página web.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          5. RESPONSABILIDADES.\n        </h4>\n        <p>Planetajob no será responsable de los retrasos o fallos que se produjeran en el acceso, funcionamiento y operatividad de la web, o en sus servicios y/o contenidos, así como tampoco de las interrupciones, suspensiones o el mal funcionamiento de la misma, cuando tuvieren su origen en averías producidas por catástrofes naturales o situaciones de fuerza mayor, o de urgencia extrema, tales como huelgas, ataques o intrusiones informáticas o cualquier otra situación de fuerza mayor o causa fortuita, así como por errores en las redes telemáticas de transferencia de datos y en todo caso cuando el error hubiera sido producido por un tercero ajeno a la organización empresarial mencionada.</p>\n        <p>Planetajob se hace responsable de la fiabilidad, veracidad y exactitud de los contenidos, datos o informaciones respecto a los productos ofrecidos en su sitio web, salvo que estas hubieran sido modificadas por terceras partes, ajenas o no a la organización, sin autorización expresa por parte de la empresa. El servicio prestado por Planetajob se ciñe exclusivamente a informar y poner a disposición de los clientes los productos, haciéndose responsable de los productos que no se ajusten a lo contratado por El Cliente.</p>\n        <p>En caso de que en los sitios web propiedad de Planetajob alberguen links o banners que permitan al usuario el acceso a páginas web o enlaces propiedad de terceros, la misma no se hace responsable de los contenidos que en ella pudieran encontrarse alojados y procederá a retirarlos en el caso de que algún usuario le comunique algún tipo de contenido ilícito, una vez la empresa lo haya verificado.</p>\n        <p>Planetajob no será responsable en ningún caso por los errores o daños producidos por el uso ineficiente y de mala fe del servicio por parte del Cliente. Tampoco será responsable de las consecuencias mayores o menores por la falta de comunicación entre Planetajob y el Cliente cuando sea imputable al no funcionamiento del correo electrónico facilitado o falsedad de los datos proporcionados por el Cliente en su registro de usuario de planetajob.es.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          6. SERVICIOS OFERTADOS EN ESTA WEB\n        </h4>\n        <p>Planetajob pone a disposición los siguientes servicios:</p>\n        <ul>\n          <li class=\"p-0\">\n            Venta de productos de formación\n          </li>\n          <li class=\"p-0\">\n            Servicios de consultoría\n          </li>\n          <li class=\"p-0\">\n            Productos tecnológicos\n          </li>\n          <li class=\"p-0\">\n            Diseño web\n          </li>\n          <li class=\"p-0\">\n            Implementación de nuevas tecnologías en la empresa\n          </li>\n          <li class=\"p-0\">\n            Servicios de marketing digital (incluyendo la intermediación con otros proveedores)\n          </li>\n        </ul>\n        <p>Como condición para contratar los Servicios ofertados, estás obligado a registrarte en el formulario correspondiente y proporcionar información de registro. La información de registro que proporciones debe ser precisa, completa y actualizada en todo momento. El no hacerlo constituye una violación de los términos, que pueden resultar en la disolución del contrato.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          7. SOLUCIONES DE TERCEROS\n        </h4>\n        <p>Algunos servicios pueden incluir soluciones de terceros. Planetajob puede proporcionar enlaces a sitios web de terceros como partners asociados a Planetajob para la prestación de algunos servicios. (Ejemplo: Google GSuite)   Aceptas también que el Servicio puede incluir soluciones de seguridad que limita el uso y que deberás usar estos servicios de acuerdo con las reglas de uso establecidos por Planetajob y sus Partners de seguridad y que cualquier otro uso puede constituir un derecho de autor infracción.</p>\n        <p>Queda prohibido alterar, eludir, realizar ingeniería inversa, descompilar, desmontar o alterar de ningún modo de la tecnología de seguridad aportada por Planetajob por cualquier razón. Las violaciones de seguridad del sistema o red pueden resultar en responsabilidad civil o penal.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          8. PRECIOS Y FORMAS DE PAGO\n        </h4>\n        <p>Te comprometes a abonar los servicios contratados a Planetajob en las formas de pago aceptadas por su web y por cualquier cantidad complementaria (incluidos los impuestos y cargos por pagos atrasados, según el caso).</p>\n        <p>El pago es por adelantado del 100% y los servicios serán suministrados cuando confirmemos el pago, salvo confirmación escrita para ofertas personalizadas o domiciliaciones bancarias. Los precios aplicables a cada producto y/o servicio son los indicados en la página web en la fecha del pedido.</p>\n        <p>Sistema común del impuesto sobre el valor añadido de la Unión Europea: Atendiendo a lo establecido en la Ley 37/1992, de 28 de diciembre, reguladora de dicho impuesto y la Directiva Europea 2008/8/CE, la operación resulta exenta o no sujeta al IVA:</p>\n        <p>“En nuestro territorio nacional, Canarias, Ceuta y Melilla están excluidas del ámbito de aplicación del sistema armonizado del IVA, aunque Canarias se integra en la Unión Aduanera.”</p>\n        <p>Los precios de los Servicios pueden cambiar en cualquier momento a discreción única y exclusiva de Planetajob. Los Servicios no brindan protección de precios o reembolsos en el caso de reducción de precios u ofertas promocionales.</p>\n        <p>En Planetajob se aceptas estas formas de pago:</p>\n        <ol>\n          <li>Transferencia</li>\n          <li>Paypal</li>\n          <li>Tarjeta de crédito (Entorno SSL vía el portal de CaixaBank)</li>\n          <li>Domiciliación Bancaria</li>\n          <li>Pagos Fraccionados mediante Sequra</li>\n        </ol>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          9. CONFIRMACIÓN DEL PEDIDO Y ENVIO\n        </h4>\n        <p>Las confirmaciones de los pedidos y del pago, así como todos los contactos con El Cliente, se realizan a través de correo electrónico por lo que es muy importante que El Cliente se asegure de hacer constar una dirección de email válida, así como un número de teléfono de contacto para el caso de que haya alguna incidencia y el correo no funcione.   Si El Cliente tiene dudas sobre el funcionamiento de la pasarela de pago, puede ponerse en contacto con el servicio de atención al cliente a través del correo electrónico info@planetajob.es o al teléfono (+34) 928 35 46 68.</p>\n        <p>Los plazos de entrega de los productos contratados pueden ser distintos según el caso y producto/ servicio adquirido. Los plazos indicados son aproximados y es posible que varíen ligeramente en unos días (al alza o a la baja) en función de la época del año (para servicios Offline), las circunstancias de la disponibilidad inmediata y la comunicación. El Cliente conoce estas circunstancias y las acepta, no siendo motivo para la devolución del pedido el incumplimiento del plazo exacto de 10 días laborables.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          10. FORMULARIO DE PEDIDO\n        </h4>\n        <p>En cualquiera de sistemas para hacer el pedido, antes de efectuar el pago, El Cliente tendrá que facilitar algunos datos personales necesarios para hacerle entrega de su pedido. Los campos que deberá cumplimentar serán todos o algunos de los siguientes:</p>\n        <ul>\n          <li class=\"p-0\">\n            Nombre\n          </li>\n          <li class=\"p-0\">\n            Apellidos\n          </li>\n          <li class=\"p-0\">\n            Dirección\n          </li>\n          <li class=\"p-0\">\n            Código Postal\n          </li>\n          <li class=\"p-0\">\n            Ciudad\n          </li>\n          <li class=\"p-0\">\n            Provincia\n          </li>\n          <li class=\"p-0\">\n            País\n          </li>\n          <li class=\"p-0\">\n            Teléfono\n          </li>\n          <li class=\"p-0\">\n            DNI/CIF/NIE para la facturación\n          </li>\n          <li class=\"p-0\">\n            Código Promocional (de existir)\n          </li>\n        </ul>\n        <p>Una vez cumplimentados estos datos, el siguiente paso es efectuar el pago del pedido.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          11. POLÍTICA DE DEVOLUCIONES\n        </h4>\n        <p>La política de cancelación es aplicable a las personas que deseen anular su matrícula o inscripción a las formaciones y eventos de Planetajob. La matriculación en cualquier formación o evento conlleva aceptar las siguientes condiciones:</p>\n        <p><strong>Cancelación de matrícula por parte del alumno.</strong></p>\n        <p>Las cancelaciones de matrícula por parte del alumno deben informarse por escrito, enviando un email en la dirección de correo electrónico administracion@planetajob.es. No se aceptan cancelaciones informadas por ninguna otra vía. En dicho email deben constar los datos de la inscripción, incluyendo nombre y apellidos, teléfono y nombre de la formación tal y como aparece en nuestra web.</p>\n        <p>Devolución de la matrícula para formaciones o eventos presenciales o semipresenciales.</p>\n        <ul>\n          <li>Si el alumno anula la matrícula hasta 20 días naturales antes del inicio, se devolverá el importe de la matrícula restando el 15% del coste completo de la formación en concepto de “gastos de gestión”.  El mínimo aplicable por “gastos de gestión” será 50€ y el máximo 150€,  justificando las posibles contrataciones de productos/servicios a terceros o el tiempo empleado para la tramitación/gestión.</li>\n          <li>Si se procede a la cancelación de la matrícula hasta 5 días naturales antes del inicio de la formación se devolverá el importe de la matrícula restando el 50% del coste completo de la formación.</li>\n          <li>No se harán devoluciones del importe de la matrícula para cancelaciones hechas con 5 días o menos antes del inicio de la formación, cuando la formación esté en curso o después de haber finalizado la formación.</li>\n          <li>Se devolverá la cantidad íntegra de la matrícula en cualquier caso si la cancelación se debe a: (1) razones médicas que impidan la ejecución adecuada de la formación  y un médico proporciona la certificación, (2) causas médicas extremas de algún familiar de primer grado y un médico proporciona la certificación, (3) Obligaciones civiles impuestas por las autoridades después de la fecha de realización de la preinscripción o matriculación, (4) Muerte inesperada de un familiar de primer grado.</li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\" />\n        <p />\n        <p />\n        <p />\n        <p />\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          12. DESISTIMIENTO COMERCIAL\n        </h4>\n        <p>El desistimiento es la facultad de un consumidor de un bien para devolverlo al comercio dentro de un plazo legal de 14 días, sin tener que alegar ni dar ninguna explicación al respecto ni sufrir una penalización.</p>\n        <p>El derecho de desistimiento no se podrá ejercer (salvo por error o defecto en el producto o servicio contratado), en los siguientes supuestos previstos por el artículo 45 de la Ley de Comercio:</p>\n        <ul>\n          <li>Contratos de suministro de bienes confeccionados conforme a las especificaciones del consumidor o claramente personalizados, o que, por su naturaleza, no puedan ser devueltos o puedan deteriorarse o caducar con rapidez.</li>\n          <li>Contratos de suministro de grabaciones sonoras o de vídeo, de discos y de programas informáticos que hubiesen sido desprecintados por el consumidor, así como de ficheros informáticos, suministrados por vía electrónica, susceptibles de ser descargados o reproducidos con carácter inmediato para su uso permanente.</li>\n          <li>Y en general todos aquellos productos encargados a distancia que se realicen a nuestra medida: ropa, revelado fotográfico, etc., o que sean susceptibles de copia (libros, música, videojuegos, etc.).</li>\n        </ul>\n        <p>El plazo de desistimiento en productos de contenido digital (como los cursos online), quedará suspendido en el momento que se utilicen las claves para el acceso al contenido digital: De conformidad al art. 103, a) del Real Decreto Legislativo 1/2007, de 16 de noviembre: El suministro de contenido digital que no se preste en un soporte material cuando la ejecución haya comenzado con el previo consentimiento expreso del consumidor y usuario con el conocimiento por su parte de que en consecuencia pierde su derecho de desistimiento.</p>\n        <p>El plazo de desistimiento en productos de contenido digital (como los cursos), quedará suspendido en el momento que se envían las claves para el acceso al contenido digital. El derecho de desistimiento, de acuerdo con el artículo 103.a de la ley 1/2007, no será aplicable a la prestación de servicios, una vez que el servicio haya sido completamente ejecutado, cuando la ejecución haya comenzado, con previo consentimiento expreso del consumidor y usuario y con el reconocimiento por su parte de que es consciente de que, una vez que el contrato haya sido completamente ejecutado por Planetajob, habrá perdido su derecho de desistimiento.</p>\n        <p>Tras aceptarse la realización de los trabajos contratados, Planetajob, te notificará la fecha de comienzo de los mismos. Asimismo, Planetajob podrá proceder a la resolución del contrato si no se efectúa por el usuario el correspondiente pago o se incurre en algunas de las actuaciones expuestas en el apartado de causas de disolución del contrato.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          13. COMO CANCELAR EL CONTRATO DE SERVICIOS\n        </h4>\n        <p>Si deseas cancelar un contrato relacionado con los servicios mensuales ofrecidos por Planetajob, debes ponerte en contacto con nosotros con una solicitud de desistimiento de contrato antes de que haya comenzado a ejecutarse el servicio contratado (ver proceso y formulario de desistimiento abajo). Planetajob garantiza al cliente el reembolso de las cantidades abonadas en el plazo de catorce (14) días naturales contados a partir de la fecha de comunicación fehaciente del ejercicio de su derecho de desistimiento siempre que este cumpla con los requisitos y haya sido aceptado por Planetajob.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          14. CONSECUENCIAS DEL DESISTIMIENTO\n        </h4>\n        <p>En caso de desistimiento por tu parte, te devolveremos todos los pagos recibidos que nos hayas realizado sin ninguna demora indebida y, en todo caso, a más tardar 14 días naturales a partir de la fecha en la que se nos informes de tu decisión de desistir del presente contrato y siempre que se haya notificado con 10 días de antelación a la fecha de comienzo de los trabajos contratados.</p>\n        <p><strong>Modelo de formulario de reclamación o desistimiento</strong></p>\n        <p>El usuario/comprador podrá notificarnos la reclamación o el desistimiento, bien a través de correo electrónico a: administracion@planetajob.es o bien por correo postal en la dirección indicada en el formulario de desistimiento indicando tu nombre como los servicios contratados, fechas y cualquier otra información de interés que ayudará a identificar la compra realizada. Puedes usar el siguente:</p>\n        <p>Modelo de formulario de desistimiento</p>\n        <p>(sólo debe cumplimentar y enviar el presente formulario si desea desistir del contrato)</p>\n        <ul>\n          <li>A la atención de Aicad Business School S.L, con CIF B76062199, situado en con domicilio social en Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria y que puede ser contactada a través del portal www.planetajob.es o al email info@planetajob.es:</li>\n          <li>Por la presente le comunico/comunicamos (*) que desisto de mi/desistimos de nuestro (*) contrato de venta del siguiente bien/prestación del siguiente servicio (*)</li>\n          <li>Pedido el/recibido el (*)</li>\n          <li>Nombre del consumidor y usuario o de los consumidores y usuarios</li>\n          <li>Domicilio del consumidor y usuario o de los consumidores y usuarios</li>\n          <li>Firma del consumidor y usuario o de los consumidores y usuarios (solo si el presente formulario se presenta en papel)</li>\n          <li>Fecha</li>\n          <li>Firma y sello</li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          15. NULIDAD PARCIAL\n        </h4>\n        <p>Si cualquier parte de estas condiciones de servicio fuera contraria a Derecho y, por tanto, inválida, ello no afectará a las otras disposiciones conformes a Derecho. Las partes se comprometen a renegociar aquellas partes de las condiciones de servicio que resultaran nulas y a incorporarlas al resto de las condiciones de servicio.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          16. LEY APLICABLE Y JURISDICCIÓN\n        </h4>\n        <p>Para toda cuestión litigiosa o que incumba al sitio web de www.planetajob.es o cualquiera de los que de él dependa, será de aplicación la legislación española, siendo competentes para la resolución de todos los conflictos derivados o relacionados con el uso de del presente sitio web, los Juzgados y Tribunales de Las Palmas de Gran Canaria (España).</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          17. PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL\n        </h4>\n        <p>De conformidad con lo establecido en el Reglamento General de Protección de Datos (UE) 2016/679 (en adelante, RGPD) y demás normativa vigente en materia de protección de datos personales, le informamos de que sus datos personales son tratados en calidad de responsable del tratamiento por AICAD BUSINESS SCHOOL SL, con domicilio social en Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria.</p>\n        <p>Puede contactar con nosotros mediante un correo a la siguiente dirección: info@planetajob.es y obtener cualquier otra información. Asimismo, le informamos que en cada comunicación comercial los usuarios podrán manifestar su negativa a continuar recibiendo dichas comunicaciones a través de un click en el botón “Baja” o “Cancelar Subscripcion”.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          18. QUEJAS, DUDAS Y EJERCICIO DEL DERECHO\n        </h4>\n        <p>Podrá dirigir sus comunicaciones y ejercitar los derechos de acceso, rectificación, cancelación y oposición por correo ordinario dirigido a Aicad Business School, Ref. LOPD, Calle Leon y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria, Las Palmas. Para ejercer dichos derechos, y en cumplimiento de la Instrucción 1/1998, de 19 de enero, de la Agencia de Protección de Datos, es necesario que usted acredite su personalidad frente a la Empresa mediante el envío de fotocopia de Documento Nacional de Identidad o cualquier otro medio válido en Derecho.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          19. NORMATIVA EUROPEA DE CONSUMO\n        </h4>\n        <p>La Comisión Europea ha creado la primera plataforma europea para la resolución de conflictos en el comercio “online” amparada en la última ley del consumidor. En este sentido, como responsables de una plataforma de venta online, tenemos el deber de informar a nuestros usuarios sobre la existencia de una plataforma online de resolución alternativa de conflictos.</p>\n        <p>Para recurrir a la plataforma de resolución de conflictos, el usuario debe utilizar el siguiente enlace: http://ec.europa.eu/odr</p>\n      </div>\n    </div>\n</div>"
            },
            "company-home": {
                "hero": {
                    "title": "TE AYUDAMOS A ENCONTRAR EL CANDIDATO IDEAL DE FORMA RÁPIDA, FÁCIL Y SEGURA",
                    "subtitle": "En <span style=\"color: #D24943\">{portal}</span>, trabajamos contigo para conseguir el candidato idóneo",
                    "button": "PRIMER ANUNCIO GRATIS"
                },
                "sections": {
                    "publish-offer": {
                        "title": "PUBLICA UNA OFERTA DE EMPLEO",
                        "publish-card": {
                            "title": "PUBLICA TUS VACANTES CON NOSOTROS",
                            "subtitle": "Crear el perfil del puesto que buscas"
                        },
                        "receive-card": {
                            "title": "ENCUENTRA AL CANDIDATO IDEAL",
                            "subtitle": "Avisaremos a los candidatos que mejor se ajusten al perfil"
                        },
                        "select-card": {
                            "title": "CONTRATA AL MEJOR",
                            "subtitle": "Filtra entre los inscritos y contacta con los que más te interesen"
                        },
                        "button": "PRIMER ANUNCIO GRATIS"
                    },
                    "find-talent": {
                        "title": "SELECCIÓN DE PERSONAL A ÉXITO ¡NUESTRO SERVICIO PREMIUM!",
                        "findcv-card": {
                            "title": "CONSEGUIMOS EL CANDIDATO IDEAL",
                            "subtitle": "Accede a más de 2 millones de CVs sin tener que publicar una oferta"
                        },
                        "interest-card": {
                            "title": "NOS ENCARGAMOS DE TODO EL PROCESO",
                            "subtitle": "Descubre si les interesa tu oferta de empleo antes de pagar por el CV"
                        },
                        "payment-card": {
                            "title": "AHORRA EN COSTES DE PUBLICACIÓN",
                            "subtitle": "Paga sólo para ver los datos de contacto de los que te interesan"
                        },
                        "button": "QUIERO SABER MÁS"
                    },
                    "partners": {
                        "title": "Miles de empresas confían en {portal}"
                    },
                    "selection": {
                        "title": "SOMOS TU EQUIPO ALIADO EN EL PROCESO DE SELECCIÓN",
                        "subtitle": "ASESORÍA GRATUITA durante todo el proceso. Te propondremos siempre LA MEJOR SOLUCIÓN"
                    },
                    "candidate": {
                        "title": "EL CANDIDATO QUE NECESITAS DE LA FORMA MÁS RÁPIDA, FÁCIL Y SEGURA",
                        "button": "PRIMER ANUNCIO GRATIS"
                    }
                }
            },
            "privacy-policy": {
                "content": "<div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        Política de Privacidad y Aviso Legal\n      </h1>\n      <p>Lee nuestra política de privacidad y el aviso legal</p>\n      <div>\n        <h2>Titularidad</h2>\n        <p>En cumplimiento de lo previsto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, se informa que el titular de este sitio web es la siguiente entidad:</p>\n        <p class=\"text-center\">\n          AICAD BUSINESS SCHOOL SL con CIF: B76062199, Empresa inscrita en el Registro Mercantil de las Palmas 30/04/2010 Tomo 1958 libro 0 Folio 116 y con domicilio en con domicilio social en Calle León y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria.\n        </p>\n      </div>\n      <div>\n        <h2>Aceptación del aviso legal</h2>\n        <p>Te recordamos que Aicad ofrece sus productos y servicios a través de la plataforma de Internet Planetajob.es (www.planetajob.es), en adelante Aicad, y el usuario que acceda, a la misma, bien a través de un ordenador personal, bien a través de cualquier aplicación desarrollada para “smartphones” o por cualquier otro medio y que, en su caso, utilice las prestaciones ofrecidas por ésta. En consecuencia, el mero acceso a Aicad por cualquier medio implica la aceptación por el usuario de las presentes condiciones y términos de uso. Podrás contactar con nosotros al email info@planetajob.es o al teléfono (+34) 928 35 46 68 para pedir más información.</p>\n      </div>\n      <div>\n        <h2 class=\"text-uppercase\">\n          AVISO LEGAL DEL PORTAL DE AICAD BUSINESS SCHOOL\n        </h2>\n        <p>Las cláusulas que a continuación se relacionan regulan las condiciones de uso del Portal Web de Internet “www.planetajob.es” (en adelante, el Portal) de Aicad Business School, S.L.</p>\n        <p>La expresión “usuario” comprende cualquier persona que acceda al Portal, ya sea directamente o bien desde cualquier otro sitio de Internet. Las condiciones generales que regulan el uso del Portal son las siguientes:</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          1.- GENÉRICAS.\n        </h4>\n        <p>Los servicios ofrecidos por Aicad Business School, S.L. en el presente sitio de Internet se regulan por las cláusulas contenidas en las presentes condiciones (sin perjuicio de los demás avisos legales y condiciones que figuran en el Portal).</p>\n        <p>Aicad Business School, S.L. se reserva el derecho a modificar, total o parcialmente, estas condiciones generales, siendo de aplicación las nuevas que acuerde desde el momento de su inserción en la página.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          2.- IDENTIFICACION Y RAZÓN SOCIAL DE LA EMPRESA OFERENTE.\n        </h4>\n        <p>AICAD BUSINESS SCHOOL SL con CIF: B76062199, Empresa inscrita en el Registro Mercantil de las Palmas 30/04/2010 Tomo 1958 libro 0 Folio 116 y con domicilio en Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria, cuyo nombre comercial es Aicad Business School, S.L.</p>\n        <p>Para cualquier consulta, sugerencia o reclamación el usuario puede dirigirse a las oficinas de nuestra empresa sitas en la dirección mencionada anteriormente, o bien a la dirección de correo electrónico info@planetajob.es, mediante teléfono: +34 928 35 46 68 o usando el formulario de contacto.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          3.- CONDICIONES DE ACCESO DEL USUARIO.\n        </h4>\n        <p>El usuario se obliga a usar la información contenida en el presente sitio de Internet para las finalidades propias del Portal exclusivamente, en concreto para la finalidad de obtención de información sobre los servicios ofrecidos y realización de sugerencias y a no realizar directa o indirectamente ningún tipo de explotación comercial diferente a los usos autorizados.</p>\n        <p>El usuario de la página web tendrá derecho al acceso libre y gratuito a la información pública recogida en la misma, si bien Aicad Business School, S.L. se reserva el derecho a restringir el acceso a determinadas secciones y servicios del Portal a los clientes registrados.</p>\n        <p>Aicad Business School, S.L. prohíbe terminantemente el uso de los elementos restringidos a determinado grupo de usuarios a los usuarios no autorizados por nombre y contraseña.</p>\n        <p>Aicad Business School, S.L. ha puesto a disposición de los usuarios autorizados a acceder a la zona privada de la página web un nombre y contraseña cuya custodia compete única y exclusivamente al usuario. En consecuencia, Aicad Business School, S.L. no es responsable bajo ninguna circunstancia del uso indebido de los nombres de usuario y contraseñas.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          4.- PROPIEDAD INTELECTUAL E INDUSTRIAL.\n        </h4>\n        <p>Los derechos relativos a la propiedad industrial e intelectual (a título enunciativo y no limitativo las marcas, logotipos, textos, fotografías, iconos, imágenes, etc., así como el diseño gráfico, código fuente y demás elementos de software contenidos en la presente página Web), son propiedad de Aicad Business School, S.L. o de las demás entidades que puedan ofrecer información a través del Portal. Por tanto, están sujetos a derechos de propiedad intelectual e industrial protegidos por la legislación española e internacional.</p>\n        <p>Sin la previa autorización escrita de forma fehaciente de Aicad Business School, S.L. o, en su caso, de la entidad titular de los derechos, no está permitido utilizar, reproducir, transmitir, manipular, así como tampoco hacer cualquier uso que exceda la visita de la página y la utilización de los servicios ofrecidos.</p>\n        <p>El acceso a los servicios suministrados no supone por parte de Aicad Business School, S.L., ni por parte del respectivo titular, renuncia, transmisión, ni cesión total o parcial de los derechos derivados de la propiedad intelectual e industrial, ni atribuye derechos de utilización, alteración, explotación, reproducción, distribución o comunicación pública sobre estos contenidos sin la previa y expresa autorización por escrito de los respectivos titulares de dichos derechos, sin perjuicio del derecho de visualización y obtención de copia privada de seguridad de tales contenidos, siempre que dicho derecho se ejercite según los principios de buena fe y siempre que se mantenga inalterada la propiedad intelectual e industrial del titular de tales derechos, se utilice sin fines comerciales y exclusivamente para información personal del usuario.</p>\n        <p>La responsabilidad derivada del uso de materiales protegidos por los derechos de propiedad intelectual e industrial contenidos en esta página corresponderá exclusivamente al usuario.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          5.- OBJETO DEL PORTAL.\n        </h4>\n        <p>La presente página ha sido diseñada por Aicad Business School, S.L. para facilitar información sobre sus servicios y otras actividades de la empresa. Las páginas web disponen de unos datos de contacto y formularios a través de los cuales los usuarios pueden dirigirse a la empresa para las finalidades previstas en cada caso, según la regulación de las cláusulas del Portal.</p>\n        <p>El mero acceso al Sitio Web, la cumplimentación de formularios, el envío de solicitudes de información, consultas, quejas, ofertas de contratación, curriculum vitae y, en general, cualquier acto de naturaleza similar a los anteriores realizados a través de los formularios y/o buzones electrónicos existentes en el Sitio Web implicará, por su parte, la aceptación sin reservas de todas y cada una de las normas integrantes del presente Aviso Legal y la adquisición de la consideración de Usuario del Sitio Web. En consecuencia, Vd. debe leer atentamente y conocer el contenido del presente Aviso Legal.</p>\n        <p>Aicad Business School, S.L. se reserva el derecho a realizar cuantas modificaciones y actualizaciones crea convenientes sobre la página web.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          6.- EXONERACIÓN DE RESPONSABILIDAD.\n        </h4>\n        <p>Aicad Business School, S.L. no responderá por las interrupciones que puedan producirse en los servicios eléctricos o de telecomunicaciones que impidan a los usuarios utilizar los servicios ofrecidos. Aicad Business School, S.L. no responderá frente a cualquier posible responsabilidad por los daños y perjuicios de toda naturaleza que pudieran deberse a la falta de veracidad, vigencia, exhaustividad o autenticidad de la información facilitada por usuarios.</p>\n        <p>Asimismo, Aicad Business School, S.L. no responderá de las páginas Web a las que pueda remitir a través de enlaces o links, banners u otros dispositivos, ni de los contenidos que éstas pudieran incluir.</p>\n      </div>\n    </div>\n\n    <div class=\"bg-card p-4\">\n      <h1 class=\"--bold\">\n        PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL\n      </h1>\n      <h2>¿Con qué finalidad tratamos sus datos personales?</h2>\n      <p>De conformidad con lo establecido en el Reglamento General de Protección de Datos (UE) 2016/679 (en adelante, RGPD) y demás normativa vigente en materia de protección de datos personales, le informamos de que sus datos personales son tratados en calidad de responsable del tratamiento por AICAD BUSINESS SCHOOL SL (en adelante, Aicad), con domicilio social en Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria.</p>\n      <div>\n        <h4 class=\"--bold\">\n          a) Información\n        </h4>\n        <p>La información recibida por Aicad Business School, S.L. a través de cualquiera de sus páginas Web será tratada con la máxima reserva y confidencialidad conforme a la normativa vigente.</p>\n        <p>Aicad Business School S.L. tratará sus datos personales con el fin de gestionar la relación que Usted mantiene con nosotros, así como para enviarle comunicaciones comerciales por cualquier vía, incluso finalizada la relación con usted, para mantenerle informado de aquellos de nuestros productos y servicios similares a los contratados por Usted.</p>\n      </div>\n      <div>\n        <h4 class=\"--bold\">\n          b) Envío y registro de datos de carácter personal\n        </h4>\n        <p>El envío de datos de carácter personal en esta web es obligatorio para contactar, comentar o contratar cualquier producto disponible para la venta en nuestra web.</p>\n        <p>Asimismo, el no facilitar los datos personales solicitados o el no aceptar la presente política de protección de datos supone la imposibilidad de suscribirse a contenidos y procesar las solicitudes realizadas en esta web.</p>\n        <p>No es necesario que facilites ningún dato de carácter personal para la navegación por esta web.</p>\n        <p>Los casos en los que esta web requiere datos personales son:</p>\n        <ul>\n          <li class=\"p-0\">\n            Para realizar la suscripción a la newsletter\n          </li>\n          <li class=\"p-0\">\n            Para comentar post publicados en el blog.\n          </li>\n          <li class=\"p-0\">\n            Para descargar algunos de los materiales que se ofrecen en el blog.\n          </li>\n          <li class=\"p-0\">\n            Para realizar consultas a través del formulario de contacto.\n          </li>\n          <li class=\"p-0\">\n            Para compartir contenidos en redes sociales.\n          </li>\n          <li class=\"p-0\">\n            Para aplicar a las ofertas de empleo.\n          </li>\n          <li class=\"p-0\">\n            Para contratar los servicios disponibles en esta web\n          </li>\n        </ul>\n      </div>\n      <div>\n        <h4 class=\"--bold\">\n          c) Ejercicio de los derechos ARCO, el derecho al olvido y portabilidad\n        </h4>\n        <p>Para ejercitar los derechos de acceso, rectificación, olvido, portabilidad, cancelación y oposición previstos en la Ley, puede dirigirse por escrito <strong>a Aicad Business School, S.L. Ref. Protección de datos, Calle León y Castillo 54, 1º Planta, 53003, Las Palmas de Gran Canaria o bien a la dirección de correo electrónico info@planetajob.es.</strong> En el caso de no existir alguna relación contractual, podrás borrar tu cuenta siempre que quieras desde el panel de usuario, accediendo a tu perfil de cliente.</p>\n        <p>Aicad Business School, S.L. declara y garantiza que mantiene los niveles de seguridad de protección de datos personales conforme al Real Decreto 994/1999, de 11 de junio, relativo a las medidas de seguridad de los ficheros automatizados que contengan datos de carácter personal; que ha establecido todos los medios técnicos a su alcance para evitar la pérdida, mal uso, alteración, acceso no autorizado y robo de los datos facilitados por los usuarios, sin perjuicio de informar que las medidas de seguridad en Internet no son inexpugnables.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          EXACTITUD Y VERACIDAD DE LOS DATOS\n        </h4>\n        <p>El usuario es el único responsable de la veracidad y corrección de los datos que remita al portal (o a sus afiliados, partners y colaboradores) exonerando al Prestador de cualquier responsabilidad al respecto. Los usuarios garantizan y responden, en cualquier caso, de la exactitud, vigencia y autenticidad de los datos personales facilitados, y se comprometen a mantenerlos debidamente actualizados. El usuario acepta proporcionar información completa y correcta en el formulario de contacto o suscripción.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          ACEPTACIÓN Y CONSENTIMIENTO\n        </h4>\n        <p>La base legal para el tratamiento de sus datos personales es la ejecución y mantenimiento de la relación mantenida con Usted, así como el consentimiento expreso que, en su caso, nos haya facilitado para los tratamientos adicionales consistentes en el envío de comunicaciones comerciales propias y/o de terceros, la elaboración de perfiles comerciales y la cesión de dichos datos y perfiles con las finalidades indicadas en el apartado “Envío y registro de datos de carácter personal” Anterior.</p>\n        <p>Para cualquier otro uso distinto de los expresamente permitidos, será necesario obtener el consentimiento previo por escrito del titular de los derechos de que se trate.</p>\n        <p><strong>La aceptación y consentimiento del interesado:</strong> En aquellos casos donde para realizar una solicitud sea necesario cumplimentar un formulario y hacer un “click” en el botón de enviar, nuestros formularios cuentan con el símbolo * en los datos obligatorios. Si no facilita esos campos, o no marca el “checkbox” de aceptación de la política de privacidad, no se permitirá el envío de la información. Normalmente tiene la siguiente fórmula: “□ He leído y acepto la Política de privacidad y/o Protección de datos.”</p> \n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          SISTEMAS DE CAPTURA DE DATOS PERSONALES QUE UTILIZA ESTA WEB\n        </h4>\n        <p>Esta web utiliza diferentes sistemas de captura de información personal. Esta web siempre requiere el consentimiento previo de los usuarios para tratar sus datos personales con los fines indicados.</p>\n        <p>El usuario tiene derecho a revocar su consentimiento previo en cualquier momento.</p>\n        <p>Sistemas de captura de información personal que utiliza Aicad:</p>\n        <p>1)  Formularios de suscripción a contenidos: dentro de la web existen varios formularios para activar la suscripción. Deberás confirmar tu suscripción para poder validar tu dirección de correo electrónico. Los datos facilitados serán utilizados exclusivamente para enviar la Newsletter y mantenerte actualizado sobre novedades y ofertas puntuales, exclusivas.</p>\n        <p>2)  Formulario de comentarios: La web incluye un formulario para comentar artículos, dejar su reseña para los productos y/o otros post del tipo personalizado. El usuario podrá publicar comentarios en los post que se publiquen. Los datos personales introducidos en el formulario para insertar estos comentarios serán utilizados exclusivamente para moderarlos y publicarlos.</p>\n        <p>3)  Formulario de contacto: También existe un formulario de contacto para consultas, sugerencias o contratación de servicio. En este caso se utilizará la dirección de correo electrónico para responder a las mismas y enviar la información que el usuario requiera a través de la web.</p>\n        <p>4)  Cookies: Cuando el usuario se registra o navega en esta web, se almacenan “cookies”, El usuario puede consultar en cualquier momento la política de cookies para ampliar información sobre el uso de cookies y como desactivarlas.</p>\n        <p>5)  Sistemas de Descargas: En esta web se pueden descargar diferentes contenidos que se incorporan periódicamente en nuestro blog, en otros portales pertenecientes a Aicad y los usuarios cuentan con la posibilidad de descargar en formato PDF cualquier temario del curso.</p>\n        <p>6)  Navegación y Dirección IP: Al navegar por esta web, el usuario facilita de forma automática al servidor de la web información relativa a tu dirección IP, fecha y hora de acceso, el hipervínculo que le ha reenviado a éstas, tu sistema operativo y el navegador utilizado. La Agencia Española de Protección de Datos considera la IP como dato de carácter personal. Esta web no utilizará la IP para identificar a sus usuarios, estos datos serán guardados y utilizados únicamente para el control y realización de estadísticas de acceso y visitas a la web, para analizar tendencias, administrar el sitio, y para recopilar información demográfica sobre nuestra base de usuarios en su conjunto. En ningún caso serán comunicados o cedidos a terceros.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          CORREOS COMERCIALES\n        </h4>\n        <p>De acuerdo con la LSSICE, Aicad no realiza prácticas de SPAM, por lo que no envía correos comerciales por vía electrónica que no hayan sido previamente solicitados o autorizados por el Usuario, en algunas ocasiones, puede remitir promociones y ofertas puntuales propias y de terceros, solo en los casos en los que cuente con la autorización de los destinatarios. En consecuencia, en cada uno de los formularios habidos en la Página Web, el Usuario tiene la posibilidad de dar su consentimiento expreso para recibir mi “Newsletter”, con independencia de la información comercial puntualmente solicitada. También podrá cancelar su suscripción de manera automática en la misma Newsletters..</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          MEDIDAS DE SEGURIDAD\n        </h4>\n        <p>De conformidad con la legislación vigente, el responsable de este sitio ha adoptado los niveles y medidas de seguridad para la protección de los datos personales que se establecen en el Reglamento General de Protección de Datos (UE) 2016/679 de protección de datos de carácter personal, respetando las obligaciones y el deber de confidencialidad que establece la ley, e instalando en sus sistemas y ficheros las medidas técnicas necesarias para garantizar el tratamiento confidencial de los datos, evitar su pérdida, alteración y acceso no autorizado.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          Política de protección de menores\n        </h4>\n        <p>Quien facilita los datos a través de los formularios de esta Web y acepta su tratamiento declara formalmente ser mayor de 14 años. Queda prohibido el acceso y uso del portal a los menores de 14 años de edad.</p>\n        <p>Aicad recuerda a las personas mayores de edad que tengan a su cargo menores, que será de su exclusiva responsabilidad si algún menor incorpora sus datos para solicitar algún servicio.</p>\n        <p>También les informa que existen programas informáticos para acotar la navegación mediante el filtro o bloqueo a determinados contenidos.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          LEGISLACIÓN APLICABLE\n        </h4>\n        <p>Todos los litigios, controversias o reclamaciones surgidas de la interpretación o la ejecución de las condiciones generales de venta se regirán por la legislación española, y se someterán a la jurisdicción de los Juzgados y Tribunales del domicilio del titular del Web.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          CAMBIOS EN LA PRESENTE POLÍTICA DE PRIVACIDAD\n        </h4>\n        <p>Aicad Business School se reserva el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria. En dichos supuestos, el Prestador anunciará en esta página los cambios introducidos con razonable antelación a su puesta en práctica.</p>\n      </div>\n      <div>\n        <h4 class=\"text-uppercase --bold\">\n          CONFIDENCIALIDAD\n        </h4>\n        <p>Tiene carácter confidencial toda la información y documentación utilizada durante la contratación, desarrollo y ejecución de las Condiciones contractuales que regulan las relaciones entre Aicad y el Cliente. No se entenderá información confidencial aquélla que sea divulgada por acuerdo entre las Partes, aquélla que se convierta en pública por igual motivo o aquélla que haya de ser revelada de acuerdo con las leyes o con una resolución judicial de autoridad competente y aquélla que sea obtenida por un tercero que no se encuentre bajo la obligación de confidencialidad alguna. Ambas partes se obligan a cumplir el deber de confidencialidad y a mantenerlo por un periodo mínimo de dos (2) años después de finalizar las mencionadas Condiciones contractuales que regulan las relaciones de Aicad y el Cliente.</p>\n        <p>Toda información recibida por parte del cliente ya sean imágenes, textos, datos de acceso como usuarios y contraseñas de WordPress, hosting u otros, se tratará de modo confidencial, estando totalmente prohibida la cesión a terceros a menos que contemos con su consentimiento y siempre para la misma finalidad en la que han sido obtenidos los datos.</p>\n      </div>\n    </div>\n  </div>"
            },
            "cookies-policy": {
                "content": "  <div class=\"container default-container text-left\">\n    <div class=\"bg-card p-4\">\n      <h1 class=\"text-uppercase --bold\">\n        POLÍTICA DE COOKIES\n      </h1>\n      <p>¡Te damos la más cordial bienvenida a Aicad Business School!</p>\n      <div class=\"mt-5\">\n        <p>Las partes que se vinculan a través de estas condiciones son Aicad Business School S.L, con domicilio social en Calle León y Castillo 54, 1º Planta, 35003, Las Palmas de Gran Canaria CIF B76062199, Empresa inscrita en el Registro Mercantil de las Palmas 30/04/2010 Tomo 1958 libro 0 Folio 116,  la cual ofrece sus productos y servicios a través de la plataforma de Internet Planetajob.es (www.planetajob.es), en adelante Aicad, y el usuario que acceda, a la misma, bien a través de un ordenador personal, bien a través de cualquier aplicación desarrollada para “smartphones” o por cualquier otro medio y que, en su caso, utilice las prestaciones ofrecidas por ésta. En consecuencia, el mero acceso a Aicad por cualquier medio implica la aceptación por el usuario de las presentes condiciones y términos de uso. Podrás contactar con nosotros al email info@planetajob.es o al teléfono (+34) 928 35 46 68 para pedir mas información.</p>\n      </div>\n    </div>\n\n    <div class=\"bg-card p-4\">\n      <div>\n        <h2 class=\"text-uppercase --bold\">\n          POLÍTICA DE COOKIES\n        </h2>\n        <p>Una cookie es un pequeño fichero de texto que se almacena en su navegador cuando visita casi cualquier página web. Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página. Las cookies suelen almacenar información de carácter técnico, preferencias personales, personalización de contenidos, estadísticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc. El objetivo de la cookie es adaptar el contenido de la web a su perfil y necesidades, sin cookies los servicios ofrecidos por cualquier página se verían mermados notablemente. Si desea consultar más información sobre qué son las cookies, qué almacenan, cómo eliminarlas, desactivarlas, etc.</p>\n        \n        <p><strong>Cookies utilizadas en este sitio web</strong></p>\n        <table style=\"width{100}%\">\n          <tr>\n            <th>TIPO DE COOKIES</th>\n            <th>FINALIDAD</th>\n          </tr>\n          <tr>\n            <td>DE FUNCIONAMIENTO</td>\n            <td>Estas cookies permiten la navegación a través de la web y la utilización de las diferentes opciones o servicios que se prestan. También se utilizan para mejorar tu experiencia de navegación y para optimizar el funcionamiento de nuestra web. Almacenan configuraciones de servicios para que el usuario no tenga que reconfigurarlos cada vez que nos visita.</td>\n          </tr>\n          <tr>\n            <td>ANALITICAS</td>\n            <td>Estas cookies se utilizan para recoger información sobre el uso de nuestro sitio web por parte de los visitantes. Utilizamos la información para elaborar informes y para mejorar el sitio. Estas cookies se asocian únicamente a un usuario anónimo y a su ordenador/dispositivo sin proporcionar referencias que permitan conocer datos personales. Recogen el número de visitantes al sitio, el tiempo que duran las visitas, el navegador, el tipo de terminal, el lugar de procedencia de los visitantes y las páginas visitadas.</td>\n          </tr>\n          <tr>\n            <td>DE GEOLOCALIZACIÓN</td>\n            <td>Estas cookies se utilizan para almacenar datos de geolocalización del ordenador y dispositivos para ofrecer servicios y contenidos más adecuados.</td>\n          </tr>\n        </table>\n        <p class=\"mt-4\">\n          Siguiendo las directrices de la Agencia Española de Protección de Datos procedemos a detallar el uso de cookies que hace esta web con el fin de informarle con la máxima exactitud posible.\n        </p>\n        <p>Este sitio web utiliza las siguientes cookies propias:</p>\n        <li>Cookies de sesión, para garantizar que los usuarios que escriban comentarios en el blog sean humanos y no aplicaciones automatizadas. De esta forma se combate el spam.</li>\n        <p>Este sitio web utiliza las siguientes cookies de terceros:</p>\n        <li>Google Analytics: Almacena cookies para poder elaborar estadísticas sobre el tráfico y volumen de visitas de esta web. Al utilizar este sitio web está consintiendo el tratamiento de información acerca de usted por Google. Por tanto, el ejercicio de cualquier derecho en este sentido deberá hacerlo comunicando directamente con Google.</li>\n        <li>Redes sociales: Cada red social utiliza sus propias cookies para que usted pueda pinchar en botones del tipo Me gusta o Compartir.</li>\n        <p class=\"mt-4\">\n          <strong>Desactivación o eliminación de cookies</strong>\n        </p>\n        <p>En cualquier momento podrá ejercer su derecho de desactivación o eliminación de cookies de este sitio web. Estas acciones se realizan de forma diferente en función del navegador que esté usando. Mas adelante damos instrucciones concretas para cualquier tipo de navegador.</p>\n        \n        <p class=\"mt-4\">\n          <strong>Notas adicionales</strong>\n        </p>\n        <ul>\n          <li>Ni esta web ni sus representantes legales se hacen responsables ni del contenido ni de la veracidad de las políticas de privacidad que puedan tener los terceros mencionados en esta política de cookies.</li>\n          <li>Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe efectuar su derecho a eliminación o desactivación de las mismas. Ni esta web ni sus representantes legales pueden garantizar la correcta o incorrecta manipulación de las cookies por parte de los mencionados navegadores.</li>\n          <li>En algunos casos es necesario instalar cookies para que el navegador no olvide su decisión de no aceptación de las mismas.</li>\n          <li>En el caso de las cookies de Google Analytics, esta empresa almacena las cookies en servidores ubicados en España y se compromete a no compartirla con terceros, excepto en los casos en los que sea necesario para el funcionamiento del sistema o cuando la ley obligue a tal efecto.</li>\n          <li>NALÍTICA WEB: La web utiliza Google Analytics, un servicio analítico de web prestado por Google, Inc., una compañía de Delaware cuya oficina principal está en 1600 Amphitheatre Parkway, Mountain View (California), CA 94043, Estados Unidos (“Google”). Google Analytics utiliza “cookies”, que son archivos de texto ubicados en su ordenador, para ayudar al website a analizar el uso que hacen los usuarios del sitio web. La información que genera la cookie acerca de su uso del website (incluyendo su dirección IP) será directamente transmitida y archivada por Google en los servidores de Estados Unidos. Google usará esta información por cuenta nuestra con el propósito de seguir la pista de su uso del website, recopilando informes de la actividad del website y prestando otros servicios relacionados con la actividad del website y el uso de Internet. Google podrá transmitir dicha información a terceros cuando así se lo requiera la legislación, o cuando dichos terceros procesen la información por cuenta de Google. Google no asociará su dirección IP con ningún otro dato del que disponga Google. Puede Usted rechazar el tratamiento de los datos o la información rechazando el uso de cookies mediante la selección de la configuración apropiada de su navegador, sin embargo, debe Usted saber que si lo hace puede ser que no pueda usar la plena funcionabilidad de este website. Al utilizar este website Usted consiente el tratamiento de información acerca de Usted por Google en la forma y para los fines arriba indicados.</li>\n          <li>Para cualquier duda o consulta acerca de esta política de cookies no dude en comunicarse con nosotros a través de la sección de contacto.</li>\n        </ul>\n\n        <p class=\"mt-4\">\n          <strong>¿Qué es una cookie?</strong>\n        </p>\n        <p>Una cookie es un fichero de texto inofensivo que se almacena en su navegador cuando visita casi cualquier página web. La utilidad de la cookie es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página. Aunque mucha gente no lo sabe las cookies se llevan utilizando desde hace 20 años, cuando aparecieron los primeros navegadores para la World Wide Web.</p>\n\n        <p class=\"mt-4\">\n          <strong>¿Qué NO ES una cookie?</strong>\n        </p>\n        <p>No es un virus, ni un troyano, ni un gusano, ni spam, ni spyware, ni abre ventanas pop-up.</p>\n\n        <p class=\"mt-4\">\n          <strong>¿Qué información almacena una cookie?</strong>\n        </p>\n        <p>Las cookies no suelen almacenar información sensible sobre usted, como tarjetas de crédito o datos bancarios, fotografías, su DNI o información personal, etc. Los datos que guardan son de carácter técnico, preferencias personales, personalización de contenidos, etc.</p>\n        <p>El servidor web no le asocia a usted como persona si no a su navegador web. De hecho, si usted navega habitualmente con Internet Explorer y prueba a navegar por la misma web con Firefox o Chrome verá que la web no se da cuenta que es usted la misma persona porque en realidad está asociando al navegador, no a la persona.</p>\n\n        <p class=\"mt-4\">\n          <strong>¿Qué tipo de cookies existen?</strong>\n        </p>\n        <ul>\n          <li>Cookies técnicas: Son las más elementales y permiten, entre otras cosas, saber cuándo está navegando un humano o una aplicación automatizada, cuándo navega un usuario anónimo y uno registrado, tareas básicas para el funcionamiento de cualquier web dinámica.</li>\n          <li>Cookies de análisis: Recogen información sobre el tipo de navegación que está realizando, las secciones que más utiliza, productos consultados, franja horaria de uso, idioma, etc.</li>\n          <li>Cookies publicitarias o comerciales: Pueden mostrar de forma periódica publicidad en función de su navegación, su país de procedencia, idioma, etc.</li>\n          <li>Cookies de afiliados: realizan el seguimiento de nuestra red de afiliados para ayudarles a realizar el reporte de las ventas.</li>\n        </ul>\n        \n        <p class=\"mt-4\">\n          <strong>¿Qué son las cookies propias y las de terceros?</strong>\n        </p>\n        <p>Las cookies propias son las generadas por la página que está visitando y las de terceros son las generadas por servicios o proveedores externos como Facebook, Twitter, Google, etc.</p>\n\n        <h2>Tipología, finalidad y funcionamiento de las Cookies en Planetajob.es</h2>\n        <table style=\"width{100}%\">\n          <tr>\n            <th>Empresa</th>\n            <th>Dominio</th>\n            <th>Nombre de la cookie</th>\n            <th>Objetivo/Finalidad</th>\n          </tr>\n          <tr>\n            <td>Aicad</td>\n            <td>Planetajob.es</td>\n            <td>cdp-cookies-plugin-wp / __smToken /sc_is_visitor_unique / pll_language/ SnapABugHistory/ PHPSESSID/ __hstc / hubspotutk /SnapABugChatWindow / _gat_pub_social / _gat_shr_post_share / woocommerce / __zlcmid / ssupp.chatid / tk_r3d / euCookiesAcc</td>\n            <td>Estas cookies tienen como finalidad mejorar la navegación por el sitio web. Unas tienen la característica que son persistentes y otras únicamente de sesión</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Google.com</td>\n            <td>HSID/ SID/ Conversion</td>\n            <td>Son utilizadas por Google para verificar el user account y el login más reciente</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Adwords</td>\n            <td>test_cookie / _ads   /    ga-audiences / ads/user-lists/#</td>\n            <td>Servicio de publicidad</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>Analytics</td>\n            <td>__utmv / _ga</td>\n            <td>Utilizada para Google Analytics</td>\n          </tr>\n          <tr>\n            <td>Twitter</td>\n            <td>Twitter</td>\n            <td>guest_id</td>\n            <td>Utiliza por Twitter para verificar el user account</td>\n          </tr>\n          <tr>\n            <td>Alexa</td>\n            <td>Alexa.com</td>\n            <td>tbver</td>\n            <td>Barra Alexa</td>\n          </tr>\n          <tr>\n            <td>Facebook</td>\n            <td>Facebook.com</td>\n            <td>datr</td>\n            <td>Utilizada por Faceebook para validar al usuario</td>\n          </tr>\n          <tr>\n            <td>Google</td>\n            <td>TAGMANAGER</td>\n            <td>ym_metrika_enabled_   / _gat /   _gid / yabs-sid</td>\n            <td>Utilizada por Google TagManager para mejorar la experiencia del usuario y ofrecer contenidos relacionados a sus intereses.</td>\n          </tr>\n        </table>\n\n        <p class=\"mt-4\">\n          <strong>¿Qué son las cookies propias y las de terceros?</strong>\n        </p>\n        <p>Para que entienda el alcance que puede tener desactivar las cookies le mostramos unos ejemplos:</p>\n        <ul>\n          <li>No podrá compartir contenidos de esa web en Facebook, Twitter o cualquier otra red social.</li>\n          <li>El sitio web no podrá adaptar los contenidos a sus preferencias personales, como suele ocurrir en las tiendas online.</li>\n          <li>No podrá acceder al área personal de esa web, como por ejemplo Mi cuenta, o Mi perfil o Mis pedidos.</li>\n          <li>Tiendas online: Le será imposible realizar compras online, tendrán que ser telefónicas o visitando la tienda física si es que dispone de ella.</li>\n          <li>No será posible personalizar sus preferencias geográficas como franja horaria, divisa o idioma.</li>\n          <li>El sitio web no podrá realizar analíticas web sobre visitantes y tráfico en la web, lo que dificultará que la web sea competitiva.</li>\n          <li>No podrá escribir en el blog, no podrá subir fotos, publicar comentarios, valorar o puntuar contenidos. La web tampoco podrá saber si usted es un humano o una aplicación automatizada que publica spam.</li>\n          <li>No se podrá realizar el seguimiento comercial, lo que reducirá los ingresos de nuestra red de afiliados.</li>\n          <li>Todas las redes sociales usan cookies, si las desactiva no podrá utilizar ninguna red social.</li>\n          <li>No podrá acceder a promociones periódicas, a su cuenta de usuario, editor o afiliado.</li>\n        </ul>\n\n        <p class=\"mt-4\">\n          <strong>¿Se pueden eliminar las cookies?</strong>\n        </p>\n        <p>Sí. No sólo eliminar, también bloquear, de forma general o particular para un dominio específico.</p>\n        <p>Para eliminar las cookies de un sitio web debe ir a la configuración de su navegador y allí podrá buscar las asociadas al dominio en cuestión y proceder a su eliminación.</p>\n      \n        <p class=\"mt-4\">\n          <strong>Configuración de cookies para los navegadores más populares</strong>\n        </p>\n        <p>A continuación le indicamos cómo acceder a una cookie determinada del navegador Chrome. Nota: estos pasos pueden variar en función de la versión del navegador:</p>\n        <ol>\n          <li>Vaya a Configuración o Preferencias mediante el menú Archivo o bien pinchando el icono de personalización que aparece arriba a la derecha.</li>\n          <li>Verá diferentes secciones, pinche la opción Mostrar opciones avanzadas.</li>\n          <li>Vaya a Privacidad, Configuración de contenido.</li>\n          <li>Seleccione Todas las cookies y los datos de sitios.</li>\n          <li>Aparecerá un listado con todas las cookies ordenadas por dominio. Para que le sea más fácil encontrar las cookies de un determinado dominio introduzca parcial o totalmente la dirección en el campo Buscar cookies.</li>\n          <li>Tras realizar este filtro aparecerán en pantalla una o varias líneas con las cookies de la web solicitada. Ahora sólo tiene que seleccionarla y pulsar la X para proceder a su eliminación.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador Internet Explorer siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Vaya a Herramientas, Opciones de Internet</li>\n          <li>Haga click en Privacidad.</li>\n          <li>Mueva el deslizador hasta ajustar el nivel de privacidad que desee.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador Firefox siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Vaya a Opciones o Preferencias según su sistema operativo.</li>\n          <li>Haga click en Privacidad.</li>\n          <li>En Historial elija Usar una configuración personalizada para el historial.</li>\n          <li>Ahora verá la opción Aceptar cookies, puede activarla o desactivarla según sus preferencias.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador Safari para OSX siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Vaya a Preferencias, luego Privacidad.</li>\n          <li>En este lugar verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea realizar.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador Safari para iOS siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Vaya a Ajustes, luego Safari.</li>\n          <li>Vaya a Privacidad y Seguridad, verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea realizar.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador Microsoft Windows Edge siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Vaya a la barra lateral pulsando en los 3 puntos para abrir la Configuración general.</li>\n          <li>Vaya a Configuración Avanzada, verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea realizar.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador para dispositivos Android siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Ejecute el navegador y pulse la tecla Menú, luego Ajustes.</li>\n          <li>Vaya a Seguridad y Privacidad, verá la opción Aceptar cookies para que active o desactive la casilla.</li>\n        </ol>\n        <p>Para acceder a la configuración de cookies del navegador para dispositivos Windows Phone siga estos pasos (pueden variar en función de la versión del navegador):</p>\n        <ol>\n          <li>Abra Internet Explorer, luego Más, luego Configuración</li>\n          <li>Ahora puede activar o desactivar la casilla Permitir cookies.</li>\n        </ol>\n      </div>\n    </div>\n  </div>"
            },
            "login": {
                "login": {
                    "title": "Acceso",
                    "email-resend": "Reenviar correo de verificación",
                    "button": "INICIAR SESIÓN",
                    "forgot-password": "¿Has olvidado la contraseña?"
                },
                "register": {
                    "title": "¿Eres candidato/a?",
                    "subtitle": "Encuentra la oportunidad que estás buscando",
                    "the-point": "Accede a nuevas oportunidades profesionales todos los días",
                    "first-point-title": "Bolsa de CVs cualificados",
                    "first-point-subtitle": "Miles  de currículums por especialidad",
                    "second-point-title": "Diversidad  de perfiles",
                    "second-point-subtitle": "Puedes encontrar comercial, administrativo, programador...",
                    "third-point-title": "Te ayudamos a conseguirlo",
                    "third-point-subtitle": "Nos encargamos de atraer a la mayor red de profesionales cualificados",
                    "first-offer": "Publica tu 1ª oferta",
                    "button": "¡Regístrate ahora!"
                },
                "register-company": {
                    "title": "¿Eres empresa?",
                    "subtitle": "Encuentra al candidato idóneo para tu vacante",
                    "work-success": "Trabajamos a éxito",
                    "best-opportunities": "¡Las mejores oportunidades en Planetajob!",
                    "first-point-title": "Bolsa de CVs cualificados",
                    "first-point-subtitle": "Miles  de currículums por especialidad",
                    "second-point-title": "Diversidad  de perfiles",
                    "second-point-subtitle": "Puedes encontrar comercial, administrativo, programador...",
                    "third-point-title": "Te ayudamos a conseguirlo",
                    "third-point-subtitle": "Nos encargamos de atraer a la mayor red de profesionales cualificados",
                    "first-offer": "Publica tu 1ª oferta",
                    "button": "¡Regístrate ahora!"
                },
                "email-resent": "¡Correo electrónico reenviado!"
            },
            "register": {
                "title": "Crea tu cuenta",
                "try-again": "Please try again.",
                "hotmail-warning": "Estamos tendiendo problemas en verificar el correo de Hotmail y outlook. Por favor usa gmail u otro tipo de correo alternativo. Gracias por tu paciencia.",
                "im-a-company": "¿Eres empresa?",
                "company-type": {
                    "company": "Empresa",
                    "temporar": "ETT",
                    "headhunter": "Headhunter",
                    "hr": "Consultora de Recursos humanos"
                },
                "invalid-cif": "CIF o NIF no válido",
                "read-the": "He leído y acepto las",
                "accept-conditions": "Por favor, acepta las condiciones",
                "button": "CREAR CUENTA"
            },
            "forgot-password": {
                "title": "¿Olvidaste tu contraseña?",
                "instructions": "Enviaremos a tu correo electrónico las instrucciones para restablecer tu contraseña.",
                "reset-password": "Restablecer",
                "success-message": "Hemos enviado a {email} las instrucciones para restablecer la contraseña. Si no encuentras las instrucciones en tu bandeja de entrada, revisa la carpeta spam. Gracias."
            },
            "reset-password": {
                "title": "Restablecer la contraseña",
                "instructions": "Para restablecer su contraseña, ingrese los detalles solicitados.",
                "new-password": "Ingrese nueva clave",
                "repeat-new-password": "Repite la nueva contraseña",
                "change-password": "CAMBIA LA CONTRASEÑA",
                "oops": "Ups... No deberías estar aquí...",
                "if-error": "Si cree que se trata de un error, comuníquese con la administración.",
                "success-msg": "¡Contraseña cambiada correctamente! Ahora puede iniciar sesión en su cuenta con su nueva contraseña.",
                "error-msg": "No pudimos restablecer la contraseña con la información que proporcionó. Intente solicitar otro enlace para restablecer la contraseña o, si el problema persiste, póngase en contacto con el servicio de asistencia.",
                "request-link": "SOLICITAR ENLACE"
            },
            "verify-email": {
                "verifying": "Verificando...",
                "success-msg": "Tu correo electrónico ha sido verificado con éxito. ¡Ya puedes iniciar sesión!",
                "success": "¡Te damos la bienvenida!"
            },
            "dashboards": {
                "navigation": {
                    "dashboard": "Panel",
                    "all-offers": "Ofertas",
                    "offers": "Ofertas",
                    "candidates": "Candidatos",
                    "companies": "Empresas",
                    "users": "Usuarios",
                    "payments": "Pagos",
                    "promo-codes": "Códigos de activación",
                    "referrals": "Referencias",
                    "delegations": "Delegaciones",
                    "headhunters": "Headhunters",
                    "publish-offer": "Publicar oferta",
                    "your-offers-and-applications": "Mis ofertas",
                    "all-your-candidates": "Mis candidatos",
                    "applications": "Candidaturas",
                    "my-cv": "Mi CV",
                    "my-account": "Mi cuenta"
                },
                "admin": {
                    "statistics": {
                        "offers": {
                            "title": "Total de ofertas",
                            "total-candidates": "Total de Candidatos"
                        },
                        "companies": {
                            "title": "Total de empresa",
                            "confirmed": "Confirmadas",
                            "pending": "Pendientes",
                            "rejected": "Rechazadas"
                        },
                        "users": {
                            "title": "Total de usuarios",
                            "companies": "Empresas",
                            "users": "Usuarios"
                        }
                    }
                },
                "candidate": {
                    "hello": "¡Hola {name}!",
                    "stat-cards": {
                        "offers": {
                            "title": "Ofertas nuevas",
                            "subtitle": "en total publicadas en las últimas 24 horas"
                        },
                        "cv": {
                            "title": "Actualiza tu CV",
                            "subtitle": "Aumenta las posibilidades de impulsar tu carrera profesional.",
                            "link": "Ir a Mi CV"
                        },
                        "applications": {
                            "title": "Candidaturas activas",
                            "subtitle": "Descubre las novedades sobre tus candidaturas",
                            "link": "Ir a Candidaturas"
                        }
                    },
                    "new-offers": {
                        "title": "Nuevas ofertas",
                        "no-offers": "No hay ofertas nuevas que coincidan con tu CV en este momento."
                    }
                },
                "employer": {
                    "verification": {
                        "info": "La cuenta de <strong>{companyTitle}</strong> es limitada.\n                No puede publicar ofertas hasta que el administrador de {appName} confirme su cuenta.\n                Nuestro personal se pondrá en contacto las próximas 48 horas al teléfono <strong>{companyPhone}</strong>.",
                        "wrong-phone": "¿Número equivocado?",
                        "update-profile": "Actualizalo aquí",
                        "rejected-info": "Desafortunadamente, su cuenta de empresa (<strong>{companyTitle}</strong>)\n                ha sido <strong><i>Rechazada</i></strong>! Sus datos de contacto fueron percibidos como\n                sospechosos por nuestro equipo. Si tiene alguna pregunta, comuníquese con el servicio de\n                atención al cliente de {appName}. Gracias por su comprensión."
                    },
                    "free-offer-alert": "¡Felicidades! ¡Tienes <strong>{offersCount}</strong> oferta gratis!",
                    "free-offer-alert-expire": "La oferta gratuita caducará el {offerExpirationDateFormatted}",
                    "publish": {
                        "title": "Publica una oferta de empleo ahora:",
                        "switch": {
                            "standart": "Planes estándar",
                            "corporate": "Planes corporativos"
                        }
                    },
                    "standard": {
                        "basic": {
                            "label": "Oferta Básica",
                            "header": "Anuncio básico",
                            "footer": {
                                "line-1": "Infoempleo",
                                "line-2": "Redes sociales"
                            }
                        },
                        "standard": {
                            "label": "Oferta Estándar",
                            "header": "Anuncio estándar",
                            "footer": {
                                "line-1": "LinkedIn",
                                "line-2": "Infoempleo",
                                "line-3": "Redes sociales"
                            }
                        },
                        "premium": {
                            "label": "Oferta Premium",
                            "header": "Anuncio corporate",
                            "footer": {
                                "line-2": "Infoempleo",
                                "line-1": "LinkedIn",
                                "line-3": "Infojobs",
                                "line-4": "Redes sociales"
                            }
                        }
                    },
                    "corporate": {
                        "standard": {
                            "label": "x10 en 3 portales",
                            "header": "Pack standar",
                            "footer": {
                                "line-1": "Infoempleo",
                                "line-2": "Redes sociales"
                            }
                        },
                        "company": {
                            "label": "x25 en 4 portales",
                            "header": "Pack empresas",
                            "footer": {
                                "line-1": "LinkedIn",
                                "line-2": "Infoempleo",
                                "line-3": "Redes sociales"
                            }
                        },
                        "corporate": {
                            "label": "x100 en 5 portales",
                            "header": "Pack corporate",
                            "footer": {
                                "line-2": "Infoempleo",
                                "line-1": "LinkedIn",
                                "line-3": "Infojobs",
                                "line-4": "Redes sociales"
                            }
                        }
                    },
                    "headhunter": {
                        "title": "¿Eres Headhunter?",
                        "card": {
                            "header": "Anuncio Headhunter",
                            "title": "Te ayudamos a conseguirlo",
                            "subtitle": "Hacemos búsqueda y criba curricular a",
                            "subtitle2": "ÉXITO",
                            "button": "CONTÁCTANOS",
                            "content": "Hacemos todo el proceso de selección sin que tengas que preocuparte de nada. 10% del salario bruto anual para puestos IT, médico y especialistas.",
                            "cols": {
                                "first": {
                                    "title": "Nos encargamos de todo el proceso",
                                    "first-point": "Publicación de ofertas",
                                    "second-point": "Criba de CVs",
                                    "third-point": "Entrevistas de candidatos potenciales"
                                },
                                "second": {
                                    "title": "Redacción de informe del perfil idóneo",
                                    "first-point": "Coordinación de entrevista final",
                                    "second-point": "Evaluación y seguimiento por 3 meses"
                                }
                            }
                        }
                    }
                },
                "hr": {
                    "hello": "¡Hola {name}!",
                    "actions": "Acciones",
                    "all-offers": "Ofertas",
                    "all-users": "Candidatos",
                    "all-delegations": "Delegaciones",
                    "no-companies-warning": "¡No tienes empresas asignadas! No podrá ver ofertas ni usuarios."
                }
            },
            "one-company": {
                "company-control": {
                    "company-data": "Datos de la empresa",
                    "confirm": "¿Estás seguro que quieres <strong style=\"color: green\">CONFIRMAR</strong> esta empresa?",
                    "reject": "¿Estás seguro que quieres <strong style=\"color: red\">RECHAZAR</strong> esta empresa?",
                    "delete": "¿Estás seguro que quieres <strong style=\"color: red\">ELIMINAR</strong> esta empresa?",
                    "undo": "¡You cannot undo this action!",
                    "adminNote": {
                        "title": "Nota privada:",
                        "no-note": "Aún no hay nota...",
                        "btnAdd": "Añadir nota",
                        "btnEdit": "Editar nota",
                        "modal": {
                            "title": "Modificar nota privada",
                            "formLabel": "Ingrese nota privada:",
                            "formValidation": "Máximo 1000 caracteres!"
                        }
                    }
                }
            },
            "one-offer": {
                "no-company-name": "Nombre de empresa no disponible",
                "requirements": "Requisitos",
                "minimum-studies": "Estudios mínimos",
                "minimum-experience": "Experiencia mínima",
                "necessary-knowledge": "Conocimientos necesarios",
                "description": "Descripción",
                "category": "Categoria de la oferta",
                "industry-type": "Tipo de industria de la oferta",
                "contract-type": "Tipo de contrato",
                "level": "Nivel",
                "number-vacancies": "Número de vacantes",
                "salary": "Salario",
                "salary-from-to": "{min} - {max} {type}",
                "salary-more-than": "Más de {min} {type}",
                "salary-dont-show": "Salario no disponible",
                "benefits": "Beneficios",
                "other-benefits": "Otros",
                "apply-to-this-offer": "Inscribirme en esta oferta",
                "already-enrolled": "Ya te inscribiste",
                "archived": "Archivada",
                "published": "Publicada",
                "sidebar": {
                    "share-offer": {
                        "title": "Comparte esta oferta",
                        "default-message": "He encontrado una oferta de trabajo en {portal}"
                    },
                    "courses": {
                        "title": "Amplía tu formación",
                        "course1": {
                            "title": "El impacto del coronavirus en el entorno económico internacional",
                            "url": "https://www.aicad.es/el-impacto-del-coronavirus-en-el-entorno-economico-internacional"
                        },
                        "course2": {
                            "title": "Gestión de Inversiones y Patrimonios Inmobiliarios",
                            "url": "https://www.aicad.es/master-en-gestion-de-inversiones-y-patrimonios-inmobiliarios"
                        },
                        "course3": {
                            "title": "Especialista en Marketing Intelligence",
                            "url": "https://www.aicad.es/especialista-en-marketing-intelligence"
                        },
                        "see-more": "Ver más cursos",
                        "see-more.url": "https://www.aicad.es/cursos-online"
                    }
                }
            },
            "offer-apply": {
                "title": "Inscripción en:",
                "current-document": "Su CV actual:",
                "last-updated": "Última actualización en: {date}",
                "presentation-text": {
                    "text": "Carta de presentación para esta oferta:",
                    "dont-include": "No incluir carta",
                    "include": "Crear una carta"
                },
                "alert": {
                    "correct-errors": "Por favor, corrija los errores en el formulario",
                    "answer-killer-questions": "Por favor, responder a killer questions"
                },
                "answer-questions": "Por favor, conteste a las siguientes preguntas:",
                "confirm": "CONFIRMA TU INSCRIPCÍON",
                "cv-warning": {
                    "title": "¡Uy! ¡Parece que todavía no has completado su CV!",
                    "subtitle": "Completa la siguiente información para acceder a las ofertas de empleo:",
                    "button": "Ir a MÍ CV ahora"
                },
                "sidebar": {
                    "title": "Datos de la oferta",
                    "company": "Empresa",
                    "place": "Localización",
                    "salary": "Salario",
                    "publish-date": "Fecha de publicación",
                    "min-exp": "Experiencia mínima",
                    "contract-type": "Tipo de contrato"
                }
            },
            "copy-offer": {
                "title": "¡Publica tu oferta en otras provincias!",
                "subtitle": "Si deseas publicar tu oferta en otras provincias, debes ingresar el código de activación.",
                "obtain-promo": "*Para obtener tu código de activación debes ponerte en contacto con el administrador del portal a través del correo electrónico info@plantetajob.es",
                "promo-applied": "¡Felicidades! Tienes una copia gratuita para <strong> {discount} </strong> provincias",
                "promo-invalid": "¡El código promocional no es válido!",
                "promo-placeholder": "Ingrese el código",
                "promo-apply": "APLICAR",
                "add": "Añadir",
                "dialog-title": "¿Seguro quieres crear {number} registros?",
                "dialog-warning": "Advertencia: Si haces clic en Aceptar, se crearán <strong style=\"font-size: 1rem\">{provincesSelected}</strong> registros",
                "save-sucess": "Guardada con éxito {savedCount} ofertas.",
                "view-offers": "Ver mis ofertas",
                "alert": {
                    "must-enter-valid-promo": "¡Debe ingresar un código de promoción válido!",
                    "can-only-copy-to": "Solo puede hacer una copia en {count} provincias con este código de promoción"
                }
            },
            "offer-intern": {
                "no-candidates": "Todavía no hay candidatos",
                "rejected-interns": {
                    "title": "Candidatos rechazados"
                }
            },
            "my-applications": {
                "total-label": "Total de Candidaturas:",
                "title": "Candidaturas",
                "subtitle": "Actualizaciones del estado de tus candidaturas",
                "no-applications": "¡Aún no te has postulado a una oferta!"
            },
            "my-candidates": {
                "no-candidates": "Aún no hay candidatos",
                "filters": {
                    "status": {
                        "new": "Nuevo",
                        "seen": "Visto",
                        "inprocess": "En proceso",
                        "accepted": "Aceptado",
                        "rejected": "Rechazado",
                        "invalid": "No se ajustan"
                    },
                    "order": {
                        "date": "Ordenar por fecha de solicitud",
                        "candidate": "Ordenar por candidato",
                        "last_change": "Ordenar por última actualización",
                        "offer_creation": "Ordenar por fecha de oferta"
                    }
                }
            },
            "my-offers": {
                "total-label": "Total de Ofertas:",
                "no-offers": "Aún no hay ofertas",
                "add-new-offer": "Añadir nuevo anuncio",
                "filters": {
                    "order-by-title": "Ordenar oferta",
                    "show-title": "Filtrar anuncios",
                    "order-by": {
                        "newest": "Por más nuevo",
                        "last_update": "Por última modificación",
                        "title": "Orden alfabético",
                        "province": "Por provincia"
                    },
                    "show": {
                        "all": "Todos los anuncios",
                        "active": "Abiertas",
                        "archived": "Cerradas",
                        "unpaid": "Borrador"
                    }
                },
                "share-offer": {
                    "default-message": "He encontrado una oferta de trabajo en {portal}"
                }
            },
            "payment-callback": {
                "success": "¡Su pago de la oferta se realizó correctamente! Tu oferta será visible públicamente a partir de ahora",
                "fail": "Desafortunadamente, su pago falló. Su tarjeta no fue cargada. Inténtalo de nuevo ...",
                "thank-you": "Gracias por elegirnos.",
                "continue": "Continuar..."
            },
            "my-account": {
                "tabs": {
                    "payments": "Compras",
                    "company": "Datos de tu empresa",
                    "profile": "Tus datos de usuario",
                    "notifications": "Notificaciones",
                    "promo-codes": "Códigos promocionales"
                },
                "company": {
                    "cif": "CIF",
                    "phone": "Numero tel.",
                    "form": {
                        "title": "Editar información",
                        "logo": {
                            "label": "Actualizar el logo de la empresa",
                            "placeholder": "Selecciona una imagen o suéltala aquí",
                            "drop-placeholder": "Suéltala aquí...",
                            "browse-text": "Examinar"
                        },
                        "category": {
                            "label": "Categoría"
                        },
                        "company-name": {
                            "label": "Nombre de la empresa",
                            "validation": "Debe tener más de 4 caracteres",
                            "tooltip": "Para cambiar el título de la empresa, comuníquese con la administración"
                        },
                        "country": {
                            "label": "País",
                            "validation": "Debe tener más de 4 caracteres"
                        },
                        "province": {
                            "label": "Provincia",
                            "validation": "Debe tener más de 4 caracteres"
                        },
                        "phone": {
                            "label": "Teléfono de contacto",
                            "validation": "Debe tener más de 4 caracteres"
                        },
                        "company-cif": {
                            "label": "Identificación fiscal (C.I.F o N.I.F)",
                            "validation": "Debe tener más de 4 caracteres",
                            "tooltip": "¡No puedes cambiar CIF!"
                        },
                        "description": {
                            "label": "Descripción de la empresa",
                            "placeholder": "Describe tu empresa como quieres que se muestre a los candidatos. Consejo: Utiliza la descripción de vuestra web corporativa."
                        }
                    },
                    "update-success": "Empresa actualizada con éxito!"
                },
                "profile": {
                    "upload-new-avatar": "Subir nuevo avatar",
                    "avatar-updated": "Avatar ha sido actualizado",
                    "role": {
                        "admin": "Administrador",
                        "user": "Usuario",
                        "employer": "Empleador",
                        "candidate": "Candidato",
                        "headhunter": "Headhunter"
                    },
                    "actions": {
                        "edit": "Editar perfil",
                        "settings": "Configuraciones de la cuenta"
                    },
                    "edit-profile-form": {
                        "title": "Editar perfil",
                        "name": {
                            "label": "Nombre",
                            "validation": "Debe tener más de 4 caracteres"
                        },
                        "last_name": {
                            "label": "Apellido",
                            "validation": "Debe tener más de 4 caracteres"
                        },
                        "phone": {
                            "label": "Numero de telefono",
                            "validation": "Must be valid phone number"
                        },
                        "address": {
                            "label": "Dirección"
                        },
                        "country": {
                            "label": "País"
                        },
                        "province": {
                            "label": "Provincia"
                        },
                        "city": {
                            "label": "Ciudad"
                        },
                        "about-me": {
                            "label": "Sobre mi",
                            "placeholder": "Cuéntanos algo sobre ti..."
                        }
                    },
                    "account-settings-form": {
                        "locale-settings": "Configuración regional",
                        "language": {
                            "label": "Idioma preferido",
                            "validation": "Opción inválida"
                        },
                        "change-password": "Cambia la contraseña",
                        "old_password": {
                            "label": "Contraseña anterior",
                            "validation": "Debe tener como mínimo 6 caracteres"
                        },
                        "new_password": {
                            "label": "Nueva contraseña",
                            "validation": "Debe tener como mínimo 6 caracteres"
                        },
                        "repeat_password": {
                            "label": "Repite la nueva contraseña",
                            "validation": "Debe tener como mínimo 6 caracteres"
                        },
                        "reactivate-account": {
                            "title": "Reactivate Account",
                            "button": "Reactivate Account"
                        },
                        "deactivate-account": {
                            "title": "Eliminar cuenta",
                            "caption": "Una vez que borres tu cuenta, sólo el administrador podrá recuperarla en un máximo de 15 días, tras ello será eliminada. ¿Seguro que quieres eliminarla?",
                            "button": "Eliminar cuenta"
                        }
                    }
                },
                "notifications": {
                    "title": "Notificaciones",
                    "changes-successful": "Se actualizó la configuración de notificaciones",
                    "no-changes-made": "No se hicieron cambios",
                    "new-applications": {
                        "title": "Aviso de nuevos inscritos",
                        "caption": "Recibe e-mails de aviso cuando se inscriban nuevos CV en vuestras ofertas.",
                        "notifications-period": "Periodicidad de los avisos *",
                        "daily-email": "Notificación diaria de aplicación a una oferta.",
                        "instant-email": "Notificación en tiempo real de aplicación a una oferta."
                    },
                    "candidate-offers": {
                        "title": "Configura tus notificaciones",
                        "caption": "Selecciona la información que deseas recibir por email.",
                        "daily-new-offers": "Informe diario de nuevas ofertas",
                        "application-status-change": "Cambio de estado de tus candidaturas"
                    },
                    "admin": {
                        "new-companies": "Informe registrado de nuevas empresas",
                        "title": "Configura tus notificaciones",
                        "caption": "La configuración de notificaciones no está habilitada para este perfil de usuario."
                    },
                    "submit": "Establecer la Periodicidad"
                },
                "promos": {
                    "title": "Códigos promocionales",
                    "card": {
                        "uses": "{remaining} usos de cada {limit}",
                        "discount": "¡Oferta de {discount} € de descuento!",
                        "multiprovince": "¡Promoción multiprovincia para {count} provincias!"
                    },
                    "no-promos": "No hay códigos promocionales disponibles"
                }
            },
            "publish-offer": {
                "publishable-offers": {
                    "basic": "Básica",
                    "standard": "Estándar",
                    "premium": "Premium"
                },
                "which-type": "¿Qué tipo de oferta deseas publicar?",
                "unfinished-offer": "Tienes una oferta sin terminar",
                "continue-link": "¿Deseas continuar?",
                "reset-form-link": "También puedes crear una nueva oferta.",
                "progress": {
                    "job-description": "Descripción del puesto",
                    "candidate-requirements": "Requisitos del candidato",
                    "pay-for-offer": "Pagar por la oferta"
                },
                "alert": {
                    "select-offer-type": "Seleccione el tipo de oferta",
                    "correct-errors": "Por favor, corrija los errores en el formulario",
                    "offer-created": "Oferta creada con éxito",
                    "offer-updated": "Oferta actualizada con éxito"
                },
                "sidepanel": {
                    "title": "Servicios seleccionados",
                    "offer-in": "Oferta de empleo en {place}",
                    "hide-company-name": "Ocultar el nombre de la empresa",
                    "promotion": "Promoción",
                    "free-offer": "oferta gratis",
                    "promo-code": "promo code"
                },
                "first-page": {
                    "company-data": "Datos de la empresa",
                    "company-name": "Nombre de tu empresa",
                    "dont-show-company-name": "No mostrar el nombre de mi empresa",
                    "title-and-place": "Título y vacante de la oferta",
                    "offer-title": "Título de la oferta",
                    "offer-title.placeholder": "Ejemplo: Auxiliar administrativo/a con Inglés nativo",
                    "num-vacancies": "Nº de vacantes",
                    "level": "Nivel",
                    "num-personnel": "Personal a cargo",
                    "job-description": "Descripción del puesto",
                    "job-description.length": "{current} / {max} (mínimo de {min} caracteres)",
                    "job-description.help.title": "¿Qué escribir aquí?",
                    "job-description.help.text": "Describe brevemente en qué consiste el puesto vacante y cuáles serán las funciones que realizará el candidato.",
                    "job-category-and-industry-type": "Categoría y tipo de industria del puesto",
                    "category-and-subcategory": "Categoría y subcategoría",
                    "supply-industry-type": "Tipo de industria de la oferta",
                    "job-location": "Ubicación del puesto",
                    "country": "País",
                    "province": "Provincia",
                    "municipality": "Municipio",
                    "postal-code": "Código postal",
                    "type-of-contract-and-working-day": "Tipo de contrato y jornada laboral",
                    "type-of-contract": "Tipo de contrato",
                    "duration": "Duración",
                    "workday": "Jornada laboral",
                    "schedule": "Horario",
                    "salary": {
                        "salary": "Salario",
                        "caption": "Indicando el salario nos ayudas a entender mejor que tipo de perfiles buscas, y cómo podemos ayudarte a encontrarlo",
                        "type": "Tipo",
                        "minimum": "Mínimo",
                        "maximum": "Máximo",
                        "show-in-offer": "Mostrar en la oferta"
                    },
                    "job-benefits.title": "Beneficios laborales",
                    "job-benefits.caption": "Aumenta la posibilidad de recibir candidatos detallando los beneficios laborales del puesto vacante",
                    "job-benefits.other": "Otros beneficios",
                    "job-benefit": {
                        "percentage-on-targets": "Porcentaje sobre objetivos",
                        "telecommuting": "Teletrabajo",
                        "health-insurance": "Seguro médico",
                        "vehicle-mileage": "Vehículo / kilometraje",
                        "flexible-schedule": "Flexibilidad horaria",
                        "mobile-phone": "Teléfono móvil",
                        "restaurant-check": "Cheque restaurante"
                    }
                },
                "second-page": {
                    "candidate-requirements": "Requisitos del candidato",
                    "minimum-studies": "Estudios mínimos",
                    "minimum-job-experience": "Experiencia mínima en el puesto",
                    "minimum-requirements": "Requisitos Mínimos",
                    "minimum-requirements.length": "{current} / {max} caracteres",
                    "minimum-requirements.caption": "Indica experiencia, disponibilidad, certificaciones y otros requisitos imprescindibles para el puesto.",
                    "killer-questions": {
                        "short-title": "Killer questions",
                        "title": "Cuestionario previo obligatorio para candidatos: Killer Questions",
                        "caption": "Define <strong>preguntas cerradas</strong> y asigna a cada respuesta una\n<strong>puntuación</strong> para descartar, filtrar e identificar\ncandidatos. Si quieres <strong>descartar automáticamente</strong> a los\ncandidatos que no se ajusten a tus requerimientos, selecciona el valor\n\"Descartar\" como puntuación de respuesta.",
                        "example": {
                            "title": "Ejemplo de killer question",
                            "question": "¿Cuál es tu nivel de inglés?",
                            "answer1": "Nativo (10 ptos.)",
                            "answer2": "Lo uso habitualmente en el trabajo (8 ptos.)",
                            "answer3": "Lo hablo pero no lo uso habitualmente (4 ptos.)",
                            "answer4": "No lo hablo pero lo entiendo (2 ptos.)",
                            "answer5": "No lo hablo (Descartar)"
                        },
                        "question.placeholder": "Ingrese una pregunta",
                        "answer.placeholder": "Ingrese una respuesta",
                        "select-predefined": "Seleccionar pregunta predefinida",
                        "accept": "Puntuar",
                        "discard": "Descartar",
                        "use-in-this-offer": "Usar Killer Questions para esta oferta",
                        "maximum-5-offers": "¡Máximo 5 preguntas!",
                        "predefined-modal": {
                            "title": "Seleccionar pregunta predefinida",
                            "message": "Seleccione una pregunta de la lista a continuación y haga clic en Seleccione para usar la pregunta"
                        }
                    }
                },
                "third-page": {
                    "tax-data": {
                        "title": "Datos fiscales",
                        "tax-id": "Identificación fiscal (CIF o NIF)",
                        "business-name": "Razón social"
                    },
                    "billing-information": {
                        "title": "Datos de facturación",
                        "address": "Dirección",
                        "contact-person": "Persona de contacto",
                        "email": "Email"
                    },
                    "discount-code": {
                        "title": "Código de activación",
                        "success": "¡Felicidades! ¡Tienes <strong>{discount} €</strong> de descuento!",
                        "placeholder": "Ingrese el código",
                        "invalid": "¡EL CÓDIGO PROMOCIONAL NO ES VÁLIDO!",
                        "apply": "APLICAR CÓDIGO",
                        "caption": "Puedes utilizar 1 código de descuento por cada pedido"
                    },
                    "payment-method": {
                        "title": "Modo de pago",
                        "credit-card": "Tarjeta de crédito",
                        "credit-card.caption": "El pago se realizará de forma inmediata y el servicio se activará al instante.",
                        "free-first-offer": "Primera oferta gratis",
                        "free-first-offer.caption": "Bienvenido a {portal}. ¡Como regalo puedes publicar esta oferta gratis! Disfruta y buena suerte."
                    }
                }
            },
            "payments": {
                "total-label": "Total de Pedidos:",
                "table": {
                    "date": "Fecha",
                    "id_and_details": "Nº pedido y detalle de servicios",
                    "amount": "Importe",
                    "status": "Estado"
                },
                "no-payments": "Aún no hay pagos",
                "failed": "Pago fallido",
                "success": "Pago exitoso",
                "offer": "Oferta",
                "details": {
                    "offer-publish": "Publicación de Oferta"
                }
            },
            "admin": {
                "offers": {
                    "total-label": "Total de Ofertas:",
                    "filter-options": {
                        "order": {
                            "label": "Ordenar oferta",
                            "newest": "Por más nuevo",
                            "updated-at": "Por última actualización",
                            "alphabetically": "Orden alfabético",
                            "province": "Por provincia"
                        },
                        "filter": {
                            "label": "Filtrar ofertas",
                            "all-offers": "Todas las ofertas",
                            "archived": "Cerradas",
                            "active": "Abiertas",
                            "unpaid": "Borrador"
                        }
                    }
                },
                "companies": {
                    "total-label": "Total de Empresas:",
                    "no-companies": "Aún no hay empresas...",
                    "active": "Activas",
                    "pending": "Pendientes",
                    "rejected": "Rechazadas",
                    "verify-success": "¡Empresa verificada con éxito!",
                    "reject-success": "¡Empresa rechazada con éxito!"
                },
                "users": {
                    "total-label": "Total de Usuarios:",
                    "something-wrong": "¡Algo malo paso! Intente actualizar la página...",
                    "no-recover": "¡No podrás recuperarlo más tarde!",
                    "confirm-delegate": "¿Está seguro de que desea delegar el usuario seleccionado a esta oferta?",
                    "delegate-success": "¡Delegar una oferta para el usuario con éxito!",
                    "deleted-success": "Borrado exitosamente",
                    "no-users": "No se encontraron usuarios...",
                    "filter-options": {
                        "order": {
                            "label": "Ordenar por...",
                            "newest": "Más reciente",
                            "name": "Por nombre",
                            "email": "Por correo electrónico"
                        },
                        "filter": {
                            "label": "Filtrar usuarios",
                            "all-users": "Todos los usuarios",
                            "companies": "Sólo empresas",
                            "candidates": "Sólo candidatos",
                            "hrs": "Sólo headhunters",
                            "withcv": "Candidatos con CV"
                        }
                    },
                    "only-active": "Sólo activos"
                },
                "promos": {
                    "total-label": "Total de Códigos de activación:",
                    "create-new-promo": "Agrega un nuevo código de activación",
                    "promo-code-added": "¡Código promocional agregado!",
                    "promo-code-deleted": "¡Código promocional eliminado!",
                    "form": {
                        "code": "Nombre del código",
                        "code.placeholder": "Ingresa código de promoción...",
                        "type": "Tipo de código",
                        "discount": "Descuento",
                        "discount.caption": "Indica el descuento de la siguiente manera:",
                        "discount.caption1": "- En (€) para publicar ofertas",
                        "discount.caption2": "-  En número para indicar la cantidad de ofertas a copiar en otras provincias",
                        "limit": " Límite de uso",
                        "user": "Para el usuario",
                        "user.placeholder": "Selecciona un usuario"
                    },
                    "table": {
                        "discount": "Descuento",
                        "used-times": "Número de usos",
                        "created-at": "Fecha de Creación",
                        "updated-at": "Última actualización",
                        "for": "Asignado",
                        "actions": "Acciones"
                    },
                    "existing-promos": "Mis códigos de activación"
                },
                "referrals": {
                    "total-label": "Total de Referencias:",
                    "referral": {
                        "title": "Actualizar Referencia",
                        "enable": "Activar",
                        "disable": "Deshabilitar",
                        "enabled": "Activa",
                        "disabled": "Deshabilitada",
                        "link": "Enlace",
                        "created-at": "Creado",
                        "updated-at": "Actualizado",
                        "counter": "Contador",
                        "referred-users": "Usuarios referidos",
                        "no-users-referred": "No hay usuarios referidos"
                    },
                    "add-new-referral": {
                        "title": "Agregar nuevo enlace de referencia",
                        "name.placeholder": "Ingresa una descripción",
                        "disabled": "Deshabilitar",
                        "success": "¡Referencia creada!",
                        "validation": "Título debe tener al menos {minLength} caracteres de longitud"
                    },
                    "disable-success": "Referencia deshabilitada",
                    "enable-success": "Referencia habilitada",
                    "filter-options": {
                        "order": {
                            "newest": "Ordenar por más nuevo",
                            "last-updated": "Última actualización",
                            "counter": "Por contador"
                        },
                        "filter": {
                            "all": "Todas las referencias",
                            "only-enabled": "Sólo activas",
                            "only-disabled": "Deshabilitadas"
                        }
                    },
                    "list": {
                        "title": "Referencias",
                        "no-referrals": "Aún no hay referencias"
                    }
                },
                "headhunters": {
                    "title": "Administrar Headhunters",
                    "assign-companies": "Asigna empresas a Headhunters",
                    "select-companies": "Asignar",
                    "select-all": "Seleccionar todas",
                    "select-companies-title": "Asignar empresas",
                    "select-companies.mark-explain": "Marca la casilla para Asignar",
                    "select-companies.unmark-explain": "Desmarca la casilla para Desvincular",
                    "no-companies": "No hay empresas asignadas todavía...",
                    "companies-update-success": "Headhunter empresas actualizadas con éxito",
                    "create-new": {
                        "title": "Ingresa los datos del nuevo Headhunter",
                        "name": "Nombre",
                        "last-name": "Apellido",
                        "place": "Lugar",
                        "city": "Ciudad",
                        "phone": "Teléfono",
                        "email": "Email",
                        "password": "Contraseña",
                        "password-confirm": "Confirma la contraseña",
                        "button": "Crear"
                    }
                },
                "permissions": {
                    "permission": "Permiso",
                    "assign": "Asignar",
                    "assign.success": "Asignado exitosamente",
                    "unassign.success": "No asignado correctamente",
                    "no-permissions": "¡Sin permisos todavía!"
                },
                "one-company": {
                    "company-offers.title": "Ofertas de empresa",
                    "no-offers": "Aún no hay ofertas..."
                }
            },
            "delegations": {
                "title": "Delegaciones de candidatos y ofertas ({count})",
                "no-delegations": "Aún no hay delegaciones"
            },
            "hr": {
                "delegating-user-for-offer": "Estás delegando un candidato a esta oferta",
                "delegating-offer-for-user": "Estas delegando una oferta para este candidato.",
                "select-user": "Selecciona el usuario",
                "select-offer": "Selecciona el oferta"
            },
            "user-cv": {
                "fill-cv-pretext": "Para inscribirte a las ofertas de empleo es necesario completar la siguiente información:",
                "upload-cv": "SUBIR MI CV",
                "fill-employment-status": "MI SITUACIÓN LABORAL",
                "profile-complete-note": "¡Excelente! Tu CV está actualizado. Ahora puedes inscribirte en las ofertas de empleo",
                "search-for-offers": "Buscar Ofertas",
                "my-cv": "Perfil de {first} {last}",
                "multiselect": {
                    "press-enter-select": "Presiona enter para seleccionar",
                    "press-enter-remove": "Presiona enter para eliminar",
                    "press-enter-selected": "Seleccionado"
                },
                "personal-data": {
                    "title": "Mis datos personales"
                },
                "profile-update.success": "¡Perfil actualizado con éxito!",
                "profile-update.failure": "¡Todos los campos son obligatorios!",
                "employment": {
                    "title": "Situación laboral",
                    "edit-button": "Mi situación laboral",
                    "preferred-levels": "Niveles preferidos",
                    "my-experience": "Mi experiencia",
                    "preferred-categories": "Mis categorias preferidas",
                    "preferred-industries": "Mis industrias preferidas",
                    "preferred-contracts": "Mis contratos preferidos",
                    "modal": {
                        "title": "Añadir/editar mi situación laboral",
                        "experience": {
                            "title": "Niveles y experiencia",
                            "preference": "¿Qué perfil de trabajo te interesa?",
                            "current": "¿Cuánta experiencia tienes?"
                        },
                        "industries": {
                            "title": "Categorías e industrias",
                            "categories": "Categorías",
                            "industries": "Industrias"
                        },
                        "contracts": {
                            "title": "Contratos",
                            "contracts": "Contratos"
                        }
                    }
                },
                "languages": {
                    "title": "Idiomas",
                    "edit-button": "Mis idiomas",
                    "speaking": "Hablado",
                    "writing": "Escrito",
                    "reading": "Leído",
                    "comments": "Comentarios",
                    "modal": {
                        "title": "Añadir/editar mis idiomas",
                        "your-languages": "Idiomas",
                        "no-languages": "¡Aún no hay idiomas!"
                    }
                },
                "document": {
                    "title": "Documento",
                    "edit-button": "Subir mi CV",
                    "current-cv-document": "Tu CV actual",
                    "last-updated": "Última actualización en:",
                    "modal": {
                        "title": "Subir mi CV",
                        "update-document": "Actualizar documento",
                        "requirements": "*Max. 2MB, .doc, .docx o .pdf",
                        "select-file": "Selecciona un archivo",
                        "drop-file": "Suelta el archivo aquí ...",
                        "please-select-file": "Por favor seleccione un documento.",
                        "invalid-file": "El documento seleccionado no cumple con los requisitos."
                    }
                },
                "skills": {
                    "title": "Competencias",
                    "edit-button": "Mis competencias",
                    "my-skills": "Mis competencias",
                    "modal": {
                        "title": "Añadir/editar mis competencias",
                        "skills": "Competencias",
                        "skills.placeholder": "Escribe una compentencia",
                        "skills.tag-placeholder": "Presiona enter para crear una competencia",
                        "skills.no-options": "Escribe una competencia y presiona enter"
                    }
                },
                "text-cv": {
                    "title": "CV en texto",
                    "edit-button": "Mi CV en texto",
                    "modal": {
                        "title": "Actualizar mi CV en texto",
                        "text": "CV en texto",
                        "text.placeholder": "Escribe tu CV aquí"
                    }
                },
                "education": {
                    "title": "Educación",
                    "edit-button": "Mi educación",
                    "entry": "{title} en {name}",
                    "modal": {
                        "title": "Añadir/editar mi educación",
                        "education": "Datos de mi educación",
                        "no-educations": "¡Aún no hay educaciónes!",
                        "form": {
                            "title": "Título",
                            "specialty": "Nombre del curso / Especialidad",
                            "ongoing": "Cursando actualmente",
                            "start-date": "Fecha inicio",
                            "end-date": "Fecha fin",
                            "study-center": "Centro de estudios"
                        }
                    }
                },
                "experience": {
                    "title": "Experiencia",
                    "edit-button": "LUGARES EN DONDE HE TRABAJADO",
                    "entry": "{company} en {position}",
                    "modal": {
                        "title": "Añadir/editar lugares en donde he trabajado",
                        "experience": "Datos de la empresa",
                        "no-experience": "¡Aún no hay experiencia!",
                        "form": {
                            "company": "Empresa",
                            "sector": "Sector de la empresa",
                            "position": "Puesto",
                            "ongoing": "Trabajo aquí actualmente",
                            "start-date": "Fecha inicio",
                            "end-date": "Fecha fin",
                            "level": "Nivel",
                            "description": "Descripción del puesto",
                            "description.placeholder": "Escribe una breve descripción de las  funciones realizadas, conocimientos obtenidos y logros alcanzados. Las empresas usarán esta información para evaluar tu candidatura."
                        }
                    }
                },
                "my-recommendations": {
                    "title": "Me recomiendan",
                    "edit-button": "Me recomiendan",
                    "name": "Nombre",
                    "phone": "Teléfono",
                    "email": "Email",
                    "text": "Texto",
                    "modal": {
                        "title": "Añadir/editar Mis recomendaciones",
                        "your-recommendations": "Tus recomendaciones",
                        "no-recommendations": "¡Aún no hay recomendaciones!"
                    }
                },
                "sidebar": {
                    "please-complete-profile": "Por favor completa tu perfil.",
                    "completion": "Está al {perc} %",
                    "necessary": "Necesario",
                    "optional": "Opcional",
                    "profile-completed": "Perfil completado!",
                    "last-updated": "Fecha de la última actualización de tu CV",
                    "find-courses": "Encuentra cursos",
                    "internships": {
                        "title": "Prácticas en empresas",
                        "company-interns": {
                            "title": "Prácticas en empresas",
                            "subtitle": "Poseemos la llave a la empleabilidad profesional"
                        },
                        "vip-interns": {
                            "title": "Prácticas VIP",
                            "subtitle": "Publica multitud de ofertas encuentra becarios sin fronteras"
                        },
                        "find-interns": {
                            "title": "Contratar becarios",
                            "subtitle": "Convenios de prácticas en empresas"
                        },
                        "agency-interns": {
                            "title": "Agencia de prácticas",
                            "subtitle": "Los más capacitados a través de procesos de preselección"
                        },
                        "erasmus-interns": {
                            "title": "Erasmus prácticas",
                            "subtitle": "Coordinamos y gestionamos programas de movilidad y fondos europeos"
                        },
                        "alien-interns": {
                            "title": "Becarios extranjeros",
                            "subtitle": "Somos el enlace entre los estudiantes, las universidades y las empresas"
                        }
                    },
                    "partner-services": {
                        "title": "Servicios Socios"
                    }
                }
            },
            "not-found": {
                "title": "No hemos encontrado esta página",
                "subtitle": "Pero no te preocupes, tenemos miles de ofertas para ti.",
                "search-offers": "Buscar ofertas"
            },
            "company-page": {
                "title": "Ofertas de empresa",
                "view-offers": "Ver Ofertas",
                "company-description": "Descripción de la empresa",
                "total-offers": "{total} ofertas en {companyTitle}"
            },
            "one-candidate": {
                "status": "Estado: {status}",
                "accept": "ACEPTAR",
                "toInProcess": "Poner EN PROCESO",
                "reject": "RECHAZAR",
                "accepted": "ACEPTADO",
                "rejected": "RECHAZADO",
                "view-cv": "Ver CV",
                "modal.title": "¡Advertencia!",
                "no-document": "Sin documento CV...",
                "modal-accept": "¿Estás seguro que quieres <strong style=\"color: green\">ACEPTAR</strong> este candidato?",
                "modal-reject": "¿Estás seguro que quieres <strong style=\"color: red\">RECHAZAR</strong> este candidato?",
                "modal-inprocess": "¿Estás seguro que quieres cambiar el estado de este candidato a <strong style=\"color: green\">EN PROCESO</strong>?"
            },
            "intern-control": {
                "title": "Datas personales",
                "save": "Guardar",
                "update.success": "Pasante actualizado con éxito"
            },
            "verify-announcement": {
                "thank-you": "¡Gracias por registrarte! Ahora,verifica tu cuenta.",
                "system-use-caption": "Para utilizar la plataforma {portal}, debes verificar tu cuenta. Hemos enviado un correo electrónico a {email} con un enlace para verificar tu cuenta. Si no has recibido el correo electrónico después de unos minutos, por favor revisa la carpeta de spam."
            },
            "workwithus": {
                "title": "Forma parte de nuestro equipo",
                "subtitle-1": "¡Queremos contar contigo!",
                "subtitle-2": "Rellena el siguiente formulario y adjunta tu CV",
                "cv": "CV",
                "requirements": "*Max. 2MB, .pdf",
                "select-file": "Selecciona un archivo",
                "drop-file": "Suelta el archivo aquí ...",
                "please-select-file": "Por favor seleccione un documento.",
                "invalid-file": "El documento seleccionado no cumple con los requisitos."
            },
            "vip-services.recruitment": {
                "hero": {
                    "title": "Reclutamiento y selección a éxito",
                    "subtitle": "Te ayudamos a conseguir el candidato ideal y nos encargamos de todo el proceso.",
                    "form-title": "Encuentra el talento idóneo ahora",
                    "form-btn-send": "Solicita nuestro servicio"
                },
                "services": {
                    "title": "Nos encargamos de todo",
                    "card-1-title": "Publicación de oferta",
                    "card-2-title": "Criba de CVs",
                    "card-3-title": "Entrevistas a candidatos potenciales",
                    "card-4-title": "Redacción de informe del perfil idóneo",
                    "card-5-title": "Coordinación de entrevista final",
                    "card-6-title": "Evaluación y seguimiento por 3 meses"
                },
                "successfull-work": {
                    "title": "TRABAJAMOS A ÉXITO",
                    "subtitle": "PAGA SOLO SI CONTRATAS A UNO DE NUESTROS CANDIDATOS"
                },
                "contact-us": {
                    "title": "Contáctanos",
                    "card-1": {
                        "title": "Nosotros",
                        "info-1": "Somos expertos en reclutamiento y selección de personal",
                        "info-2": "24 años de experiencia formando personas y desarrollando organizaciones"
                    },
                    "card-2": {
                        "title": "Horario",
                        "info-1": "Lunes a jueves de 09:00 a 17:00 Horas",
                        "info-2": "Viernes de 09:00 a 15:00 Horas"
                    },
                    "card-3": {
                        "title": "Contacto",
                        "info-1": "Calle León y Castillo, 54, 1ª Planta, 35003 Las Palmas de Gran Canaria, Las Palmas, España",
                        "info-2": "Email: info@planetajob.es",
                        "info-3": "Telephone: +34928354668"
                    }
                },
                "bottom-form": {
                    "btn-send": "Solicita nuestro servicio"
                },
                "form-success-1": "¡Su consulta ha sido enviada con éxito!",
                "form-success-2": "Nuestro equipo se pondrá en contacto contigo a la brevedad."
            },
            "killer-questions-templates": {
                "main": {
                    "title": "Plantillas de Killer Questions",
                    "existing-questions": "Estructura de preguntas existente",
                    "view-questions": "Ver las preguntas de las carpeta",
                    "selected-question": "Pregunta seleccionada",
                    "must-create-root": "Para crear tus plantillas primero crea un directorio."
                },
                "actions": {
                    "title": "Acciones",
                    "new-question-title": "Nueva Killer Question",
                    "new-question-desc": "Crea una pregunta y guárdala para utilizarla en diferentes ofertas.",
                    "new-folder-title": "Nueva carpeta",
                    "new-folder-desc": "Organiza tus preguntas en carpetas para poder localizarlas fácilmente.",
                    "edit-question-title": "Gestionar Killer Questions",
                    "edit-question-desc": "Modifica o borra las preguntas que ya has creado anteriormente.",
                    "edit-folder-title": "Gestionar carpetas",
                    "edit-folder-desc": "Modifica o borra las carpetas que ya has creado anteriormente."
                },
                "add-question": {
                    "title": "Nueva Killer Question",
                    "subtitle": "Elige una de tus plantillas de Killer Questions. Podrás modificar a tu medida la pregunta seleccionada.",
                    "rule-1": "Define de 2 a 5 respuestas diferentes por pregunta.",
                    "rule-2": "Puntúa cada respuesta del 0 al 10, para ordenar los candidatos por puntuación.",
                    "rule-3": "Decide si una respuesta concreta excluye al candidato. Los candidatos que seleccionen esas respuesta serán clasificados como \"No se ajustan\".",
                    "save-in-folder": "Guardar en una carpeta",
                    "save-in-folder-subtitle": "Selecciona la ubicación de la nueva plantilla de Killer Question:",
                    "must-select-folder": "Debes seleccionar una carpeta!",
                    "view-questions": "Ver las preguntas de las carpeta",
                    "select-save-folder": "Debe seleccionar guardar carpeta"
                },
                "add-folder": {
                    "title": "Nueva carpeta",
                    "subtitle": "Para crear una nueva carpeta en la que organizar tus Killer Questions, deberás ponerle un nombre y seleccionar en donde guardarla.",
                    "folder-name": "Nombre de la carpeta:",
                    "save-folder-in": "Guardar carpeta en:",
                    "must-select-folder": "Debes seleccionar una carpeta!",
                    "failure": "¡Todos los campos son obligatorios!"
                },
                "manage-question": {
                    "title": "Gestionar Killer Question",
                    "subtitle": "Elige una de plantillas de Killer Questions. Podrás modificar a tu medida la pregunta seleccionada.",
                    "must-select-folder": "Debes seleccionar una carpeta!",
                    "rule-1": "Define de 2 a 5 respuestas diferentes por pregunta.",
                    "rule-2": "Puntúa cada respuesta del 0 al 10, para ordenar los candidatos por puntuación.",
                    "rule-3": "Decide si una respuesta concreta excluye al candidato. Los candidatos que seleccionen esas respuesta serán clasificados como \"No se ajustan\".",
                    "save-in-folder": "Guardar en una carpeta",
                    "save-in-folder-subtitle": "Selecciona la ubicación de la nueva plantilla de Killer Question:",
                    "view-questions": "Ver las preguntas de las carpeta",
                    "select-question": "Debe seleccionar una pregunta",
                    "you-sure-delete": "¿Está seguro de que desea eliminar la pregunta seleccionada?"
                },
                "manage-folder": {
                    "title": "Gestionar Carpetas",
                    "must-select-folder": "Debes seleccionar una carpeta!",
                    "select-folder": "Selecciona la carpeta que quieres modificar",
                    "edit-folder-name": "Modificar el nombre de tu carpeta",
                    "folder-name": "Nombre de la carpeta:",
                    "folder-location": "Modificar la ubicación de tu carpeta",
                    "failure": "¡Todos los campos son obligatorios!",
                    "cannot-move": "¡No se puede mover la carpeta principal!",
                    "cannot-delete": "¡No se puede eliminar la carpeta principal!",
                    "delete-modal": {
                        "selected": "Has seleccionado ",
                        "folders": " carpetas",
                        "you-sure": "¿Estás seguro?",
                        "you-sure-delete": "¿Seguro deseas eliminar?"
                    }
                }
            }
        }
    }
}
